(function () {

function $454384510905b1a7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $454384510905b1a7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.6.0
 * https://greensock.com
 *
 * @license Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $454384510905b1a7$export$4922bee768729a77 = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, $454384510905b1a7$var$_defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, $454384510905b1a7$var$_suppressOverwrites, $454384510905b1a7$var$_bigNum = 1e8, $454384510905b1a7$var$_tinyNum = 1 / $454384510905b1a7$var$_bigNum, $454384510905b1a7$var$_2PI = Math.PI * 2, $454384510905b1a7$var$_HALF_PI = $454384510905b1a7$var$_2PI / 4, $454384510905b1a7$var$_gsID = 0, $454384510905b1a7$var$_sqrt = Math.sqrt, $454384510905b1a7$var$_cos = Math.cos, $454384510905b1a7$var$_sin = Math.sin, $454384510905b1a7$export$f664476fd67145ca = function _isString(value) {
    return typeof value === "string";
}, $454384510905b1a7$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $454384510905b1a7$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $454384510905b1a7$export$a8178c063a9fd3a1 = function _isUndefined(value) {
    return typeof value === "undefined";
}, $454384510905b1a7$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $454384510905b1a7$var$_isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, $454384510905b1a7$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $454384510905b1a7$var$_isFuncOrString = function _isFuncOrString(value) {
    return $454384510905b1a7$var$_isFunction(value) || $454384510905b1a7$export$f664476fd67145ca(value);
}, $454384510905b1a7$var$_isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
$454384510905b1a7$var$_isArray = Array.isArray, $454384510905b1a7$var$_strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
$454384510905b1a7$export$b9d44bb6523120d6 = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$454384510905b1a7$export$65c88bbd597e7b0a = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, $454384510905b1a7$var$_complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
$454384510905b1a7$export$5a680e28b0b61bc = /[+-]=-?[.\d]+/, $454384510905b1a7$var$_delimitedValueExp = /[#\-+.]*\b[a-z\d-=+%.]+/gi, $454384510905b1a7$var$_unitExp = /[\d.+\-=]+(?:e[-+]\d*)*/i, $454384510905b1a7$var$_globalTimeline, $454384510905b1a7$var$_win, $454384510905b1a7$var$_coreInitted, $454384510905b1a7$var$_doc, $454384510905b1a7$var$_globals = {}, $454384510905b1a7$var$_installScope = {}, $454384510905b1a7$var$_coreReady, $454384510905b1a7$var$_install = function _install(scope) {
    return ($454384510905b1a7$var$_installScope = $454384510905b1a7$var$_merge(scope, $454384510905b1a7$var$_globals)) && $454384510905b1a7$export$99ee26438460406a;
}, $454384510905b1a7$export$7fb54635790b59a5 = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, $454384510905b1a7$var$_warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, $454384510905b1a7$var$_addGlobal = function _addGlobal(name, obj) {
    return name && ($454384510905b1a7$var$_globals[name] = obj) && $454384510905b1a7$var$_installScope && ($454384510905b1a7$var$_installScope[name] = obj) || $454384510905b1a7$var$_globals;
}, $454384510905b1a7$var$_emptyFunc = function _emptyFunc() {
    return 0;
}, $454384510905b1a7$var$_reservedProps = {}, $454384510905b1a7$var$_lazyTweens = [], $454384510905b1a7$var$_lazyLookup = {}, $454384510905b1a7$var$_lastRenderedFrame, $454384510905b1a7$export$d305d8ec5d7c26b8 = {}, $454384510905b1a7$var$_effects = {}, $454384510905b1a7$var$_nextGCFrame = 30, $454384510905b1a7$var$_harnessPlugins = [], $454384510905b1a7$var$_callbackNames = "", $454384510905b1a7$var$_harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    $454384510905b1a7$var$_isObject(target) || $454384510905b1a7$var$_isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = $454384510905b1a7$var$_harnessPlugins.length;
        while(i-- && !$454384510905b1a7$var$_harnessPlugins[i].targetTest(target));
        harnessPlugin = $454384510905b1a7$var$_harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new $454384510905b1a7$export$cf10981d5419cad5(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, $454384510905b1a7$export$8b9be379d2de2a39 = function _getCache(target) {
    return target._gsap || $454384510905b1a7$var$_harness($454384510905b1a7$export$45b10814cc054894(target))[0]._gsap;
}, $454384510905b1a7$export$51d6bbe898aef1f9 = function _getProperty(target, property, v) {
    return (v = target[property]) && $454384510905b1a7$var$_isFunction(v) ? target[property]() : $454384510905b1a7$export$a8178c063a9fd3a1(v) && target.getAttribute && target.getAttribute(property) || v;
}, $454384510905b1a7$export$f9000b814859f126 = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
$454384510905b1a7$export$9c8d725d65e13f94 = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $454384510905b1a7$var$_arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, $454384510905b1a7$var$_parseVars = function _parseVars(params, type, parent) {
    //reads the arguments passed to one of the key methods and figures out if the user is defining things with the OLD/legacy syntax where the duration is the 2nd parameter, and then it adjusts things accordingly and spits back the corrected vars object (with the duration added if necessary, as well as runBackwards or startAt or immediateRender). type 0 = to()/staggerTo(), 1 = from()/staggerFrom(), 2 = fromTo()/staggerFromTo()
    var isLegacy = $454384510905b1a7$var$_isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars;
    isLegacy && (vars.duration = params[1]);
    vars.parent = parent;
    if (type) {
        irVars = vars;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = $454384510905b1a7$var$_isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = $454384510905b1a7$var$_isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return vars;
}, $454384510905b1a7$var$_lazyRender = function _lazyRender() {
    var l = $454384510905b1a7$var$_lazyTweens.length, a = $454384510905b1a7$var$_lazyTweens.slice(0), i, tween;
    $454384510905b1a7$var$_lazyLookup = {};
    $454384510905b1a7$var$_lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, $454384510905b1a7$var$_lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    $454384510905b1a7$var$_lazyTweens.length && $454384510905b1a7$var$_lazyRender();
    animation.render(time, suppressEvents, force);
    $454384510905b1a7$var$_lazyTweens.length && $454384510905b1a7$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, $454384510905b1a7$var$_numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match($454384510905b1a7$var$_delimitedValueExp).length < 2 ? n : $454384510905b1a7$export$f664476fd67145ca(value) ? value.trim() : value;
}, $454384510905b1a7$var$_passThrough = function _passThrough(p) {
    return p;
}, $454384510905b1a7$export$dc2b19673bb53610 = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $454384510905b1a7$var$_setKeyframeDefaults = function _setKeyframeDefaults(obj, defaults) {
    for(var p in defaults)p in obj || p === "duration" || p === "ease" || (obj[p] = defaults[p]);
}, $454384510905b1a7$var$_merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, $454384510905b1a7$var$_mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = $454384510905b1a7$var$_isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, $454384510905b1a7$var$_copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, $454384510905b1a7$var$_inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || $454384510905b1a7$var$_globalTimeline, func = vars.keyframes ? $454384510905b1a7$var$_setKeyframeDefaults : $454384510905b1a7$export$dc2b19673bb53610;
    if ($454384510905b1a7$var$_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, $454384510905b1a7$var$_arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, $454384510905b1a7$var$_addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, $454384510905b1a7$export$cd008aa6cd8844e3 = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, $454384510905b1a7$var$_removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove(child);
    child._act = 0;
}, $454384510905b1a7$var$_uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, $454384510905b1a7$var$_recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, $454384510905b1a7$var$_hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, $454384510905b1a7$var$_elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? $454384510905b1a7$var$_animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
$454384510905b1a7$var$_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, $454384510905b1a7$var$_parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, $454384510905b1a7$var$_setEnd = function _setEnd(animation) {
    return animation._end = $454384510905b1a7$export$9c8d725d65e13f94(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || $454384510905b1a7$var$_tinyNum) || 0));
}, $454384510905b1a7$var$_alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = $454384510905b1a7$export$9c8d725d65e13f94(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        $454384510905b1a7$var$_setEnd(animation);
        parent._dirty || $454384510905b1a7$var$_uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ $454384510905b1a7$var$_postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || child._initted && !child._dur) {
        //in case, for example, the _start is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
        t = $454384510905b1a7$var$_parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || $454384510905b1a7$var$_clamp(0, child.totalDuration(), t) - child._tTime > $454384510905b1a7$var$_tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if ($454384510905b1a7$var$_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -$454384510905b1a7$var$_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, $454384510905b1a7$var$_addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && $454384510905b1a7$var$_removeFromParent(child);
    child._start = $454384510905b1a7$export$9c8d725d65e13f94(position + child._delay);
    child._end = $454384510905b1a7$export$9c8d725d65e13f94(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    $454384510905b1a7$var$_addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    timeline._recent = child;
    skipChecks || $454384510905b1a7$var$_postAddChecks(timeline, child);
    return timeline;
}, $454384510905b1a7$var$_scrollTrigger = function _scrollTrigger(animation, trigger) {
    return ($454384510905b1a7$var$_globals.ScrollTrigger || $454384510905b1a7$export$7fb54635790b59a5("scrollTrigger", trigger)) && $454384510905b1a7$var$_globals.ScrollTrigger.create(trigger, animation);
}, $454384510905b1a7$var$_attemptInitTween = function _attemptInitTween(tween, totalTime, force, suppressEvents) {
    $454384510905b1a7$var$_initTween(tween, totalTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && $454384510905b1a7$var$_lastRenderedFrame !== $454384510905b1a7$export$762ed8fbedb691e3.frame) {
        $454384510905b1a7$var$_lazyTweens.push(tween);
        tween._lazy = [
            totalTime,
            suppressEvents
        ];
        return 1;
    }
}, $454384510905b1a7$var$_parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
$454384510905b1a7$var$_renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && $454384510905b1a7$var$_parentPlayheadIsBeforeStart(tween) || (tween._ts < 0 || tween._dp._ts < 0) && tween.data !== "isFromStart" && tween.data !== "isStart") ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = $454384510905b1a7$var$_clamp(0, tween._tDur, totalTime);
        iteration = $454384510905b1a7$var$_animationCycle(tTime, repeatDelay);
        prevIteration = $454384510905b1a7$var$_animationCycle(tween._tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== prevIteration) {
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || force || tween._zTime === $454384510905b1a7$var$_tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && $454384510905b1a7$var$_attemptInitTween(tween, totalTime, force, suppressEvents)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? $454384510905b1a7$var$_tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        suppressEvents || $454384510905b1a7$var$_callback(tween, "onStart");
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        tween._startAt && totalTime < 0 && tween._startAt.render(totalTime, true, true);
        tween._onUpdate && !suppressEvents && $454384510905b1a7$var$_callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && $454384510905b1a7$var$_callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && $454384510905b1a7$var$_removeFromParent(tween, 1);
            if (!suppressEvents) {
                $454384510905b1a7$var$_callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, $454384510905b1a7$var$_findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (!child._dur && child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (!child._dur && child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, $454384510905b1a7$var$_setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = $454384510905b1a7$export$9c8d725d65e13f94(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : $454384510905b1a7$export$9c8d725d65e13f94(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress && !leavePlayhead ? $454384510905b1a7$var$_alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress) : animation.parent && $454384510905b1a7$var$_setEnd(animation);
    skipUncache || $454384510905b1a7$var$_uncache(animation.parent, animation);
    return animation;
}, $454384510905b1a7$var$_onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof $454384510905b1a7$export$e6a97ba2cae5bb94 ? $454384510905b1a7$var$_uncache(animation) : $454384510905b1a7$var$_setDuration(animation, animation._dur);
}, $454384510905b1a7$var$_zeroPosition = {
    _start: 0,
    endTime: $454384510905b1a7$var$_emptyFunc
}, $454384510905b1a7$var$_parsePosition = function _parsePosition(animation, position) {
    var labels = animation.labels, recent = animation._recent || $454384510905b1a7$var$_zeroPosition, clippedDuration = animation.duration() >= $454384510905b1a7$var$_bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset;
    if ($454384510905b1a7$export$f664476fd67145ca(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        i = position.charAt(0);
        if (i === "<" || i === ">") return (i === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0);
        i = position.indexOf("=");
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = +(position.charAt(i - 1) + position.substr(i + 1));
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1)) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, $454384510905b1a7$var$_conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, $454384510905b1a7$var$_clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, $454384510905b1a7$export$65f2564e9a9b9222 = function getUnit(value) {
    if (typeof value !== "string") return "";
    var v = $454384510905b1a7$var$_unitExp.exec(value);
    return v ? value.substr(v.index + v[0].length) : "";
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
$454384510905b1a7$export$7d15b64cf5a3a4c4 = function clamp(min, max, value) {
    return $454384510905b1a7$var$_conditionalReturn(value, function(v) {
        return $454384510905b1a7$var$_clamp(min, max, v);
    });
}, $454384510905b1a7$var$_slice = [].slice, $454384510905b1a7$var$_isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && $454384510905b1a7$var$_isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && $454384510905b1a7$var$_isObject(value[0])) && !value.nodeType && value !== $454384510905b1a7$var$_win;
}, $454384510905b1a7$var$_flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return $454384510905b1a7$export$f664476fd67145ca(value) && !leaveStrings || $454384510905b1a7$var$_isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, $454384510905b1a7$export$45b10814cc054894(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
$454384510905b1a7$export$45b10814cc054894 = function toArray(value, leaveStrings) {
    return $454384510905b1a7$export$f664476fd67145ca(value) && !leaveStrings && ($454384510905b1a7$var$_coreInitted || !$454384510905b1a7$var$_wake()) ? $454384510905b1a7$var$_slice.call($454384510905b1a7$var$_doc.querySelectorAll(value), 0) : $454384510905b1a7$var$_isArray(value) ? $454384510905b1a7$var$_flatten(value, leaveStrings) : $454384510905b1a7$var$_isArrayLike(value) ? $454384510905b1a7$var$_slice.call(value, 0) : value ? [
        value
    ] : [];
}, $454384510905b1a7$export$448332262467e042 = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
$454384510905b1a7$export$f02a9ddbe4480f19 = function distribute(v) {
    if ($454384510905b1a7$var$_isFunction(v)) return v;
    var vars = $454384510905b1a7$var$_isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = $454384510905b1a7$var$_parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if ($454384510905b1a7$export$f664476fd67145ca(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                $454384510905b1a7$var$_bigNum
            ])[1];
            if (!wrapAt) {
                max = -$454384510905b1a7$var$_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = $454384510905b1a7$var$_bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? $454384510905b1a7$var$_sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && $454384510905b1a7$export$448332262467e042(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = $454384510905b1a7$export$65f2564e9a9b9222(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? $454384510905b1a7$var$_invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return $454384510905b1a7$export$9c8d725d65e13f94(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, $454384510905b1a7$export$dd12390e6b265a17 = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = v < 1 ? Math.pow(10, (v + "").length - 2) : 1; //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed()
    return function(raw) {
        var n = Math.round(parseFloat(raw) / v) * v * p;
        return (n - n % 1) / p + ($454384510905b1a7$var$_isNumber(raw) ? 0 : $454384510905b1a7$export$65f2564e9a9b9222(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, $454384510905b1a7$export$51a0620f7a28532b = function snap(snapTo, value) {
    var isArray = $454384510905b1a7$var$_isArray(snapTo), radius, is2D;
    if (!isArray && $454384510905b1a7$var$_isObject(snapTo)) {
        radius = isArray = snapTo.radius || $454384510905b1a7$var$_bigNum;
        if (snapTo.values) {
            snapTo = $454384510905b1a7$export$45b10814cc054894(snapTo.values);
            if (is2D = !$454384510905b1a7$var$_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = $454384510905b1a7$export$dd12390e6b265a17(snapTo.increment);
    }
    return $454384510905b1a7$var$_conditionalReturn(value, !isArray ? $454384510905b1a7$export$dd12390e6b265a17(snapTo) : $454384510905b1a7$var$_isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = $454384510905b1a7$var$_bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || $454384510905b1a7$var$_isNumber(raw) ? closest : closest + $454384510905b1a7$export$65f2564e9a9b9222(raw);
    });
}, $454384510905b1a7$export$4385e60b38654f68 = function random(min, max, roundingIncrement, returnFunction) {
    return $454384510905b1a7$var$_conditionalReturn($454384510905b1a7$var$_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return $454384510905b1a7$var$_isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, $454384510905b1a7$export$a4627e546088548d = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, $454384510905b1a7$export$d7502930aa5492de = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || $454384510905b1a7$export$65f2564e9a9b9222(value));
    };
}, $454384510905b1a7$export$a3295358bff77e = function normalize(min, max, value) {
    return $454384510905b1a7$export$f65a7599bbc6b121(min, max, 0, 1, value);
}, $454384510905b1a7$var$_wrapArray = function _wrapArray(a, wrapper, value) {
    return $454384510905b1a7$var$_conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, $454384510905b1a7$export$4997ffc0176396a6 = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return $454384510905b1a7$var$_isArray(min) ? $454384510905b1a7$var$_wrapArray(min, wrap(0, min.length), max) : $454384510905b1a7$var$_conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, $454384510905b1a7$export$cfc0b067273edc55 = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return $454384510905b1a7$var$_isArray(min) ? $454384510905b1a7$var$_wrapArray(min, wrapYoyo(0, min.length - 1), max) : $454384510905b1a7$var$_conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, $454384510905b1a7$export$d5962a97e3cde94d = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? $454384510905b1a7$var$_delimitedValueExp : $454384510905b1a7$var$_strictNumExp);
        s += value.substr(prev, i - prev) + $454384510905b1a7$export$4385e60b38654f68(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, $454384510905b1a7$export$f65a7599bbc6b121 = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return $454384510905b1a7$var$_conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, $454384510905b1a7$export$89e29e4ab65e70a9 = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = $454384510905b1a7$export$f664476fd67145ca(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if ($454384510905b1a7$var$_isArray(start) && !$454384510905b1a7$var$_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = $454384510905b1a7$var$_merge($454384510905b1a7$var$_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)$454384510905b1a7$var$_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return $454384510905b1a7$var$_renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return $454384510905b1a7$var$_conditionalReturn(progress, func);
}, $454384510905b1a7$var$_getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = $454384510905b1a7$var$_bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, $454384510905b1a7$var$_callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], params, scope;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && $454384510905b1a7$var$_lazyTweens.length && $454384510905b1a7$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    return params ? callback.apply(scope, params) : callback.call(scope);
}, $454384510905b1a7$var$_interrupt = function _interrupt(animation) {
    $454384510905b1a7$var$_removeFromParent(animation);
    animation.progress() < 1 && $454384510905b1a7$var$_callback(animation, "onInterrupt");
    return animation;
}, $454384510905b1a7$var$_quickTween, $454384510905b1a7$var$_createPlugin = function _createPlugin(config) {
    config = !config.name && config["default"] || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    var name = config.name, isFunc = $454384510905b1a7$var$_isFunction(config), Plugin = name && !isFunc && config.init ? function() {
        this._props = [];
    } : config, //in case someone passes in an object that's not a plugin, like CustomEase
    instanceDefaults = {
        init: $454384510905b1a7$var$_emptyFunc,
        render: $454384510905b1a7$var$_renderPropTweens,
        add: $454384510905b1a7$var$_addPropTween,
        kill: $454384510905b1a7$var$_killPropTweensOf,
        modifier: $454384510905b1a7$var$_addPluginModifier,
        rawVars: 0
    }, statics = {
        targetTest: 0,
        get: 0,
        getSetter: $454384510905b1a7$export$d60fbc1e0278aaf0,
        aliases: {},
        register: 0
    };
    $454384510905b1a7$var$_wake();
    if (config !== Plugin) {
        if ($454384510905b1a7$export$d305d8ec5d7c26b8[name]) return;
        $454384510905b1a7$export$dc2b19673bb53610(Plugin, $454384510905b1a7$export$dc2b19673bb53610($454384510905b1a7$var$_copyExcluding(config, instanceDefaults), statics)); //static methods
        $454384510905b1a7$var$_merge(Plugin.prototype, $454384510905b1a7$var$_merge(instanceDefaults, $454384510905b1a7$var$_copyExcluding(config, statics))); //instance methods
        $454384510905b1a7$export$d305d8ec5d7c26b8[Plugin.prop = name] = Plugin;
        if (config.targetTest) {
            $454384510905b1a7$var$_harnessPlugins.push(Plugin);
            $454384510905b1a7$var$_reservedProps[name] = 1;
        }
        name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
    }
    $454384510905b1a7$var$_addGlobal(name, Plugin);
    config.register && config.register($454384510905b1a7$export$99ee26438460406a, Plugin, $454384510905b1a7$export$3a67f7f44b1e838a);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ $454384510905b1a7$var$_255 = 255, $454384510905b1a7$var$_colorLookup = {
    aqua: [
        0,
        $454384510905b1a7$var$_255,
        $454384510905b1a7$var$_255
    ],
    lime: [
        0,
        $454384510905b1a7$var$_255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        $454384510905b1a7$var$_255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        $454384510905b1a7$var$_255,
        $454384510905b1a7$var$_255,
        $454384510905b1a7$var$_255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        $454384510905b1a7$var$_255,
        $454384510905b1a7$var$_255,
        0
    ],
    orange: [
        $454384510905b1a7$var$_255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        $454384510905b1a7$var$_255,
        0,
        0
    ],
    pink: [
        $454384510905b1a7$var$_255,
        192,
        203
    ],
    cyan: [
        0,
        $454384510905b1a7$var$_255,
        $454384510905b1a7$var$_255
    ],
    transparent: [
        $454384510905b1a7$var$_255,
        $454384510905b1a7$var$_255,
        $454384510905b1a7$var$_255,
        0
    ]
}, $454384510905b1a7$var$_hue = function _hue(h, m1, m2) {
    h = h < 0 ? h + 1 : h > 1 ? h - 1 : h;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * $454384510905b1a7$var$_255 + .5 | 0;
}, $454384510905b1a7$export$73d6f35be992df24 = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? $454384510905b1a7$var$_colorLookup.black : $454384510905b1a7$var$_isNumber(v) ? [
        v >> 16,
        v >> 8 & $454384510905b1a7$var$_255,
        v & $454384510905b1a7$var$_255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if ($454384510905b1a7$var$_colorLookup[v]) a = $454384510905b1a7$var$_colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & $454384510905b1a7$var$_255,
                    a & $454384510905b1a7$var$_255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & $454384510905b1a7$var$_255,
                v & $454384510905b1a7$var$_255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match($454384510905b1a7$var$_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = $454384510905b1a7$var$_hue(h + 1 / 3, r, g);
                a[1] = $454384510905b1a7$var$_hue(h, r, g);
                a[2] = $454384510905b1a7$var$_hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match($454384510905b1a7$export$b9d44bb6523120d6);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match($454384510905b1a7$var$_strictNumExp) || $454384510905b1a7$var$_colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / $454384510905b1a7$var$_255;
        g = a[1] / $454384510905b1a7$var$_255;
        b = a[2] / $454384510905b1a7$var$_255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, $454384510905b1a7$var$_colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split($454384510905b1a7$var$_colorExp).forEach(function(v) {
        var a = v.match($454384510905b1a7$export$65c88bbd597e7b0a) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, $454384510905b1a7$var$_formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match($454384510905b1a7$var$_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = $454384510905b1a7$export$73d6f35be992df24(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = $454384510905b1a7$var$_colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace($454384510905b1a7$var$_colorExp, "1").split($454384510905b1a7$export$65c88bbd597e7b0a);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split($454384510905b1a7$var$_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, $454384510905b1a7$var$_colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in $454384510905b1a7$var$_colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), $454384510905b1a7$var$_hslExp = /hsl[a]?\(/, $454384510905b1a7$export$7eb2e5eb5eeb96a4 = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    $454384510905b1a7$var$_colorExp.lastIndex = 0;
    if ($454384510905b1a7$var$_colorExp.test(combined)) {
        toHSL = $454384510905b1a7$var$_hslExp.test(combined);
        a[1] = $454384510905b1a7$var$_formatColors(a[1], toHSL);
        a[0] = $454384510905b1a7$var$_formatColors(a[0], toHSL, $454384510905b1a7$var$_colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ $454384510905b1a7$var$_tickerActive, $454384510905b1a7$export$762ed8fbedb691e3 = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if ($454384510905b1a7$var$_coreReady) {
                if (!$454384510905b1a7$var$_coreInitted && $454384510905b1a7$var$_windowExists()) {
                    $454384510905b1a7$var$_win = $454384510905b1a7$var$_coreInitted = window;
                    $454384510905b1a7$var$_doc = $454384510905b1a7$var$_win.document || {};
                    $454384510905b1a7$var$_globals.gsap = $454384510905b1a7$export$99ee26438460406a;
                    ($454384510905b1a7$var$_win.gsapVersions || ($454384510905b1a7$var$_win.gsapVersions = [])).push($454384510905b1a7$export$99ee26438460406a.version);
                    $454384510905b1a7$var$_install($454384510905b1a7$var$_installScope || $454384510905b1a7$var$_win.GreenSockGlobals || !$454384510905b1a7$var$_win.gsap && $454384510905b1a7$var$_win || {});
                    _raf = $454384510905b1a7$var$_win.requestAnimationFrame;
                }
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                $454384510905b1a7$var$_tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? $454384510905b1a7$var$_win.cancelAnimationFrame : clearTimeout)(_id);
            $454384510905b1a7$var$_tickerActive = 0;
            _req = $454384510905b1a7$var$_emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || 1 / $454384510905b1a7$var$_tinyNum; //zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback) {
            _listeners.indexOf(callback) < 0 && _listeners.push(callback);
            $454384510905b1a7$var$_wake();
        },
        remove: function remove(callback) {
            var i;
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), $454384510905b1a7$var$_wake = function _wake() {
    return !$454384510905b1a7$var$_tickerActive && $454384510905b1a7$export$762ed8fbedb691e3.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ $454384510905b1a7$var$_easeMap = {}, $454384510905b1a7$var$_customEaseExp = /^[\d.\-M][\d.\-,\s]/, $454384510905b1a7$var$_quotesExp = /["']/g, $454384510905b1a7$var$_parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace($454384510905b1a7$var$_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, $454384510905b1a7$var$_valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, $454384510905b1a7$var$_configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = $454384510905b1a7$var$_easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        $454384510905b1a7$var$_parseObjectInString(split[1])
    ] : $454384510905b1a7$var$_valueInParentheses(name).split(",").map($454384510905b1a7$var$_numericIfPossible)) : $454384510905b1a7$var$_easeMap._CE && $454384510905b1a7$var$_customEaseExp.test(name) ? $454384510905b1a7$var$_easeMap._CE("", name) : ease;
}, $454384510905b1a7$var$_invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
$454384510905b1a7$var$_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof $454384510905b1a7$export$e6a97ba2cae5bb94) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, $454384510905b1a7$var$_parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : ($454384510905b1a7$var$_isFunction(ease) ? ease : $454384510905b1a7$var$_easeMap[ease] || $454384510905b1a7$var$_configEaseFromString(ease)) || defaultEase;
}, $454384510905b1a7$var$_insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    $454384510905b1a7$export$f9000b814859f126(names, function(name) {
        $454384510905b1a7$var$_easeMap[name] = $454384510905b1a7$var$_globals[name] = ease;
        $454384510905b1a7$var$_easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)$454384510905b1a7$var$_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = $454384510905b1a7$var$_easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, $454384510905b1a7$var$_easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, $454384510905b1a7$var$_configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / $454384510905b1a7$var$_2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * $454384510905b1a7$var$_sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $454384510905b1a7$var$_easeInOutFromOut(easeOut);
    p2 = $454384510905b1a7$var$_2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, $454384510905b1a7$var$_configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $454384510905b1a7$var$_easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
$454384510905b1a7$export$f9000b814859f126("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    $454384510905b1a7$var$_insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
$454384510905b1a7$var$_easeMap.Linear.easeNone = $454384510905b1a7$var$_easeMap.none = $454384510905b1a7$var$_easeMap.Linear.easeIn;
$454384510905b1a7$var$_insertEase("Elastic", $454384510905b1a7$var$_configElastic("in"), $454384510905b1a7$var$_configElastic("out"), $454384510905b1a7$var$_configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    $454384510905b1a7$var$_insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
$454384510905b1a7$var$_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
$454384510905b1a7$var$_insertEase("Circ", function(p) {
    return -($454384510905b1a7$var$_sqrt(1 - p * p) - 1);
});
$454384510905b1a7$var$_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -$454384510905b1a7$var$_cos(p * $454384510905b1a7$var$_HALF_PI) + 1;
});
$454384510905b1a7$var$_insertEase("Back", $454384510905b1a7$var$_configBack("in"), $454384510905b1a7$var$_configBack("out"), $454384510905b1a7$var$_configBack());
$454384510905b1a7$var$_easeMap.SteppedEase = $454384510905b1a7$var$_easeMap.steps = $454384510905b1a7$var$_globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - $454384510905b1a7$var$_tinyNum;
        return function(p) {
            return ((p2 * $454384510905b1a7$var$_clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
$454384510905b1a7$var$_defaults.ease = $454384510905b1a7$var$_easeMap["quad.out"];
$454384510905b1a7$export$f9000b814859f126("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return $454384510905b1a7$var$_callbackNames += name + "," + name + "Params,";
});
var $454384510905b1a7$export$cf10981d5419cad5 = function GSCache(target, harness) {
    this.id = $454384510905b1a7$var$_gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : $454384510905b1a7$export$51d6bbe898aef1f9;
    this.set = harness ? harness.getSetter : $454384510905b1a7$export$d60fbc1e0278aaf0;
};
var $454384510905b1a7$export$c35d437ae5945fcd = /*#__PURE__*/ function() {
    function Animation(vars, time) {
        var parent = vars.parent || $454384510905b1a7$var$_globalTimeline;
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        $454384510905b1a7$var$_setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        $454384510905b1a7$var$_tickerActive || $454384510905b1a7$export$762ed8fbedb691e3.wake();
        parent && $454384510905b1a7$var$_addToTimeline(parent, this, time || time === 0 ? time : parent._time, 1);
        vars.reversed && this.reverse();
        vars.paused && this.paused(true);
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return $454384510905b1a7$var$_setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        $454384510905b1a7$var$_wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            $454384510905b1a7$var$_alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || $454384510905b1a7$var$_postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            $454384510905b1a7$var$_addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === $454384510905b1a7$var$_tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            $454384510905b1a7$var$_lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + $454384510905b1a7$var$_elapsedCycleDuration(this)) % this._dur || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + $454384510905b1a7$var$_elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? $454384510905b1a7$var$_animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value) {
        if (!arguments.length) return this._rts === -$454384510905b1a7$var$_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? $454384510905b1a7$var$_parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -$454384510905b1a7$var$_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        return $454384510905b1a7$var$_recacheAncestors(this.totalTime($454384510905b1a7$var$_clamp(-this._delay, this._tDur, tTime), true));
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                $454384510905b1a7$var$_wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && (this._tTime -= $454384510905b1a7$var$_tinyNum) && Math.abs(this._zTime) !== $454384510905b1a7$var$_tinyNum); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && $454384510905b1a7$var$_addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + ($454384510905b1a7$var$_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detatched parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : $454384510905b1a7$var$_parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (animation._ts || 1);
            animation = animation._dp;
        }
        return time;
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return $454384510905b1a7$var$_onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            this._rDelay = value;
            return $454384510905b1a7$var$_onUpdateTotalDuration(this);
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime($454384510905b1a7$var$_parsePosition(this, position), $454384510905b1a7$var$_isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, $454384510905b1a7$var$_isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -$454384510905b1a7$var$_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -$454384510905b1a7$var$_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - $454384510905b1a7$var$_tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = $454384510905b1a7$var$_isFunction(onFulfilled) ? onFulfilled : $454384510905b1a7$var$_passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                $454384510905b1a7$var$_isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        $454384510905b1a7$var$_interrupt(this);
    };
    return Animation;
}();
$454384510905b1a7$export$dc2b19673bb53610($454384510905b1a7$export$c35d437ae5945fcd.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -$454384510905b1a7$var$_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var $454384510905b1a7$export$e6a97ba2cae5bb94 = /*#__PURE__*/ function(_Animation) {
    $454384510905b1a7$var$_inheritsLoose(Timeline, _Animation);
    function Timeline(vars, time) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars, time) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = $454384510905b1a7$var$_isNotFalse(vars.sortChildren);
        _this.parent && $454384510905b1a7$var$_postAddChecks(_this.parent, $454384510905b1a7$var$_assertThisInitialized(_this));
        vars.scrollTrigger && $454384510905b1a7$var$_scrollTrigger($454384510905b1a7$var$_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        new $454384510905b1a7$export$208a41d6b4e37b97(targets, $454384510905b1a7$var$_parseVars(arguments, 0, this), $454384510905b1a7$var$_parsePosition(this, $454384510905b1a7$var$_isNumber(vars) ? arguments[3] : position));
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        new $454384510905b1a7$export$208a41d6b4e37b97(targets, $454384510905b1a7$var$_parseVars(arguments, 1, this), $454384510905b1a7$var$_parsePosition(this, $454384510905b1a7$var$_isNumber(vars) ? arguments[3] : position));
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        new $454384510905b1a7$export$208a41d6b4e37b97(targets, $454384510905b1a7$var$_parseVars(arguments, 2, this), $454384510905b1a7$var$_parsePosition(this, $454384510905b1a7$var$_isNumber(fromVars) ? arguments[4] : position));
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        $454384510905b1a7$var$_inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new $454384510905b1a7$export$208a41d6b4e37b97(targets, vars, $454384510905b1a7$var$_parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return $454384510905b1a7$var$_addToTimeline(this, $454384510905b1a7$export$208a41d6b4e37b97.delayedCall(0, callback, params), $454384510905b1a7$var$_parsePosition(this, position));
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new $454384510905b1a7$export$208a41d6b4e37b97(targets, vars, $454384510905b1a7$var$_parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        $454384510905b1a7$var$_inheritDefaults(vars).immediateRender = $454384510905b1a7$var$_isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        $454384510905b1a7$var$_inheritDefaults(toVars).immediateRender = $454384510905b1a7$var$_isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = this !== $454384510905b1a7$var$_globalTimeline && totalTime > tDur - $454384510905b1a7$var$_tinyNum && totalTime >= 0 ? tDur : totalTime < $454384510905b1a7$var$_tinyNum ? 0 : totalTime, crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $454384510905b1a7$export$9c8d725d65e13f94(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = $454384510905b1a7$var$_animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://greensock.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : dur;
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : $454384510905b1a7$export$9c8d725d65e13f94(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    !suppressEvents && this.parent && $454384510905b1a7$var$_callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime !== this._time || prevPaused !== !this._ts) return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    $454384510905b1a7$var$_propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = $454384510905b1a7$var$_findNextPauseTween(this, $454384510905b1a7$export$9c8d725d65e13f94(prevTime), $454384510905b1a7$export$9c8d725d65e13f94(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            !prevTime && (time || !dur && totalTime >= 0) && !suppressEvents && $454384510905b1a7$var$_callback(this, "onStart");
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -$454384510905b1a7$var$_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -$454384510905b1a7$var$_tinyNum : $454384510905b1a7$var$_tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -$454384510905b1a7$var$_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    $454384510905b1a7$var$_setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && $454384510905b1a7$var$_callback(this, "onUpdate", true);
            if (tTime === tDur && tDur >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && $454384510905b1a7$var$_removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime)) {
                            $454384510905b1a7$var$_callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        $454384510905b1a7$var$_isNumber(position) || (position = $454384510905b1a7$var$_parsePosition(this, position));
        if (!(child instanceof $454384510905b1a7$export$c35d437ae5945fcd)) {
            if ($454384510905b1a7$var$_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if ($454384510905b1a7$export$f664476fd67145ca(child)) return this.addLabel(child, position);
            if ($454384510905b1a7$var$_isFunction(child)) child = $454384510905b1a7$export$208a41d6b4e37b97.delayedCall(0, child);
            else return this;
        }
        return this !== child ? $454384510905b1a7$var$_addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -$454384510905b1a7$var$_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof $454384510905b1a7$export$208a41d6b4e37b97) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if ($454384510905b1a7$export$f664476fd67145ca(child)) return this.removeLabel(child);
        if ($454384510905b1a7$var$_isFunction(child)) return this.killTweensOf(child);
        $454384510905b1a7$export$cd008aa6cd8844e3(this, child);
        if (child === this._recent) this._recent = this._last;
        return $454384510905b1a7$var$_uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = $454384510905b1a7$export$9c8d725d65e13f94($454384510905b1a7$export$762ed8fbedb691e3.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = $454384510905b1a7$var$_parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = $454384510905b1a7$export$208a41d6b4e37b97.delayedCall(0, callback || $454384510905b1a7$var$_emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return $454384510905b1a7$var$_addToTimeline(this, t, $454384510905b1a7$var$_parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = $454384510905b1a7$var$_parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") $454384510905b1a7$var$_removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)$454384510905b1a7$var$_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = $454384510905b1a7$export$45b10814cc054894(targets), child = this._first, isGlobalTime = $454384510905b1a7$var$_isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof $454384510905b1a7$export$208a41d6b4e37b97) {
                if ($454384510905b1a7$var$_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!$454384510905b1a7$var$_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = $454384510905b1a7$var$_parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, tween = $454384510905b1a7$export$208a41d6b4e37b97.to(tl, $454384510905b1a7$export$dc2b19673bb53610({
            ease: "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || $454384510905b1a7$var$_tinyNum,
            onStart: function onStart() {
                tl.pause();
                var duration = vars.duration || Math.abs((endTime - tl._time) / tl.timeScale());
                tween._dur !== duration && $454384510905b1a7$var$_setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, $454384510905b1a7$export$dc2b19673bb53610({
            startAt: {
                time: $454384510905b1a7$var$_parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return $454384510905b1a7$var$_getLabelInDirection(this, $454384510905b1a7$var$_parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return $454384510905b1a7$var$_getLabelInDirection(this, $454384510905b1a7$var$_parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + $454384510905b1a7$var$_tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return $454384510905b1a7$var$_uncache(this);
    };
    _proto2.invalidate = function invalidate() {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate();
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return $454384510905b1a7$var$_uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = $454384510905b1a7$var$_bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    $454384510905b1a7$var$_addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            $454384510905b1a7$var$_setDuration(self, self === $454384510905b1a7$var$_globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if ($454384510905b1a7$var$_globalTimeline._ts) {
            $454384510905b1a7$var$_lazySafeRender($454384510905b1a7$var$_globalTimeline, $454384510905b1a7$var$_parentToChildTotalTime(time, $454384510905b1a7$var$_globalTimeline));
            $454384510905b1a7$var$_lastRenderedFrame = $454384510905b1a7$export$762ed8fbedb691e3.frame;
        }
        if ($454384510905b1a7$export$762ed8fbedb691e3.frame >= $454384510905b1a7$var$_nextGCFrame) {
            $454384510905b1a7$var$_nextGCFrame += $454384510905b1a7$export$4922bee768729a77.autoSleep || 120;
            var child = $454384510905b1a7$var$_globalTimeline._first;
            if (!child || !child._ts) {
                if ($454384510905b1a7$export$4922bee768729a77.autoSleep && $454384510905b1a7$export$762ed8fbedb691e3._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || $454384510905b1a7$export$762ed8fbedb691e3.sleep();
                }
            }
        }
    };
    return Timeline;
}($454384510905b1a7$export$c35d437ae5945fcd);
$454384510905b1a7$export$dc2b19673bb53610($454384510905b1a7$export$e6a97ba2cae5bb94.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var $454384510905b1a7$var$_addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new $454384510905b1a7$export$3a67f7f44b1e838a(this._pt, target, prop, 0, 1, $454384510905b1a7$export$c5bc8e04394ecb2, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = $454384510905b1a7$export$d5962a97e3cde94d(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match($454384510905b1a7$var$_complexStringNumExp) || [];
    while(result = $454384510905b1a7$var$_complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? parseFloat(endNum.substr(2)) * (endNum.charAt(0) === "-" ? -1 : 1) : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = $454384510905b1a7$var$_complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if ($454384510905b1a7$export$5a680e28b0b61bc.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, $454384510905b1a7$var$_addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam) {
    $454384510905b1a7$var$_isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !$454384510905b1a7$var$_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !$454384510905b1a7$var$_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !$454384510905b1a7$var$_isFunction(currentValue) ? $454384510905b1a7$var$_setterPlain : funcParam ? $454384510905b1a7$var$_setterFuncWithParam : $454384510905b1a7$var$_setterFunc, pt;
    if ($454384510905b1a7$export$f664476fd67145ca(end)) {
        if (~end.indexOf("random(")) end = $454384510905b1a7$export$d5962a97e3cde94d(end);
        if (end.charAt(1) === "=") end = parseFloat(parsedStart) + parseFloat(end.substr(2)) * (end.charAt(0) === "-" ? -1 : 1) + ($454384510905b1a7$export$65f2564e9a9b9222(parsedStart) || 0);
    }
    if (parsedStart !== end) {
        if (!isNaN(parsedStart * end)) {
            pt = new $454384510905b1a7$export$3a67f7f44b1e838a(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? $454384510905b1a7$var$_renderBoolean : $454384510905b1a7$var$_renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && $454384510905b1a7$export$7fb54635790b59a5(prop, end);
        return $454384510905b1a7$var$_addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || $454384510905b1a7$export$4922bee768729a77.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
$454384510905b1a7$var$_processVars = function _processVars(vars, index, target, targets, tween) {
    $454384510905b1a7$var$_isFunction(vars) && (vars = $454384510905b1a7$var$_parseFuncOrString(vars, tween, index, target, targets));
    if (!$454384510905b1a7$var$_isObject(vars) || vars.style && vars.nodeType || $454384510905b1a7$var$_isArray(vars) || $454384510905b1a7$var$_isTypedArray(vars)) return $454384510905b1a7$export$f664476fd67145ca(vars) ? $454384510905b1a7$var$_parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = $454384510905b1a7$var$_parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, $454384510905b1a7$export$5c457b74208010cf = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if ($454384510905b1a7$export$d305d8ec5d7c26b8[property] && (plugin = new $454384510905b1a7$export$d305d8ec5d7c26b8[property]()).init(target, plugin.rawVars ? vars[property] : $454384510905b1a7$var$_processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new $454384510905b1a7$export$3a67f7f44b1e838a(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== $454384510905b1a7$var$_quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, $454384510905b1a7$var$_overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
$454384510905b1a7$var$_initTween = function _initTween(tween, time) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, onUpdateParams = vars.onUpdateParams, callbackScope = vars.callbackScope, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.parent._targets : targets, autoOverwrite = tween._overwrite === "auto" && !$454384510905b1a7$var$_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = $454384510905b1a7$var$_parseEase(ease, $454384510905b1a7$var$_defaults.ease);
    tween._yEase = yoyoEase ? $454384510905b1a7$var$_invertEase($454384510905b1a7$var$_parseEase(yoyoEase === true ? ease : yoyoEase, $454384510905b1a7$var$_defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    if (!tl) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? $454384510905b1a7$export$8b9be379d2de2a39(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = $454384510905b1a7$var$_copyExcluding(vars, $454384510905b1a7$var$_reservedProps);
        prevStartAt && prevStartAt.render(-1, true).kill();
        if (startAt) {
            $454384510905b1a7$var$_removeFromParent(tween._startAt = $454384510905b1a7$export$208a41d6b4e37b97.set(targets, $454384510905b1a7$export$dc2b19673bb53610({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: $454384510905b1a7$var$_isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate,
                onUpdateParams: onUpdateParams,
                callbackScope: callbackScope,
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            if (immediateRender) {
                if (time > 0) autoRevert || (tween._startAt = 0); //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in Timeline instances where immediateRender was false or when autoRevert is explicitly set to true.
                else if (dur && !(time < 0 && prevStartAt)) {
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) {
            //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
            if (prevStartAt) !autoRevert && (tween._startAt = 0);
            else {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = $454384510905b1a7$export$dc2b19673bb53610({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && $454384510905b1a7$var$_isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y:gsap.utils.wrap([-100,100])})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                $454384510905b1a7$var$_removeFromParent(tween._startAt = $454384510905b1a7$export$208a41d6b4e37b97.set(targets, p));
                if (!immediateRender) _initTween(tween._startAt, $454384510905b1a7$var$_tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = 0;
        lazy = dur && $454384510905b1a7$var$_isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || $454384510905b1a7$var$_harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            $454384510905b1a7$var$_lazyLookup[gsData.id] && $454384510905b1a7$var$_lazyTweens.length && $454384510905b1a7$var$_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new $454384510905b1a7$export$3a67f7f44b1e838a(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if ($454384510905b1a7$export$d305d8ec5d7c26b8[p] && (plugin = $454384510905b1a7$export$5c457b74208010cf(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = $454384510905b1a7$var$_addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                $454384510905b1a7$var$_overwritingTween = tween;
                $454384510905b1a7$var$_globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(0)); //Also make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                $454384510905b1a7$var$_overwritingTween = 0;
            }
            tween._pt && lazy && ($454384510905b1a7$var$_lazyLookup[gsData.id] = 1);
        }
        hasPriority && $454384510905b1a7$export$eed5824f53346d57(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
}, $454384510905b1a7$var$_addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? $454384510905b1a7$export$8b9be379d2de2a39(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = $454384510905b1a7$var$_merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, $454384510905b1a7$var$_parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return $454384510905b1a7$var$_isFunction(value) ? value.call(tween, i, target, targets) : $454384510905b1a7$export$f664476fd67145ca(value) && ~value.indexOf("random(") ? $454384510905b1a7$export$d5962a97e3cde94d(value) : value;
}, $454384510905b1a7$var$_staggerTweenProps = $454384510905b1a7$var$_callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase", $454384510905b1a7$var$_staggerPropsToSkip = ($454384510905b1a7$var$_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger").split(",");
var $454384510905b1a7$export$208a41d6b4e37b97 = /*#__PURE__*/ function(_Animation2) {
    $454384510905b1a7$var$_inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, time, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            time.duration = vars;
            vars = time;
            time = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : $454384510905b1a7$var$_inheritDefaults(vars), time) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = _this3.parent, parsedTargets = ($454384510905b1a7$var$_isArray(targets) || $454384510905b1a7$var$_isTypedArray(targets) ? $454384510905b1a7$var$_isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : $454384510905b1a7$export$45b10814cc054894(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? $454384510905b1a7$var$_harness(parsedTargets) : $454384510905b1a7$var$_warn("GSAP target " + targets + " not found. https://greensock.com", !$454384510905b1a7$export$4922bee768729a77.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || $454384510905b1a7$var$_isFuncOrString(duration) || $454384510905b1a7$var$_isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new $454384510905b1a7$export$e6a97ba2cae5bb94({
                data: "nested",
                defaults: defaults || {}
            });
            tl.kill();
            tl.parent = tl._dp = $454384510905b1a7$var$_assertThisInitialized(_this3);
            tl._start = 0;
            if (keyframes) {
                $454384510905b1a7$export$dc2b19673bb53610(tl.vars.defaults, {
                    ease: "none"
                });
                keyframes.forEach(function(frame) {
                    return tl.to(parsedTargets, frame, ">");
                });
            } else {
                l = parsedTargets.length;
                staggerFunc = stagger ? $454384510905b1a7$export$f02a9ddbe4480f19(stagger) : $454384510905b1a7$var$_emptyFunc;
                if ($454384510905b1a7$var$_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~$454384510905b1a7$var$_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = {};
                    for(p in vars)if ($454384510905b1a7$var$_staggerPropsToSkip.indexOf(p) < 0) copy[p] = vars[p];
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && $454384510905b1a7$var$_merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +$454384510905b1a7$var$_parseFuncOrString(duration, $454384510905b1a7$var$_assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+$454384510905b1a7$var$_parseFuncOrString(delay, $454384510905b1a7$var$_assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc(i, curTarget, parsedTargets));
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !$454384510905b1a7$var$_suppressOverwrites) {
            $454384510905b1a7$var$_overwritingTween = $454384510905b1a7$var$_assertThisInitialized(_this3);
            $454384510905b1a7$var$_globalTimeline.killTweensOf(parsedTargets);
            $454384510905b1a7$var$_overwritingTween = 0;
        }
        parent && $454384510905b1a7$var$_postAddChecks(parent, $454384510905b1a7$var$_assertThisInitialized(_this3));
        if (immediateRender || !duration && !keyframes && _this3._start === $454384510905b1a7$export$9c8d725d65e13f94(parent._time) && $454384510905b1a7$var$_isNotFalse(immediateRender) && $454384510905b1a7$var$_hasNoPausedAncestors($454384510905b1a7$var$_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -$454384510905b1a7$var$_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay)); //in case delay is negative
        }
        scrollTrigger && $454384510905b1a7$var$_scrollTrigger($454384510905b1a7$var$_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, tTime = totalTime > tDur - $454384510905b1a7$var$_tinyNum && totalTime >= 0 ? tDur : totalTime < $454384510905b1a7$var$_tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) $454384510905b1a7$var$_renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== totalTime < 0) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $454384510905b1a7$export$9c8d725d65e13f94(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = $454384510905b1a7$var$_animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted) //could be during the repeatDelay part. No need to render and fire callbacks.
                return this;
                if (iteration !== prevIteration) {
                    timeline && this._yEase && $454384510905b1a7$var$_propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render($454384510905b1a7$export$9c8d725d65e13f94(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if ($454384510905b1a7$var$_attemptInitTween(this, totalTime < 0 ? totalTime : time, force, suppressEvents)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            time && !prevTime && !suppressEvents && $454384510905b1a7$var$_callback(this, "onStart");
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -$454384510905b1a7$var$_tinyNum : timeline._dur * ratio, suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                totalTime < 0 && this._startAt && this._startAt.render(totalTime, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                $454384510905b1a7$var$_callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && $454384510905b1a7$var$_callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                totalTime < 0 && this._startAt && !this._onUpdate && this._startAt.render(totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && $454384510905b1a7$var$_removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    $454384510905b1a7$var$_callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate() {
        this._pt = this._op = this._startAt = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate();
        return _Animation2.prototype.invalidate.call(this);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? $454384510905b1a7$var$_interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, $454384510905b1a7$var$_overwritingTween && $454384510905b1a7$var$_overwritingTween.vars.overwrite !== true)._first || $454384510905b1a7$var$_interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && $454384510905b1a7$var$_setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? $454384510905b1a7$export$45b10814cc054894(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && $454384510905b1a7$var$_arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return $454384510905b1a7$var$_interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if ($454384510905b1a7$export$f664476fd67145ca(vars)) {
                p = {};
                $454384510905b1a7$export$f9000b814859f126(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = $454384510905b1a7$var$_addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) $454384510905b1a7$export$cd008aa6cd8844e3(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && $454384510905b1a7$var$_interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return new Tween(targets, $454384510905b1a7$var$_parseVars(arguments, 1));
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        });
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return new Tween(targets, $454384510905b1a7$var$_parseVars(arguments, 2));
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return $454384510905b1a7$var$_globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}($454384510905b1a7$export$c35d437ae5945fcd);
$454384510905b1a7$export$dc2b19673bb53610($454384510905b1a7$export$208a41d6b4e37b97.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
$454384510905b1a7$export$f9000b814859f126("staggerTo,staggerFrom,staggerFromTo", function(name) {
    $454384510905b1a7$export$208a41d6b4e37b97[name] = function() {
        var tl = new $454384510905b1a7$export$e6a97ba2cae5bb94(), params = $454384510905b1a7$var$_slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var $454384510905b1a7$var$_setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, $454384510905b1a7$var$_setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, $454384510905b1a7$var$_setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, $454384510905b1a7$var$_setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, $454384510905b1a7$export$d60fbc1e0278aaf0 = function _getSetter(target, property) {
    return $454384510905b1a7$var$_isFunction(target[property]) ? $454384510905b1a7$var$_setterFunc : $454384510905b1a7$export$a8178c063a9fd3a1(target[property]) && target.setAttribute ? $454384510905b1a7$var$_setterAttribute : $454384510905b1a7$var$_setterPlain;
}, $454384510905b1a7$var$_renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000, data);
}, $454384510905b1a7$var$_renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, $454384510905b1a7$export$c5bc8e04394ecb2 = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, $454384510905b1a7$var$_renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, $454384510905b1a7$var$_addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, $454384510905b1a7$var$_killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) $454384510905b1a7$export$cd008aa6cd8844e3(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, $454384510905b1a7$var$_setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, $454384510905b1a7$export$eed5824f53346d57 = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var $454384510905b1a7$export$3a67f7f44b1e838a = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || $454384510905b1a7$var$_renderPlain;
        this.d = data || this;
        this.set = setter || $454384510905b1a7$var$_setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = $454384510905b1a7$var$_setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
$454384510905b1a7$export$f9000b814859f126($454384510905b1a7$var$_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return $454384510905b1a7$var$_reservedProps[name] = 1;
});
$454384510905b1a7$var$_globals.TweenMax = $454384510905b1a7$var$_globals.TweenLite = $454384510905b1a7$export$208a41d6b4e37b97;
$454384510905b1a7$var$_globals.TimelineLite = $454384510905b1a7$var$_globals.TimelineMax = $454384510905b1a7$export$e6a97ba2cae5bb94;
$454384510905b1a7$var$_globalTimeline = new $454384510905b1a7$export$e6a97ba2cae5bb94({
    sortChildren: false,
    defaults: $454384510905b1a7$var$_defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
$454384510905b1a7$export$4922bee768729a77.stringFilter = $454384510905b1a7$export$7eb2e5eb5eeb96a4;
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var $454384510905b1a7$var$_gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return $454384510905b1a7$var$_createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new $454384510905b1a7$export$e6a97ba2cae5bb94(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return $454384510905b1a7$var$_globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        $454384510905b1a7$export$f664476fd67145ca(target) && (target = $454384510905b1a7$export$45b10814cc054894(target)[0]); //in case selector text or an array is passed in
        var getter = $454384510905b1a7$export$8b9be379d2de2a39(target || {}).get, format = unit ? $454384510905b1a7$var$_passThrough : $454384510905b1a7$var$_numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format(($454384510905b1a7$export$d305d8ec5d7c26b8[property] && $454384510905b1a7$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache));
        } : format(($454384510905b1a7$export$d305d8ec5d7c26b8[property] && $454384510905b1a7$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = $454384510905b1a7$export$45b10814cc054894(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return $454384510905b1a7$export$99ee26438460406a.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = $454384510905b1a7$export$d305d8ec5d7c26b8[property], cache = $454384510905b1a7$export$8b9be379d2de2a39(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            $454384510905b1a7$var$_quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, $454384510905b1a7$var$_quickTween, 0, [
                target
            ]);
            p.render(1, p);
            $454384510905b1a7$var$_quickTween._pt && $454384510905b1a7$var$_renderPropTweens(1, $454384510905b1a7$var$_quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    isTweening: function isTweening(targets) {
        return $454384510905b1a7$var$_globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = $454384510905b1a7$var$_parseEase(value.ease, $454384510905b1a7$var$_defaults.ease));
        return $454384510905b1a7$var$_mergeDeep($454384510905b1a7$var$_defaults, value || {});
    },
    config: function config(value) {
        return $454384510905b1a7$var$_mergeDeep($454384510905b1a7$export$4922bee768729a77, value || {});
    },
    registerEffect: function registerEffect(_ref2) {
        var name = _ref2.name, effect = _ref2.effect, plugins = _ref2.plugins, defaults = _ref2.defaults, extendTimeline = _ref2.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !$454384510905b1a7$export$d305d8ec5d7c26b8[pluginName] && !$454384510905b1a7$var$_globals[pluginName] && $454384510905b1a7$var$_warn(name + " effect requires " + pluginName + " plugin.");
        });
        $454384510905b1a7$var$_effects[name] = function(targets, vars, tl) {
            return effect($454384510905b1a7$export$45b10814cc054894(targets), $454384510905b1a7$export$dc2b19673bb53610(vars || {}, defaults), tl);
        };
        if (extendTimeline) $454384510905b1a7$export$e6a97ba2cae5bb94.prototype[name] = function(targets, vars, position) {
            return this.add($454384510905b1a7$var$_effects[name](targets, $454384510905b1a7$var$_isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        $454384510905b1a7$var$_easeMap[name] = $454384510905b1a7$var$_parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? $454384510905b1a7$var$_parseEase(ease, defaultEase) : $454384510905b1a7$var$_easeMap;
    },
    getById: function getById(id) {
        return $454384510905b1a7$var$_globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new $454384510905b1a7$export$e6a97ba2cae5bb94(vars), child, next;
        tl.smoothChildTiming = $454384510905b1a7$var$_isNotFalse(vars.smoothChildTiming);
        $454384510905b1a7$var$_globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = $454384510905b1a7$var$_globalTimeline._time;
        child = $454384510905b1a7$var$_globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof $454384510905b1a7$export$208a41d6b4e37b97 && child.vars.onComplete === child._targets[0])) $454384510905b1a7$var$_addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        $454384510905b1a7$var$_addToTimeline($454384510905b1a7$var$_globalTimeline, tl, 0);
        return tl;
    },
    utils: {
        wrap: $454384510905b1a7$export$4997ffc0176396a6,
        wrapYoyo: $454384510905b1a7$export$cfc0b067273edc55,
        distribute: $454384510905b1a7$export$f02a9ddbe4480f19,
        random: $454384510905b1a7$export$4385e60b38654f68,
        snap: $454384510905b1a7$export$51a0620f7a28532b,
        normalize: $454384510905b1a7$export$a3295358bff77e,
        getUnit: $454384510905b1a7$export$65f2564e9a9b9222,
        clamp: $454384510905b1a7$export$7d15b64cf5a3a4c4,
        splitColor: $454384510905b1a7$export$73d6f35be992df24,
        toArray: $454384510905b1a7$export$45b10814cc054894,
        mapRange: $454384510905b1a7$export$f65a7599bbc6b121,
        pipe: $454384510905b1a7$export$a4627e546088548d,
        unitize: $454384510905b1a7$export$d7502930aa5492de,
        interpolate: $454384510905b1a7$export$89e29e4ab65e70a9,
        shuffle: $454384510905b1a7$export$448332262467e042
    },
    install: $454384510905b1a7$var$_install,
    effects: $454384510905b1a7$var$_effects,
    ticker: $454384510905b1a7$export$762ed8fbedb691e3,
    updateRoot: $454384510905b1a7$export$e6a97ba2cae5bb94.updateRoot,
    plugins: $454384510905b1a7$export$d305d8ec5d7c26b8,
    globalTimeline: $454384510905b1a7$var$_globalTimeline,
    core: {
        PropTween: $454384510905b1a7$export$3a67f7f44b1e838a,
        globals: $454384510905b1a7$var$_addGlobal,
        Tween: $454384510905b1a7$export$208a41d6b4e37b97,
        Timeline: $454384510905b1a7$export$e6a97ba2cae5bb94,
        Animation: $454384510905b1a7$export$c35d437ae5945fcd,
        getCache: $454384510905b1a7$export$8b9be379d2de2a39,
        _removeLinkedListItem: $454384510905b1a7$export$cd008aa6cd8844e3,
        suppressOverwrites: function suppressOverwrites(value) {
            return $454384510905b1a7$var$_suppressOverwrites = value;
        }
    }
};
$454384510905b1a7$export$f9000b814859f126("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return $454384510905b1a7$var$_gsap[name] = $454384510905b1a7$export$208a41d6b4e37b97[name];
});
$454384510905b1a7$export$762ed8fbedb691e3.add($454384510905b1a7$export$e6a97ba2cae5bb94.updateRoot);
$454384510905b1a7$var$_quickTween = $454384510905b1a7$var$_gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var $454384510905b1a7$var$_getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, $454384510905b1a7$var$_addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = $454384510905b1a7$var$_getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, $454384510905b1a7$var$_buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if ($454384510905b1a7$export$f664476fd67145ca(vars)) {
                    temp = {};
                    $454384510905b1a7$export$f9000b814859f126(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                $454384510905b1a7$var$_addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var $454384510905b1a7$export$99ee26438460406a = $454384510905b1a7$var$_gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt;
        for(p in vars){
            pt = this.add(target, "setAttribute", (target.getAttribute(p) || 0) + "", vars[p], index, targets, 0, 0, p);
            pt && (pt.op = p);
            this._props.push(p);
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i]);
    }
}, $454384510905b1a7$var$_buildModifierPlugin("roundProps", $454384510905b1a7$export$dd12390e6b265a17), $454384510905b1a7$var$_buildModifierPlugin("modifiers"), $454384510905b1a7$var$_buildModifierPlugin("snap", $454384510905b1a7$export$51a0620f7a28532b)) || $454384510905b1a7$var$_gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
$454384510905b1a7$export$208a41d6b4e37b97.version = $454384510905b1a7$export$e6a97ba2cae5bb94.version = $454384510905b1a7$export$99ee26438460406a.version = "3.6.0";
$454384510905b1a7$var$_coreReady = 1;
if ($454384510905b1a7$var$_windowExists()) $454384510905b1a7$var$_wake();
var $454384510905b1a7$export$2fae1e8613537d5f = $454384510905b1a7$var$_easeMap.Power0, $454384510905b1a7$export$5d84ab4efbecec39 = $454384510905b1a7$var$_easeMap.Power1, $454384510905b1a7$export$d8c694b7490ad65d = $454384510905b1a7$var$_easeMap.Power2, $454384510905b1a7$export$acebdf2b184a0b6f = $454384510905b1a7$var$_easeMap.Power3, $454384510905b1a7$export$42e40a141003d2f0 = $454384510905b1a7$var$_easeMap.Power4, $454384510905b1a7$export$cff00ccf6e2392de = $454384510905b1a7$var$_easeMap.Linear, $454384510905b1a7$export$7005c9eb6671414d = $454384510905b1a7$var$_easeMap.Quad, $454384510905b1a7$export$755261d5a1567778 = $454384510905b1a7$var$_easeMap.Cubic, $454384510905b1a7$export$daf531446cad3d2a = $454384510905b1a7$var$_easeMap.Quart, $454384510905b1a7$export$4c407d38ce8ad8cc = $454384510905b1a7$var$_easeMap.Quint, $454384510905b1a7$export$f301627d437cff88 = $454384510905b1a7$var$_easeMap.Strong, $454384510905b1a7$export$56ebabebb04a9ca9 = $454384510905b1a7$var$_easeMap.Elastic, $454384510905b1a7$export$25e48ac541203d4a = $454384510905b1a7$var$_easeMap.Back, $454384510905b1a7$export$f7a11c7543d81853 = $454384510905b1a7$var$_easeMap.SteppedEase, $454384510905b1a7$export$d20e79fdc3899e95 = $454384510905b1a7$var$_easeMap.Bounce, $454384510905b1a7$export$bed2d20ad96b784c = $454384510905b1a7$var$_easeMap.Sine, $454384510905b1a7$export$41e9d1ff1a2fb15a = $454384510905b1a7$var$_easeMap.Expo, $454384510905b1a7$export$ce49a57dd865b86c = $454384510905b1a7$var$_easeMap.Circ;


/*!
 * CSSPlugin 3.6.0
 * https://greensock.com
 *
 * Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $75d916b583848404$var$_win, $75d916b583848404$var$_doc, $75d916b583848404$var$_docElement, $75d916b583848404$var$_pluginInitted, $75d916b583848404$var$_tempDiv, $75d916b583848404$var$_tempDivStyler, $75d916b583848404$var$_recentSetterPlugin, $75d916b583848404$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $75d916b583848404$var$_transformProps = {}, $75d916b583848404$var$_RAD2DEG = 180 / Math.PI, $75d916b583848404$var$_DEG2RAD = Math.PI / 180, $75d916b583848404$var$_atan2 = Math.atan2, $75d916b583848404$var$_bigNum = 1e8, $75d916b583848404$var$_capsExp = /([A-Z])/g, $75d916b583848404$var$_horizontalExp = /(?:left|right|width|margin|padding|x)/i, $75d916b583848404$var$_complexExp = /[\s,\(]\S/, $75d916b583848404$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $75d916b583848404$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $75d916b583848404$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $75d916b583848404$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$75d916b583848404$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $75d916b583848404$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $75d916b583848404$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $75d916b583848404$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $75d916b583848404$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $75d916b583848404$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $75d916b583848404$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $75d916b583848404$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $75d916b583848404$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $75d916b583848404$var$_transformProp = "transform", $75d916b583848404$var$_transformOriginProp = $75d916b583848404$var$_transformProp + "Origin", $75d916b583848404$var$_supports3D, $75d916b583848404$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $75d916b583848404$var$_doc.createElementNS ? $75d916b583848404$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $75d916b583848404$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e.style ? e : $75d916b583848404$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $75d916b583848404$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($75d916b583848404$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $75d916b583848404$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $75d916b583848404$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $75d916b583848404$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $75d916b583848404$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($75d916b583848404$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $75d916b583848404$var$_prefixes[i] : "") + property;
}, $75d916b583848404$var$_initCore = function _initCore() {
    if ($75d916b583848404$var$_windowExists() && window.document) {
        $75d916b583848404$var$_win = window;
        $75d916b583848404$var$_doc = $75d916b583848404$var$_win.document;
        $75d916b583848404$var$_docElement = $75d916b583848404$var$_doc.documentElement;
        $75d916b583848404$var$_tempDiv = $75d916b583848404$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $75d916b583848404$var$_tempDivStyler = $75d916b583848404$export$a232bb0480ae674a("div");
        $75d916b583848404$var$_transformProp = $75d916b583848404$export$8cbef5dd49a09c8b($75d916b583848404$var$_transformProp);
        $75d916b583848404$var$_transformOriginProp = $75d916b583848404$var$_transformProp + "Origin";
        $75d916b583848404$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $75d916b583848404$var$_supports3D = !!$75d916b583848404$export$8cbef5dd49a09c8b("perspective");
        $75d916b583848404$var$_pluginInitted = 1;
    }
}, $75d916b583848404$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $75d916b583848404$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $75d916b583848404$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $75d916b583848404$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $75d916b583848404$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $75d916b583848404$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $75d916b583848404$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $75d916b583848404$var$_getBBoxHack || (bounds = $75d916b583848404$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$75d916b583848404$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$75d916b583848404$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $75d916b583848404$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $75d916b583848404$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$75d916b583848404$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style;
        if (property in $75d916b583848404$var$_transformProps && property !== $75d916b583848404$var$_transformOriginProp) property = $75d916b583848404$var$_transformProp;
        if (style.removeProperty) {
            if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(property.replace($75d916b583848404$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $75d916b583848404$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $454384510905b1a7$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $75d916b583848404$var$_renderNonTweeningValueOnlyAtEnd : $75d916b583848404$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $75d916b583848404$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$75d916b583848404$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $75d916b583848404$var$_tempDiv.style, horizontal = $75d916b583848404$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $75d916b583848404$var$_nonConvertibleUnits[unit] || $75d916b583848404$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $75d916b583848404$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($75d916b583848404$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $454384510905b1a7$export$9c8d725d65e13f94)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $75d916b583848404$var$_doc || !parent.appendChild) parent = $75d916b583848404$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $454384510905b1a7$export$762ed8fbedb691e3).time) return (0, $454384510905b1a7$export$9c8d725d65e13f94)(curValue / cache.width * amount);
    else {
        (toPercent || curUnit === "%") && (style.position = $75d916b583848404$var$_getComputedProperty(target, "position"));
        parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
        parent.appendChild($75d916b583848404$var$_tempDiv);
        px = $75d916b583848404$var$_tempDiv[measureProperty];
        parent.removeChild($75d916b583848404$var$_tempDiv);
        style.position = "absolute";
        if (horizontal && toPercent) {
            cache = (0, $454384510905b1a7$export$8b9be379d2de2a39)(parent);
            cache.time = (0, $454384510905b1a7$export$762ed8fbedb691e3).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $454384510905b1a7$export$9c8d725d65e13f94)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $75d916b583848404$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $75d916b583848404$var$_pluginInitted || $75d916b583848404$var$_initCore();
    if (property in $75d916b583848404$var$_propertyAliases && property !== "transform") {
        property = $75d916b583848404$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($75d916b583848404$var$_transformProps[property] && property !== "transform") {
        value = $75d916b583848404$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : $75d916b583848404$var$_firstTwoOnly($75d916b583848404$var$_getComputedProperty(target, $75d916b583848404$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $75d916b583848404$var$_specialProps[property] && $75d916b583848404$var$_specialProps[property](target, property, unit) || $75d916b583848404$var$_getComputedProperty(target, property) || (0, $454384510905b1a7$export$51d6bbe898aef1f9)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $75d916b583848404$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $75d916b583848404$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    //note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://greensock.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $75d916b583848404$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $75d916b583848404$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $75d916b583848404$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://greensock.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $454384510905b1a7$export$3a67f7f44b1e838a)(this._pt, target.style, prop, 0, 1, (0, $454384510905b1a7$export$c5bc8e04394ecb2)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, relative, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (end === "auto") {
        target.style[prop] = end;
        end = $75d916b583848404$var$_getComputedProperty(target, prop) || end;
        target.style[prop] = start;
    }
    a = [
        start,
        end
    ];
    (0, $454384510905b1a7$export$7eb2e5eb5eeb96a4)(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $454384510905b1a7$export$65c88bbd597e7b0a)) || [];
    endValues = end.match((0, $454384510905b1a7$export$65c88bbd597e7b0a)) || [];
    if (endValues.length) {
        while(result = (0, $454384510905b1a7$export$65c88bbd597e7b0a).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                relative = endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
                if (relative) endValue = endValue.substr(2);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $454384510905b1a7$export$65c88bbd597e7b0a).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $454384510905b1a7$export$4922bee768729a77).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $75d916b583848404$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: relative ? relative * endNum : endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $75d916b583848404$var$_renderNonTweeningValueOnlyAtEnd : $75d916b583848404$var$_renderNonTweeningValue;
    (0, $454384510905b1a7$export$5a680e28b0b61bc).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $75d916b583848404$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $75d916b583848404$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $75d916b583848404$var$_keywordToPercent[x] || x;
    split[1] = $75d916b583848404$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $75d916b583848404$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($75d916b583848404$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $75d916b583848404$var$_transformOriginProp : $75d916b583848404$var$_transformProp;
                }
                $75d916b583848404$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $75d916b583848404$var$_removeProperty(target, $75d916b583848404$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $75d916b583848404$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$75d916b583848404$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $454384510905b1a7$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 0, $75d916b583848404$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $75d916b583848404$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $75d916b583848404$var$_rotationalProperties = {}, $75d916b583848404$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $75d916b583848404$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $75d916b583848404$var$_getComputedProperty(target, $75d916b583848404$var$_transformProp);
    return $75d916b583848404$var$_isNullTransform(matrixString) ? $75d916b583848404$var$_identity2DMatrix : matrixString.substr(7).match((0, $454384510905b1a7$export$b9d44bb6523120d6)).map((0, $454384510905b1a7$export$9c8d725d65e13f94));
}, $75d916b583848404$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $454384510905b1a7$export$8b9be379d2de2a39)(target), style = target.style, matrix = $75d916b583848404$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $75d916b583848404$var$_identity2DMatrix : matrix;
    } else if (matrix === $75d916b583848404$var$_identity2DMatrix && !target.offsetParent && target !== $75d916b583848404$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextSibling;
            $75d916b583848404$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $75d916b583848404$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $75d916b583848404$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $75d916b583848404$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $75d916b583848404$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $75d916b583848404$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $75d916b583848404$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
    } else if (matrix !== $75d916b583848404$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y;
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$75d916b583848404$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $75d916b583848404$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $75d916b583848404$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $75d916b583848404$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $75d916b583848404$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $75d916b583848404$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $454384510905b1a7$export$cf10981d5419cad5)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", origin = $75d916b583848404$var$_getComputedProperty(target, $75d916b583848404$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $75d916b583848404$var$_isSVG(target));
    matrix = $75d916b583848404$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        t1 = !cache.uncache && target.getAttribute("data-svg-origin");
        $75d916b583848404$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $75d916b583848404$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $75d916b583848404$var$_atan2(b, a) * $75d916b583848404$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $75d916b583848404$var$_atan2(c, d) * $75d916b583848404$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.cos(skewX * $75d916b583848404$var$_DEG2RAD));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $75d916b583848404$var$_atan2(a32, a33);
            rotationX = angle * $75d916b583848404$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $75d916b583848404$var$_atan2(-c, a33);
            rotationY = angle * $75d916b583848404$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $75d916b583848404$var$_atan2(b, a);
            rotation = angle * $75d916b583848404$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $454384510905b1a7$export$9c8d725d65e13f94)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $454384510905b1a7$export$9c8d725d65e13f94)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $75d916b583848404$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $75d916b583848404$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$75d916b583848404$var$_isNullTransform($75d916b583848404$var$_getComputedProperty(target, $75d916b583848404$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    cache.x = x - ((cache.xPercent = x && (cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $454384510905b1a7$export$9c8d725d65e13f94)(scaleX);
    cache.scaleY = (0, $454384510905b1a7$export$9c8d725d65e13f94)(scaleY);
    cache.rotation = (0, $454384510905b1a7$export$9c8d725d65e13f94)(rotation) + deg;
    cache.rotationX = (0, $454384510905b1a7$export$9c8d725d65e13f94)(rotationX) + deg;
    cache.rotationY = (0, $454384510905b1a7$export$9c8d725d65e13f94)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) style[$75d916b583848404$var$_transformOriginProp] = $75d916b583848404$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $454384510905b1a7$export$4922bee768729a77).force3D;
    cache.renderTransform = cache.svg ? $75d916b583848404$var$_renderSVGTransforms : $75d916b583848404$var$_supports3D ? $75d916b583848404$var$_renderCSSTransforms : $75d916b583848404$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $75d916b583848404$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$75d916b583848404$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $454384510905b1a7$export$65f2564e9a9b9222)(start);
    return (0, $454384510905b1a7$export$9c8d725d65e13f94)(parseFloat(start) + parseFloat($75d916b583848404$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $75d916b583848404$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $75d916b583848404$var$_renderCSSTransforms(ratio, cache);
}, $75d916b583848404$var$_zeroDeg = "0deg", $75d916b583848404$var$_zeroPx = "0px", $75d916b583848404$var$_endParenthesis = ") ", $75d916b583848404$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $75d916b583848404$var$_zeroDeg || rotationY !== $75d916b583848404$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $75d916b583848404$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $75d916b583848404$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $75d916b583848404$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $75d916b583848404$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $75d916b583848404$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $75d916b583848404$var$_zeroPx) transforms += "perspective(" + transformPerspective + $75d916b583848404$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $75d916b583848404$var$_zeroPx || y !== $75d916b583848404$var$_zeroPx || z !== $75d916b583848404$var$_zeroPx) transforms += z !== $75d916b583848404$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $75d916b583848404$var$_endParenthesis;
    if (rotation !== $75d916b583848404$var$_zeroDeg) transforms += "rotate(" + rotation + $75d916b583848404$var$_endParenthesis;
    if (rotationY !== $75d916b583848404$var$_zeroDeg) transforms += "rotateY(" + rotationY + $75d916b583848404$var$_endParenthesis;
    if (rotationX !== $75d916b583848404$var$_zeroDeg) transforms += "rotateX(" + rotationX + $75d916b583848404$var$_endParenthesis;
    if (skewX !== $75d916b583848404$var$_zeroDeg || skewY !== $75d916b583848404$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $75d916b583848404$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $75d916b583848404$var$_endParenthesis;
    target.style[$75d916b583848404$var$_transformProp] = transforms || "translate(0, 0)";
}, $75d916b583848404$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $75d916b583848404$var$_DEG2RAD;
        skewX *= $75d916b583848404$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $75d916b583848404$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $454384510905b1a7$export$9c8d725d65e13f94)(a11);
        a21 = (0, $454384510905b1a7$export$9c8d725d65e13f94)(a21);
        a12 = (0, $454384510905b1a7$export$9c8d725d65e13f94)(a12);
        a22 = (0, $454384510905b1a7$export$9c8d725d65e13f94)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $75d916b583848404$var$_convertToUnit(target, "x", x, "px");
        ty = $75d916b583848404$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $454384510905b1a7$export$9c8d725d65e13f94)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $454384510905b1a7$export$9c8d725d65e13f94)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $454384510905b1a7$export$9c8d725d65e13f94)(tx + xPercent / 100 * temp.width);
        ty = (0, $454384510905b1a7$export$9c8d725d65e13f94)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$75d916b583848404$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the  transform attribute changes!)
}, $75d916b583848404$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue, relative) {
    var cap = 360, isString = (0, $454384510905b1a7$export$f664476fd67145ca)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $75d916b583848404$var$_RAD2DEG : 1), change = relative ? endNum * relative : endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $75d916b583848404$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $75d916b583848404$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $454384510905b1a7$export$3a67f7f44b1e838a)(plugin._pt, target, property, startNum, change, $75d916b583848404$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $75d916b583848404$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var style = $75d916b583848404$var$_tempDivStyler.style, startCache = target._gsap, exclude = "perspective,force3D,transformOrigin,svgOrigin", endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    style.cssText = getComputedStyle(target).cssText + ";position:absolute;display:block;"; //%-based translations will fail unless we set the width/height to match the original target (and padding/borders can affect it)
    style[$75d916b583848404$var$_transformProp] = transforms;
    $75d916b583848404$var$_doc.body.appendChild($75d916b583848404$var$_tempDivStyler);
    endCache = $75d916b583848404$var$_parseTransform($75d916b583848404$var$_tempDivStyler, 1);
    for(p in $75d916b583848404$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $454384510905b1a7$export$65f2564e9a9b9222)(startValue);
            endUnit = (0, $454384510905b1a7$export$65f2564e9a9b9222)(endValue);
            startNum = startUnit !== endUnit ? $75d916b583848404$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $454384510905b1a7$export$3a67f7f44b1e838a)(plugin._pt, startCache, p, startNum, endNum - startNum, $75d916b583848404$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $75d916b583848404$var$_doc.body.removeChild($75d916b583848404$var$_tempDivStyler);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $454384510905b1a7$export$f9000b814859f126)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $75d916b583848404$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $75d916b583848404$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $75d916b583848404$export$855822f522f18eef = {
    name: "css",
    register: $75d916b583848404$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority;
        $75d916b583848404$var$_pluginInitted || $75d916b583848404$var$_initCore();
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $454384510905b1a7$export$d305d8ec5d7c26b8)[p] && (0, $454384510905b1a7$export$5c457b74208010cf)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $75d916b583848404$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $454384510905b1a7$export$d5962a97e3cde94d)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                startUnit = (0, $454384510905b1a7$export$65f2564e9a9b9222)(startValue);
                endUnit = (0, $454384510905b1a7$export$65f2564e9a9b9222)(endValue);
                endUnit ? startUnit !== endUnit && (startValue = $75d916b583848404$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    p in (0, $454384510905b1a7$export$4922bee768729a77).units && !(0, $454384510905b1a7$export$65f2564e9a9b9222)(startValue) && (startValue += (0, $454384510905b1a7$export$4922bee768729a77).units[p]); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $75d916b583848404$var$_get(target, p)); // can't work with relative values
                } else startValue = $75d916b583848404$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $75d916b583848404$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $75d916b583848404$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        $75d916b583848404$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $75d916b583848404$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $75d916b583848404$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $75d916b583848404$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $454384510905b1a7$export$3a67f7f44b1e838a)(this._pt, style, $75d916b583848404$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $454384510905b1a7$export$3a67f7f44b1e838a)(this._pt, cache, "scaleY", cache.scaleY, relative ? relative * endNum : endNum - cache.scaleY);
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        endValue = $75d916b583848404$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $75d916b583848404$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $75d916b583848404$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $75d916b583848404$var$_addNonTweeningPT(this, style, p, $75d916b583848404$var$_firstTwoOnly(startValue), $75d916b583848404$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $75d916b583848404$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $75d916b583848404$var$_rotationalProperties) {
                        $75d916b583848404$var$_addRotationalPropTween(this, cache, p, startNum, endValue, relative);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $75d916b583848404$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $75d916b583848404$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $75d916b583848404$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$75d916b583848404$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $454384510905b1a7$export$65f2564e9a9b9222)(endValue) || (p in (0, $454384510905b1a7$export$4922bee768729a77).units ? (0, $454384510905b1a7$export$4922bee768729a77).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $75d916b583848404$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $454384510905b1a7$export$3a67f7f44b1e838a)(this._pt, isTransformRelated ? cache : style, p, startNum, relative ? relative * endNum : endNum - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $75d916b583848404$var$_renderRoundedCSSProp : $75d916b583848404$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit) {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $75d916b583848404$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, target[p], endValue, index, targets);
                    else {
                        (0, $454384510905b1a7$export$7fb54635790b59a5)(p, endValue);
                        continue;
                    }
                } else $75d916b583848404$var$_tweenComplexCSSString.call(this, target, p, startValue, endValue);
                props.push(p);
            }
        }
        hasPriority && (0, $454384510905b1a7$export$eed5824f53346d57)(this);
    },
    get: $75d916b583848404$var$_get,
    aliases: $75d916b583848404$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $75d916b583848404$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $75d916b583848404$var$_transformProps && property !== $75d916b583848404$var$_transformOriginProp && (target._gsap.x || $75d916b583848404$var$_get(target, "x")) ? plugin && $75d916b583848404$var$_recentSetterPlugin === plugin ? property === "scale" ? $75d916b583848404$var$_setterScale : $75d916b583848404$var$_setterTransform : ($75d916b583848404$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $75d916b583848404$var$_setterScaleWithRender : $75d916b583848404$var$_setterTransformWithRender) : target.style && !(0, $454384510905b1a7$export$a8178c063a9fd3a1)(target.style[property]) ? $75d916b583848404$var$_setterCSSStyle : ~property.indexOf("-") ? $75d916b583848404$var$_setterCSSProp : (0, $454384510905b1a7$export$d60fbc1e0278aaf0)(target, property);
    },
    core: {
        _removeProperty: $75d916b583848404$var$_removeProperty,
        _getMatrix: $75d916b583848404$var$_getMatrix
    }
};
(0, $454384510905b1a7$export$99ee26438460406a).utils.checkPrefix = $75d916b583848404$export$8cbef5dd49a09c8b;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $454384510905b1a7$export$f9000b814859f126)(positionAndScale + "," + rotation + "," + others, function(name) {
        $75d916b583848404$var$_transformProps[name] = 1;
    });
    (0, $454384510905b1a7$export$f9000b814859f126)(rotation, function(name) {
        (0, $454384510905b1a7$export$4922bee768729a77).units[name] = "deg";
        $75d916b583848404$var$_rotationalProperties[name] = 1;
    });
    $75d916b583848404$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $454384510905b1a7$export$f9000b814859f126)(aliases, function(name) {
        var split = name.split(":");
        $75d916b583848404$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $454384510905b1a7$export$f9000b814859f126)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $454384510905b1a7$export$4922bee768729a77).units[name] = "px";
});
(0, $454384510905b1a7$export$99ee26438460406a).registerPlugin($75d916b583848404$export$855822f522f18eef);


var $f3bc927f09a8d458$export$99ee26438460406a = (0, $454384510905b1a7$export$99ee26438460406a).registerPlugin((0, $75d916b583848404$export$855822f522f18eef)) || (0, $454384510905b1a7$export$99ee26438460406a), // to protect from tree shaking
$f3bc927f09a8d458$export$7b23975ad686bf91 = $f3bc927f09a8d458$export$99ee26438460406a.core.Tween;


const $03da642c15b09e5e$var$loaderTl = (0, $f3bc927f09a8d458$export$99ee26438460406a).timeline({
    paused: true
});
let $03da642c15b09e5e$var$loadOutCalled = false;
const $03da642c15b09e5e$var$hidePreloader = ()=>{
    if ($03da642c15b09e5e$var$loadOutCalled === false) {
        console.log("hide");
        $03da642c15b09e5e$var$loaderTl.play();
        $03da642c15b09e5e$var$loadOutCalled = true;
    }
};
const $03da642c15b09e5e$var$checkForLoader = ()=>{
    $03da642c15b09e5e$var$loaderTl.to(".loader__img-cont", {
        duration: 0.4,
        autoAlpha: 0,
        y: -50,
        ease: "power3.inOut"
    }).to(".loader", {
        duration: 1,
        height: 0,
        ease: "power3.inOut"
    }, "-=0.2").to(".loader", {
        duration: .1,
        display: "none"
    });
    console.log(window.Webflow.require("lottie").lottie.getRegisteredAnimations().length);
    //See if there is a lottie file on the page
    if (window.Webflow.require("lottie").lottie.getRegisteredAnimations().length > 0) {
        const dogIndex = window.Webflow.require("lottie").lottie.getRegisteredAnimations().findIndex((el)=>el.fileName.includes("dog-static"));
        if (dogIndex < 0) {
            $03da642c15b09e5e$var$hidePreloader();
            console.log("hidePreloader1");
        } else var loadLottie = setInterval(function() {
            let lotteObjs = window.Webflow.require("lottie").lottie.getRegisteredAnimations();
            let lotteObjNotLoaded = lotteObjs.filter((lotteObj)=>lotteObj.isLoaded !== true);
            if (lotteObjNotLoaded.length === 0) {
                console.log("hidePreloader2");
                $03da642c15b09e5e$var$hidePreloader();
                clearInterval(loadLottie);
            }
        }, 100);
    } else {
        $03da642c15b09e5e$var$hidePreloader();
        console.log("hidePreloader3");
    }
};
const $03da642c15b09e5e$export$127d9b655e7cc8a7 = ()=>{
    window.addEventListener("load", ()=>{
        console.log("load");
        $03da642c15b09e5e$var$checkForLoader();
    });
    setTimeout(function() {
        if ($03da642c15b09e5e$var$loadOutCalled != true) {
            $03da642c15b09e5e$var$hidePreloader();
            console.log("hidePreloader Timelimit");
        }
    }, 10000);
    document.addEventListener("DOMContentLoaded", function() {
        console.log("DOMContentLoaded");
    }, false);
};


/*
 * anime.js v3.2.2
 * (c) 2023 Julian Garnier
 * Released under the MIT license
 * animejs.com
 */ // Defaults
var $d5074f6a41fc61ab$var$defaultInstanceSettings = {
    update: null,
    begin: null,
    loopBegin: null,
    changeBegin: null,
    change: null,
    changeComplete: null,
    loopComplete: null,
    complete: null,
    loop: 1,
    direction: "normal",
    autoplay: true,
    timelineOffset: 0
};
var $d5074f6a41fc61ab$var$defaultTweenSettings = {
    duration: 1000,
    delay: 0,
    endDelay: 0,
    easing: "easeOutElastic(1, .5)",
    round: 0
};
var $d5074f6a41fc61ab$var$validTransforms = [
    "translateX",
    "translateY",
    "translateZ",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "skew",
    "skewX",
    "skewY",
    "perspective",
    "matrix",
    "matrix3d"
];
// Caching
var $d5074f6a41fc61ab$var$cache = {
    CSS: {},
    springs: {}
};
// Utils
function $d5074f6a41fc61ab$var$minMax(val, min, max) {
    return Math.min(Math.max(val, min), max);
}
function $d5074f6a41fc61ab$var$stringContains(str, text) {
    return str.indexOf(text) > -1;
}
function $d5074f6a41fc61ab$var$applyArguments(func, args) {
    return func.apply(null, args);
}
var $d5074f6a41fc61ab$var$is = {
    arr: function(a) {
        return Array.isArray(a);
    },
    obj: function(a) {
        return $d5074f6a41fc61ab$var$stringContains(Object.prototype.toString.call(a), "Object");
    },
    pth: function(a) {
        return $d5074f6a41fc61ab$var$is.obj(a) && a.hasOwnProperty("totalLength");
    },
    svg: function(a) {
        return a instanceof SVGElement;
    },
    inp: function(a) {
        return a instanceof HTMLInputElement;
    },
    dom: function(a) {
        return a.nodeType || $d5074f6a41fc61ab$var$is.svg(a);
    },
    str: function(a) {
        return typeof a === "string";
    },
    fnc: function(a) {
        return typeof a === "function";
    },
    und: function(a) {
        return typeof a === "undefined";
    },
    nil: function(a) {
        return $d5074f6a41fc61ab$var$is.und(a) || a === null;
    },
    hex: function(a) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a);
    },
    rgb: function(a) {
        return /^rgb/.test(a);
    },
    hsl: function(a) {
        return /^hsl/.test(a);
    },
    col: function(a) {
        return $d5074f6a41fc61ab$var$is.hex(a) || $d5074f6a41fc61ab$var$is.rgb(a) || $d5074f6a41fc61ab$var$is.hsl(a);
    },
    key: function(a) {
        return !$d5074f6a41fc61ab$var$defaultInstanceSettings.hasOwnProperty(a) && !$d5074f6a41fc61ab$var$defaultTweenSettings.hasOwnProperty(a) && a !== "targets" && a !== "keyframes";
    }
};
// Easings
function $d5074f6a41fc61ab$var$parseEasingParameters(string) {
    var match = /\(([^)]+)\)/.exec(string);
    return match ? match[1].split(",").map(function(p) {
        return parseFloat(p);
    }) : [];
}
// Spring solver inspired by Webkit Copyright © 2016 Apple Inc. All rights reserved. https://webkit.org/demos/spring/spring.js
function $d5074f6a41fc61ab$var$spring(string, duration) {
    var params = $d5074f6a41fc61ab$var$parseEasingParameters(string);
    var mass = $d5074f6a41fc61ab$var$minMax($d5074f6a41fc61ab$var$is.und(params[0]) ? 1 : params[0], .1, 100);
    var stiffness = $d5074f6a41fc61ab$var$minMax($d5074f6a41fc61ab$var$is.und(params[1]) ? 100 : params[1], .1, 100);
    var damping = $d5074f6a41fc61ab$var$minMax($d5074f6a41fc61ab$var$is.und(params[2]) ? 10 : params[2], .1, 100);
    var velocity = $d5074f6a41fc61ab$var$minMax($d5074f6a41fc61ab$var$is.und(params[3]) ? 0 : params[3], .1, 100);
    var w0 = Math.sqrt(stiffness / mass);
    var zeta = damping / (2 * Math.sqrt(stiffness * mass));
    var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
    var a = 1;
    var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;
    function solver(t) {
        var progress = duration ? duration * t / 1000 : t;
        if (zeta < 1) progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
        else progress = (a + b * progress) * Math.exp(-progress * w0);
        if (t === 0 || t === 1) return t;
        return 1 - progress;
    }
    function getDuration() {
        var cached = $d5074f6a41fc61ab$var$cache.springs[string];
        if (cached) return cached;
        var frame = 1 / 6;
        var elapsed = 0;
        var rest = 0;
        while(true){
            elapsed += frame;
            if (solver(elapsed) === 1) {
                rest++;
                if (rest >= 16) break;
            } else rest = 0;
        }
        var duration = elapsed * frame * 1000;
        $d5074f6a41fc61ab$var$cache.springs[string] = duration;
        return duration;
    }
    return duration ? solver : getDuration;
}
// Basic steps easing implementation https://developer.mozilla.org/fr/docs/Web/CSS/transition-timing-function
function $d5074f6a41fc61ab$var$steps(steps) {
    if (steps === void 0) steps = 10;
    return function(t) {
        return Math.ceil($d5074f6a41fc61ab$var$minMax(t, 0.000001, 1) * steps) * (1 / steps);
    };
}
// BezierEasing https://github.com/gre/bezier-easing
var $d5074f6a41fc61ab$var$bezier = function() {
    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }
    function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }
    function getSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function binarySubdivide(aX, aA, aB, mX1, mX2) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) aB = currentT;
            else aA = currentT;
        }while (Math.abs(currentX) > 0.0000001 && ++i < 10);
        return currentT;
    }
    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
        for(var i = 0; i < 4; ++i){
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }
    function bezier(mX1, mY1, mX2, mY2) {
        if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) return;
        var sampleValues = new Float32Array(kSplineTableSize);
        if (mX1 !== mY1 || mX2 !== mY2) for(var i = 0; i < kSplineTableSize; ++i)sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
        function getTForX(aX) {
            var intervalStart = 0;
            var currentSample = 1;
            var lastSample = kSplineTableSize - 1;
            for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
            --currentSample;
            var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
            var guessForT = intervalStart + dist * kSampleStepSize;
            var initialSlope = getSlope(guessForT, mX1, mX2);
            if (initialSlope >= 0.001) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            else if (initialSlope === 0.0) return guessForT;
            else return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
        return function(x) {
            if (mX1 === mY1 && mX2 === mY2) return x;
            if (x === 0 || x === 1) return x;
            return calcBezier(getTForX(x), mY1, mY2);
        };
    }
    return bezier;
}();
var $d5074f6a41fc61ab$var$penner = function() {
    // Based on jQuery UI's implemenation of easing equations from Robert Penner (http://www.robertpenner.com/easing)
    var eases = {
        linear: function() {
            return function(t) {
                return t;
            };
        }
    };
    var functionEasings = {
        Sine: function() {
            return function(t) {
                return 1 - Math.cos(t * Math.PI / 2);
            };
        },
        Expo: function() {
            return function(t) {
                return t ? Math.pow(2, 10 * t - 10) : 0;
            };
        },
        Circ: function() {
            return function(t) {
                return 1 - Math.sqrt(1 - t * t);
            };
        },
        Back: function() {
            return function(t) {
                return t * t * (3 * t - 2);
            };
        },
        Bounce: function() {
            return function(t) {
                var pow2, b = 4;
                while(t < ((pow2 = Math.pow(2, --b)) - 1) / 11);
                return 1 / Math.pow(4, 3 - b) - 7.5625 * Math.pow((pow2 * 3 - 2) / 22 - t, 2);
            };
        },
        Elastic: function(amplitude, period) {
            if (amplitude === void 0) amplitude = 1;
            if (period === void 0) period = .5;
            var a = $d5074f6a41fc61ab$var$minMax(amplitude, 1, 10);
            var p = $d5074f6a41fc61ab$var$minMax(period, .1, 2);
            return function(t) {
                return t === 0 || t === 1 ? t : -a * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - p / (Math.PI * 2) * Math.asin(1 / a)) * (Math.PI * 2) / p);
            };
        }
    };
    var baseEasings = [
        "Quad",
        "Cubic",
        "Quart",
        "Quint"
    ];
    baseEasings.forEach(function(name, i) {
        functionEasings[name] = function() {
            return function(t) {
                return Math.pow(t, i + 2);
            };
        };
    });
    Object.keys(functionEasings).forEach(function(name) {
        var easeIn = functionEasings[name];
        eases["easeIn" + name] = easeIn;
        eases["easeOut" + name] = function(a, b) {
            return function(t) {
                return 1 - easeIn(a, b)(1 - t);
            };
        };
        eases["easeInOut" + name] = function(a, b) {
            return function(t) {
                return t < 0.5 ? easeIn(a, b)(t * 2) / 2 : 1 - easeIn(a, b)(t * -2 + 2) / 2;
            };
        };
        eases["easeOutIn" + name] = function(a, b) {
            return function(t) {
                return t < 0.5 ? (1 - easeIn(a, b)(1 - t * 2)) / 2 : (easeIn(a, b)(t * 2 - 1) + 1) / 2;
            };
        };
    });
    return eases;
}();
function $d5074f6a41fc61ab$var$parseEasings(easing, duration) {
    if ($d5074f6a41fc61ab$var$is.fnc(easing)) return easing;
    var name = easing.split("(")[0];
    var ease = $d5074f6a41fc61ab$var$penner[name];
    var args = $d5074f6a41fc61ab$var$parseEasingParameters(easing);
    switch(name){
        case "spring":
            return $d5074f6a41fc61ab$var$spring(easing, duration);
        case "cubicBezier":
            return $d5074f6a41fc61ab$var$applyArguments($d5074f6a41fc61ab$var$bezier, args);
        case "steps":
            return $d5074f6a41fc61ab$var$applyArguments($d5074f6a41fc61ab$var$steps, args);
        default:
            return $d5074f6a41fc61ab$var$applyArguments(ease, args);
    }
}
// Strings
function $d5074f6a41fc61ab$var$selectString(str) {
    try {
        var nodes = document.querySelectorAll(str);
        return nodes;
    } catch (e) {
        return;
    }
}
// Arrays
function $d5074f6a41fc61ab$var$filterArray(arr, callback) {
    var len = arr.length;
    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    var result = [];
    for(var i = 0; i < len; i++)if (i in arr) {
        var val = arr[i];
        if (callback.call(thisArg, val, i, arr)) result.push(val);
    }
    return result;
}
function $d5074f6a41fc61ab$var$flattenArray(arr) {
    return arr.reduce(function(a, b) {
        return a.concat($d5074f6a41fc61ab$var$is.arr(b) ? $d5074f6a41fc61ab$var$flattenArray(b) : b);
    }, []);
}
function $d5074f6a41fc61ab$var$toArray(o) {
    if ($d5074f6a41fc61ab$var$is.arr(o)) return o;
    if ($d5074f6a41fc61ab$var$is.str(o)) o = $d5074f6a41fc61ab$var$selectString(o) || o;
    if (o instanceof NodeList || o instanceof HTMLCollection) return [].slice.call(o);
    return [
        o
    ];
}
function $d5074f6a41fc61ab$var$arrayContains(arr, val) {
    return arr.some(function(a) {
        return a === val;
    });
}
// Objects
function $d5074f6a41fc61ab$var$cloneObject(o) {
    var clone = {};
    for(var p in o)clone[p] = o[p];
    return clone;
}
function $d5074f6a41fc61ab$var$replaceObjectProps(o1, o2) {
    var o = $d5074f6a41fc61ab$var$cloneObject(o1);
    for(var p in o1)o[p] = o2.hasOwnProperty(p) ? o2[p] : o1[p];
    return o;
}
function $d5074f6a41fc61ab$var$mergeObjects(o1, o2) {
    var o = $d5074f6a41fc61ab$var$cloneObject(o1);
    for(var p in o2)o[p] = $d5074f6a41fc61ab$var$is.und(o1[p]) ? o2[p] : o1[p];
    return o;
}
// Colors
function $d5074f6a41fc61ab$var$rgbToRgba(rgbValue) {
    var rgb = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(rgbValue);
    return rgb ? "rgba(" + rgb[1] + ",1)" : rgbValue;
}
function $d5074f6a41fc61ab$var$hexToRgba(hexValue) {
    var rgx = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var hex = hexValue.replace(rgx, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    var r = parseInt(rgb[1], 16);
    var g = parseInt(rgb[2], 16);
    var b = parseInt(rgb[3], 16);
    return "rgba(" + r + "," + g + "," + b + ",1)";
}
function $d5074f6a41fc61ab$var$hslToRgba(hslValue) {
    var hsl = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(hslValue) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(hslValue);
    var h = parseInt(hsl[1], 10) / 360;
    var s = parseInt(hsl[2], 10) / 100;
    var l = parseInt(hsl[3], 10) / 100;
    var a = hsl[4] || 1;
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    var r, g, b;
    if (s == 0) r = g = b = l;
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return "rgba(" + r * 255 + "," + g * 255 + "," + b * 255 + "," + a + ")";
}
function $d5074f6a41fc61ab$var$colorToRgb(val) {
    if ($d5074f6a41fc61ab$var$is.rgb(val)) return $d5074f6a41fc61ab$var$rgbToRgba(val);
    if ($d5074f6a41fc61ab$var$is.hex(val)) return $d5074f6a41fc61ab$var$hexToRgba(val);
    if ($d5074f6a41fc61ab$var$is.hsl(val)) return $d5074f6a41fc61ab$var$hslToRgba(val);
}
// Units
function $d5074f6a41fc61ab$var$getUnit(val) {
    var split = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(val);
    if (split) return split[1];
}
function $d5074f6a41fc61ab$var$getTransformUnit(propName) {
    if ($d5074f6a41fc61ab$var$stringContains(propName, "translate") || propName === "perspective") return "px";
    if ($d5074f6a41fc61ab$var$stringContains(propName, "rotate") || $d5074f6a41fc61ab$var$stringContains(propName, "skew")) return "deg";
}
// Values
function $d5074f6a41fc61ab$var$getFunctionValue(val, animatable) {
    if (!$d5074f6a41fc61ab$var$is.fnc(val)) return val;
    return val(animatable.target, animatable.id, animatable.total);
}
function $d5074f6a41fc61ab$var$getAttribute(el, prop) {
    return el.getAttribute(prop);
}
function $d5074f6a41fc61ab$var$convertPxToUnit(el, value, unit) {
    var valueUnit = $d5074f6a41fc61ab$var$getUnit(value);
    if ($d5074f6a41fc61ab$var$arrayContains([
        unit,
        "deg",
        "rad",
        "turn"
    ], valueUnit)) return value;
    var cached = $d5074f6a41fc61ab$var$cache.CSS[value + unit];
    if (!$d5074f6a41fc61ab$var$is.und(cached)) return cached;
    var baseline = 100;
    var tempEl = document.createElement(el.tagName);
    var parentEl = el.parentNode && el.parentNode !== document ? el.parentNode : document.body;
    parentEl.appendChild(tempEl);
    tempEl.style.position = "absolute";
    tempEl.style.width = baseline + unit;
    var factor = baseline / tempEl.offsetWidth;
    parentEl.removeChild(tempEl);
    var convertedUnit = factor * parseFloat(value);
    $d5074f6a41fc61ab$var$cache.CSS[value + unit] = convertedUnit;
    return convertedUnit;
}
function $d5074f6a41fc61ab$var$getCSSValue(el, prop, unit) {
    if (prop in el.style) {
        var uppercasePropName = prop.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        var value = el.style[prop] || getComputedStyle(el).getPropertyValue(uppercasePropName) || "0";
        return unit ? $d5074f6a41fc61ab$var$convertPxToUnit(el, value, unit) : value;
    }
}
function $d5074f6a41fc61ab$var$getAnimationType(el, prop) {
    if ($d5074f6a41fc61ab$var$is.dom(el) && !$d5074f6a41fc61ab$var$is.inp(el) && (!$d5074f6a41fc61ab$var$is.nil($d5074f6a41fc61ab$var$getAttribute(el, prop)) || $d5074f6a41fc61ab$var$is.svg(el) && el[prop])) return "attribute";
    if ($d5074f6a41fc61ab$var$is.dom(el) && $d5074f6a41fc61ab$var$arrayContains($d5074f6a41fc61ab$var$validTransforms, prop)) return "transform";
    if ($d5074f6a41fc61ab$var$is.dom(el) && prop !== "transform" && $d5074f6a41fc61ab$var$getCSSValue(el, prop)) return "css";
    if (el[prop] != null) return "object";
}
function $d5074f6a41fc61ab$var$getElementTransforms(el) {
    if (!$d5074f6a41fc61ab$var$is.dom(el)) return;
    var str = el.style.transform || "";
    var reg = /(\w+)\(([^)]*)\)/g;
    var transforms = new Map();
    var m;
    while(m = reg.exec(str))transforms.set(m[1], m[2]);
    return transforms;
}
function $d5074f6a41fc61ab$var$getTransformValue(el, propName, animatable, unit) {
    var defaultVal = $d5074f6a41fc61ab$var$stringContains(propName, "scale") ? 1 : 0 + $d5074f6a41fc61ab$var$getTransformUnit(propName);
    var value = $d5074f6a41fc61ab$var$getElementTransforms(el).get(propName) || defaultVal;
    if (animatable) {
        animatable.transforms.list.set(propName, value);
        animatable.transforms["last"] = propName;
    }
    return unit ? $d5074f6a41fc61ab$var$convertPxToUnit(el, value, unit) : value;
}
function $d5074f6a41fc61ab$var$getOriginalTargetValue(target, propName, unit, animatable) {
    switch($d5074f6a41fc61ab$var$getAnimationType(target, propName)){
        case "transform":
            return $d5074f6a41fc61ab$var$getTransformValue(target, propName, animatable, unit);
        case "css":
            return $d5074f6a41fc61ab$var$getCSSValue(target, propName, unit);
        case "attribute":
            return $d5074f6a41fc61ab$var$getAttribute(target, propName);
        default:
            return target[propName] || 0;
    }
}
function $d5074f6a41fc61ab$var$getRelativeValue(to, from) {
    var operator = /^(\*=|\+=|-=)/.exec(to);
    if (!operator) return to;
    var u = $d5074f6a41fc61ab$var$getUnit(to) || 0;
    var x = parseFloat(from);
    var y = parseFloat(to.replace(operator[0], ""));
    switch(operator[0][0]){
        case "+":
            return x + y + u;
        case "-":
            return x - y + u;
        case "*":
            return x * y + u;
    }
}
function $d5074f6a41fc61ab$var$validateValue(val, unit) {
    if ($d5074f6a41fc61ab$var$is.col(val)) return $d5074f6a41fc61ab$var$colorToRgb(val);
    if (/\s/g.test(val)) return val;
    var originalUnit = $d5074f6a41fc61ab$var$getUnit(val);
    var unitLess = originalUnit ? val.substr(0, val.length - originalUnit.length) : val;
    if (unit) return unitLess + unit;
    return unitLess;
}
// getTotalLength() equivalent for circle, rect, polyline, polygon and line shapes
// adapted from https://gist.github.com/SebLambla/3e0550c496c236709744
function $d5074f6a41fc61ab$var$getDistance(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
function $d5074f6a41fc61ab$var$getCircleLength(el) {
    return Math.PI * 2 * $d5074f6a41fc61ab$var$getAttribute(el, "r");
}
function $d5074f6a41fc61ab$var$getRectLength(el) {
    return $d5074f6a41fc61ab$var$getAttribute(el, "width") * 2 + $d5074f6a41fc61ab$var$getAttribute(el, "height") * 2;
}
function $d5074f6a41fc61ab$var$getLineLength(el) {
    return $d5074f6a41fc61ab$var$getDistance({
        x: $d5074f6a41fc61ab$var$getAttribute(el, "x1"),
        y: $d5074f6a41fc61ab$var$getAttribute(el, "y1")
    }, {
        x: $d5074f6a41fc61ab$var$getAttribute(el, "x2"),
        y: $d5074f6a41fc61ab$var$getAttribute(el, "y2")
    });
}
function $d5074f6a41fc61ab$var$getPolylineLength(el) {
    var points = el.points;
    var totalLength = 0;
    var previousPos;
    for(var i = 0; i < points.numberOfItems; i++){
        var currentPos = points.getItem(i);
        if (i > 0) totalLength += $d5074f6a41fc61ab$var$getDistance(previousPos, currentPos);
        previousPos = currentPos;
    }
    return totalLength;
}
function $d5074f6a41fc61ab$var$getPolygonLength(el) {
    var points = el.points;
    return $d5074f6a41fc61ab$var$getPolylineLength(el) + $d5074f6a41fc61ab$var$getDistance(points.getItem(points.numberOfItems - 1), points.getItem(0));
}
// Path animation
function $d5074f6a41fc61ab$var$getTotalLength(el) {
    if (el.getTotalLength) return el.getTotalLength();
    switch(el.tagName.toLowerCase()){
        case "circle":
            return $d5074f6a41fc61ab$var$getCircleLength(el);
        case "rect":
            return $d5074f6a41fc61ab$var$getRectLength(el);
        case "line":
            return $d5074f6a41fc61ab$var$getLineLength(el);
        case "polyline":
            return $d5074f6a41fc61ab$var$getPolylineLength(el);
        case "polygon":
            return $d5074f6a41fc61ab$var$getPolygonLength(el);
    }
}
function $d5074f6a41fc61ab$var$setDashoffset(el) {
    var pathLength = $d5074f6a41fc61ab$var$getTotalLength(el);
    el.setAttribute("stroke-dasharray", pathLength);
    return pathLength;
}
// Motion path
function $d5074f6a41fc61ab$var$getParentSvgEl(el) {
    var parentEl = el.parentNode;
    while($d5074f6a41fc61ab$var$is.svg(parentEl)){
        if (!$d5074f6a41fc61ab$var$is.svg(parentEl.parentNode)) break;
        parentEl = parentEl.parentNode;
    }
    return parentEl;
}
function $d5074f6a41fc61ab$var$getParentSvg(pathEl, svgData) {
    var svg = svgData || {};
    var parentSvgEl = svg.el || $d5074f6a41fc61ab$var$getParentSvgEl(pathEl);
    var rect = parentSvgEl.getBoundingClientRect();
    var viewBoxAttr = $d5074f6a41fc61ab$var$getAttribute(parentSvgEl, "viewBox");
    var width = rect.width;
    var height = rect.height;
    var viewBox = svg.viewBox || (viewBoxAttr ? viewBoxAttr.split(" ") : [
        0,
        0,
        width,
        height
    ]);
    return {
        el: parentSvgEl,
        viewBox: viewBox,
        x: viewBox[0] / 1,
        y: viewBox[1] / 1,
        w: width,
        h: height,
        vW: viewBox[2],
        vH: viewBox[3]
    };
}
function $d5074f6a41fc61ab$var$getPath(path, percent) {
    var pathEl = $d5074f6a41fc61ab$var$is.str(path) ? $d5074f6a41fc61ab$var$selectString(path)[0] : path;
    var p = percent || 100;
    return function(property) {
        return {
            property: property,
            el: pathEl,
            svg: $d5074f6a41fc61ab$var$getParentSvg(pathEl),
            totalLength: $d5074f6a41fc61ab$var$getTotalLength(pathEl) * (p / 100)
        };
    };
}
function $d5074f6a41fc61ab$var$getPathProgress(path, progress, isPathTargetInsideSVG) {
    function point(offset) {
        if (offset === void 0) offset = 0;
        var l = progress + offset >= 1 ? progress + offset : 0;
        return path.el.getPointAtLength(l);
    }
    var svg = $d5074f6a41fc61ab$var$getParentSvg(path.el, path.svg);
    var p = point();
    var p0 = point(-1);
    var p1 = point(1);
    var scaleX = isPathTargetInsideSVG ? 1 : svg.w / svg.vW;
    var scaleY = isPathTargetInsideSVG ? 1 : svg.h / svg.vH;
    switch(path.property){
        case "x":
            return (p.x - svg.x) * scaleX;
        case "y":
            return (p.y - svg.y) * scaleY;
        case "angle":
            return Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;
    }
}
// Decompose value
function $d5074f6a41fc61ab$var$decomposeValue(val, unit) {
    // const rgx = /-?\d*\.?\d+/g; // handles basic numbers
    // const rgx = /[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
    var rgx = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g; // handles exponents notation
    var value = $d5074f6a41fc61ab$var$validateValue($d5074f6a41fc61ab$var$is.pth(val) ? val.totalLength : val, unit) + "";
    return {
        original: value,
        numbers: value.match(rgx) ? value.match(rgx).map(Number) : [
            0
        ],
        strings: $d5074f6a41fc61ab$var$is.str(val) || unit ? value.split(rgx) : []
    };
}
// Animatables
function $d5074f6a41fc61ab$var$parseTargets(targets) {
    var targetsArray = targets ? $d5074f6a41fc61ab$var$flattenArray($d5074f6a41fc61ab$var$is.arr(targets) ? targets.map($d5074f6a41fc61ab$var$toArray) : $d5074f6a41fc61ab$var$toArray(targets)) : [];
    return $d5074f6a41fc61ab$var$filterArray(targetsArray, function(item, pos, self) {
        return self.indexOf(item) === pos;
    });
}
function $d5074f6a41fc61ab$var$getAnimatables(targets) {
    var parsed = $d5074f6a41fc61ab$var$parseTargets(targets);
    return parsed.map(function(t, i) {
        return {
            target: t,
            id: i,
            total: parsed.length,
            transforms: {
                list: $d5074f6a41fc61ab$var$getElementTransforms(t)
            }
        };
    });
}
// Properties
function $d5074f6a41fc61ab$var$normalizePropertyTweens(prop, tweenSettings) {
    var settings = $d5074f6a41fc61ab$var$cloneObject(tweenSettings);
    // Override duration if easing is a spring
    if (/^spring/.test(settings.easing)) settings.duration = $d5074f6a41fc61ab$var$spring(settings.easing);
    if ($d5074f6a41fc61ab$var$is.arr(prop)) {
        var l = prop.length;
        var isFromTo = l === 2 && !$d5074f6a41fc61ab$var$is.obj(prop[0]);
        if (!isFromTo) // Duration divided by the number of tweens
        {
            if (!$d5074f6a41fc61ab$var$is.fnc(tweenSettings.duration)) settings.duration = tweenSettings.duration / l;
        } else // Transform [from, to] values shorthand to a valid tween value
        prop = {
            value: prop
        };
    }
    var propArray = $d5074f6a41fc61ab$var$is.arr(prop) ? prop : [
        prop
    ];
    return propArray.map(function(v, i) {
        var obj = $d5074f6a41fc61ab$var$is.obj(v) && !$d5074f6a41fc61ab$var$is.pth(v) ? v : {
            value: v
        };
        // Default delay value should only be applied to the first tween
        if ($d5074f6a41fc61ab$var$is.und(obj.delay)) obj.delay = !i ? tweenSettings.delay : 0;
        // Default endDelay value should only be applied to the last tween
        if ($d5074f6a41fc61ab$var$is.und(obj.endDelay)) obj.endDelay = i === propArray.length - 1 ? tweenSettings.endDelay : 0;
        return obj;
    }).map(function(k) {
        return $d5074f6a41fc61ab$var$mergeObjects(k, settings);
    });
}
function $d5074f6a41fc61ab$var$flattenKeyframes(keyframes) {
    var propertyNames = $d5074f6a41fc61ab$var$filterArray($d5074f6a41fc61ab$var$flattenArray(keyframes.map(function(key) {
        return Object.keys(key);
    })), function(p) {
        return $d5074f6a41fc61ab$var$is.key(p);
    }).reduce(function(a, b) {
        if (a.indexOf(b) < 0) a.push(b);
        return a;
    }, []);
    var properties = {};
    var loop = function(i) {
        var propName = propertyNames[i];
        properties[propName] = keyframes.map(function(key) {
            var newKey = {};
            for(var p in key){
                if ($d5074f6a41fc61ab$var$is.key(p)) {
                    if (p == propName) newKey.value = key[p];
                } else newKey[p] = key[p];
            }
            return newKey;
        });
    };
    for(var i = 0; i < propertyNames.length; i++)loop(i);
    return properties;
}
function $d5074f6a41fc61ab$var$getProperties(tweenSettings, params) {
    var properties = [];
    var keyframes = params.keyframes;
    if (keyframes) params = $d5074f6a41fc61ab$var$mergeObjects($d5074f6a41fc61ab$var$flattenKeyframes(keyframes), params);
    for(var p in params)if ($d5074f6a41fc61ab$var$is.key(p)) properties.push({
        name: p,
        tweens: $d5074f6a41fc61ab$var$normalizePropertyTweens(params[p], tweenSettings)
    });
    return properties;
}
// Tweens
function $d5074f6a41fc61ab$var$normalizeTweenValues(tween, animatable) {
    var t = {};
    for(var p in tween){
        var value = $d5074f6a41fc61ab$var$getFunctionValue(tween[p], animatable);
        if ($d5074f6a41fc61ab$var$is.arr(value)) {
            value = value.map(function(v) {
                return $d5074f6a41fc61ab$var$getFunctionValue(v, animatable);
            });
            if (value.length === 1) value = value[0];
        }
        t[p] = value;
    }
    t.duration = parseFloat(t.duration);
    t.delay = parseFloat(t.delay);
    return t;
}
function $d5074f6a41fc61ab$var$normalizeTweens(prop, animatable) {
    var previousTween;
    return prop.tweens.map(function(t) {
        var tween = $d5074f6a41fc61ab$var$normalizeTweenValues(t, animatable);
        var tweenValue = tween.value;
        var to = $d5074f6a41fc61ab$var$is.arr(tweenValue) ? tweenValue[1] : tweenValue;
        var toUnit = $d5074f6a41fc61ab$var$getUnit(to);
        var originalValue = $d5074f6a41fc61ab$var$getOriginalTargetValue(animatable.target, prop.name, toUnit, animatable);
        var previousValue = previousTween ? previousTween.to.original : originalValue;
        var from = $d5074f6a41fc61ab$var$is.arr(tweenValue) ? tweenValue[0] : previousValue;
        var fromUnit = $d5074f6a41fc61ab$var$getUnit(from) || $d5074f6a41fc61ab$var$getUnit(originalValue);
        var unit = toUnit || fromUnit;
        if ($d5074f6a41fc61ab$var$is.und(to)) to = previousValue;
        tween.from = $d5074f6a41fc61ab$var$decomposeValue(from, unit);
        tween.to = $d5074f6a41fc61ab$var$decomposeValue($d5074f6a41fc61ab$var$getRelativeValue(to, from), unit);
        tween.start = previousTween ? previousTween.end : 0;
        tween.end = tween.start + tween.delay + tween.duration + tween.endDelay;
        tween.easing = $d5074f6a41fc61ab$var$parseEasings(tween.easing, tween.duration);
        tween.isPath = $d5074f6a41fc61ab$var$is.pth(tweenValue);
        tween.isPathTargetInsideSVG = tween.isPath && $d5074f6a41fc61ab$var$is.svg(animatable.target);
        tween.isColor = $d5074f6a41fc61ab$var$is.col(tween.from.original);
        if (tween.isColor) tween.round = 1;
        previousTween = tween;
        return tween;
    });
}
// Tween progress
var $d5074f6a41fc61ab$var$setProgressValue = {
    css: function(t, p, v) {
        return t.style[p] = v;
    },
    attribute: function(t, p, v) {
        return t.setAttribute(p, v);
    },
    object: function(t, p, v) {
        return t[p] = v;
    },
    transform: function(t, p, v, transforms, manual) {
        transforms.list.set(p, v);
        if (p === transforms.last || manual) {
            var str = "";
            transforms.list.forEach(function(value, prop) {
                str += prop + "(" + value + ") ";
            });
            t.style.transform = str;
        }
    }
};
// Set Value helper
function $d5074f6a41fc61ab$var$setTargetsValue(targets, properties) {
    var animatables = $d5074f6a41fc61ab$var$getAnimatables(targets);
    animatables.forEach(function(animatable) {
        for(var property in properties){
            var value = $d5074f6a41fc61ab$var$getFunctionValue(properties[property], animatable);
            var target = animatable.target;
            var valueUnit = $d5074f6a41fc61ab$var$getUnit(value);
            var originalValue = $d5074f6a41fc61ab$var$getOriginalTargetValue(target, property, valueUnit, animatable);
            var unit = valueUnit || $d5074f6a41fc61ab$var$getUnit(originalValue);
            var to = $d5074f6a41fc61ab$var$getRelativeValue($d5074f6a41fc61ab$var$validateValue(value, unit), originalValue);
            var animType = $d5074f6a41fc61ab$var$getAnimationType(target, property);
            $d5074f6a41fc61ab$var$setProgressValue[animType](target, property, to, animatable.transforms, true);
        }
    });
}
// Animations
function $d5074f6a41fc61ab$var$createAnimation(animatable, prop) {
    var animType = $d5074f6a41fc61ab$var$getAnimationType(animatable.target, prop.name);
    if (animType) {
        var tweens = $d5074f6a41fc61ab$var$normalizeTweens(prop, animatable);
        var lastTween = tweens[tweens.length - 1];
        return {
            type: animType,
            property: prop.name,
            animatable: animatable,
            tweens: tweens,
            duration: lastTween.end,
            delay: tweens[0].delay,
            endDelay: lastTween.endDelay
        };
    }
}
function $d5074f6a41fc61ab$var$getAnimations(animatables, properties) {
    return $d5074f6a41fc61ab$var$filterArray($d5074f6a41fc61ab$var$flattenArray(animatables.map(function(animatable) {
        return properties.map(function(prop) {
            return $d5074f6a41fc61ab$var$createAnimation(animatable, prop);
        });
    })), function(a) {
        return !$d5074f6a41fc61ab$var$is.und(a);
    });
}
// Create Instance
function $d5074f6a41fc61ab$var$getInstanceTimings(animations, tweenSettings) {
    var animLength = animations.length;
    var getTlOffset = function(anim) {
        return anim.timelineOffset ? anim.timelineOffset : 0;
    };
    var timings = {};
    timings.duration = animLength ? Math.max.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.duration;
    })) : tweenSettings.duration;
    timings.delay = animLength ? Math.min.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.delay;
    })) : tweenSettings.delay;
    timings.endDelay = animLength ? timings.duration - Math.max.apply(Math, animations.map(function(anim) {
        return getTlOffset(anim) + anim.duration - anim.endDelay;
    })) : tweenSettings.endDelay;
    return timings;
}
var $d5074f6a41fc61ab$var$instanceID = 0;
function $d5074f6a41fc61ab$var$createNewInstance(params) {
    var instanceSettings = $d5074f6a41fc61ab$var$replaceObjectProps($d5074f6a41fc61ab$var$defaultInstanceSettings, params);
    var tweenSettings = $d5074f6a41fc61ab$var$replaceObjectProps($d5074f6a41fc61ab$var$defaultTweenSettings, params);
    var properties = $d5074f6a41fc61ab$var$getProperties(tweenSettings, params);
    var animatables = $d5074f6a41fc61ab$var$getAnimatables(params.targets);
    var animations = $d5074f6a41fc61ab$var$getAnimations(animatables, properties);
    var timings = $d5074f6a41fc61ab$var$getInstanceTimings(animations, tweenSettings);
    var id = $d5074f6a41fc61ab$var$instanceID;
    $d5074f6a41fc61ab$var$instanceID++;
    return $d5074f6a41fc61ab$var$mergeObjects(instanceSettings, {
        id: id,
        children: [],
        animatables: animatables,
        animations: animations,
        duration: timings.duration,
        delay: timings.delay,
        endDelay: timings.endDelay
    });
}
// Core
var $d5074f6a41fc61ab$var$activeInstances = [];
var $d5074f6a41fc61ab$var$engine = function() {
    var raf;
    function play() {
        if (!raf && (!$d5074f6a41fc61ab$var$isDocumentHidden() || !$d5074f6a41fc61ab$var$anime.suspendWhenDocumentHidden) && $d5074f6a41fc61ab$var$activeInstances.length > 0) raf = requestAnimationFrame(step);
    }
    function step(t) {
        // memo on algorithm issue:
        // dangerous iteration over mutable `activeInstances`
        // (that collection may be updated from within callbacks of `tick`-ed animation instances)
        var activeInstancesLength = $d5074f6a41fc61ab$var$activeInstances.length;
        var i = 0;
        while(i < activeInstancesLength){
            var activeInstance = $d5074f6a41fc61ab$var$activeInstances[i];
            if (!activeInstance.paused) {
                activeInstance.tick(t);
                i++;
            } else {
                $d5074f6a41fc61ab$var$activeInstances.splice(i, 1);
                activeInstancesLength--;
            }
        }
        raf = i > 0 ? requestAnimationFrame(step) : undefined;
    }
    function handleVisibilityChange() {
        if (!$d5074f6a41fc61ab$var$anime.suspendWhenDocumentHidden) return;
        if ($d5074f6a41fc61ab$var$isDocumentHidden()) // suspend ticks
        raf = cancelAnimationFrame(raf);
        else {
            // first adjust animations to consider the time that ticks were suspended
            $d5074f6a41fc61ab$var$activeInstances.forEach(function(instance) {
                return instance._onDocumentVisibility();
            });
            $d5074f6a41fc61ab$var$engine();
        }
    }
    if (typeof document !== "undefined") document.addEventListener("visibilitychange", handleVisibilityChange);
    return play;
}();
function $d5074f6a41fc61ab$var$isDocumentHidden() {
    return !!document && document.hidden;
}
// Public Instance
function $d5074f6a41fc61ab$var$anime(params) {
    if (params === void 0) params = {};
    var startTime = 0, lastTime = 0, now = 0;
    var children, childrenLength = 0;
    var resolve = null;
    function makePromise(instance) {
        var promise = window.Promise && new Promise(function(_resolve) {
            return resolve = _resolve;
        });
        instance.finished = promise;
        return promise;
    }
    var instance = $d5074f6a41fc61ab$var$createNewInstance(params);
    var promise = makePromise(instance);
    function toggleInstanceDirection() {
        var direction = instance.direction;
        if (direction !== "alternate") instance.direction = direction !== "normal" ? "normal" : "reverse";
        instance.reversed = !instance.reversed;
        children.forEach(function(child) {
            return child.reversed = instance.reversed;
        });
    }
    function adjustTime(time) {
        return instance.reversed ? instance.duration - time : time;
    }
    function resetTime() {
        startTime = 0;
        lastTime = adjustTime(instance.currentTime) * (1 / $d5074f6a41fc61ab$var$anime.speed);
    }
    function seekChild(time, child) {
        if (child) child.seek(time - child.timelineOffset);
    }
    function syncInstanceChildren(time) {
        if (!instance.reversePlayback) for(var i = 0; i < childrenLength; i++)seekChild(time, children[i]);
        else for(var i$1 = childrenLength; i$1--;)seekChild(time, children[i$1]);
    }
    function setAnimationsProgress(insTime) {
        var i = 0;
        var animations = instance.animations;
        var animationsLength = animations.length;
        while(i < animationsLength){
            var anim = animations[i];
            var animatable = anim.animatable;
            var tweens = anim.tweens;
            var tweenLength = tweens.length - 1;
            var tween = tweens[tweenLength];
            // Only check for keyframes if there is more than one tween
            if (tweenLength) tween = $d5074f6a41fc61ab$var$filterArray(tweens, function(t) {
                return insTime < t.end;
            })[0] || tween;
            var elapsed = $d5074f6a41fc61ab$var$minMax(insTime - tween.start - tween.delay, 0, tween.duration) / tween.duration;
            var eased = isNaN(elapsed) ? 1 : tween.easing(elapsed);
            var strings = tween.to.strings;
            var round = tween.round;
            var numbers = [];
            var toNumbersLength = tween.to.numbers.length;
            var progress = void 0;
            for(var n = 0; n < toNumbersLength; n++){
                var value = void 0;
                var toNumber = tween.to.numbers[n];
                var fromNumber = tween.from.numbers[n] || 0;
                if (!tween.isPath) value = fromNumber + eased * (toNumber - fromNumber);
                else value = $d5074f6a41fc61ab$var$getPathProgress(tween.value, eased * toNumber, tween.isPathTargetInsideSVG);
                if (round) {
                    if (!(tween.isColor && n > 2)) value = Math.round(value * round) / round;
                }
                numbers.push(value);
            }
            // Manual Array.reduce for better performances
            var stringsLength = strings.length;
            if (!stringsLength) progress = numbers[0];
            else {
                progress = strings[0];
                for(var s = 0; s < stringsLength; s++){
                    var a = strings[s];
                    var b = strings[s + 1];
                    var n$1 = numbers[s];
                    if (!isNaN(n$1)) {
                        if (!b) progress += n$1 + " ";
                        else progress += n$1 + b;
                    }
                }
            }
            $d5074f6a41fc61ab$var$setProgressValue[anim.type](animatable.target, anim.property, progress, animatable.transforms);
            anim.currentValue = progress;
            i++;
        }
    }
    function setCallback(cb) {
        if (instance[cb] && !instance.passThrough) instance[cb](instance);
    }
    function countIteration() {
        if (instance.remaining && instance.remaining !== true) instance.remaining--;
    }
    function setInstanceProgress(engineTime) {
        var insDuration = instance.duration;
        var insDelay = instance.delay;
        var insEndDelay = insDuration - instance.endDelay;
        var insTime = adjustTime(engineTime);
        instance.progress = $d5074f6a41fc61ab$var$minMax(insTime / insDuration * 100, 0, 100);
        instance.reversePlayback = insTime < instance.currentTime;
        if (children) syncInstanceChildren(insTime);
        if (!instance.began && instance.currentTime > 0) {
            instance.began = true;
            setCallback("begin");
        }
        if (!instance.loopBegan && instance.currentTime > 0) {
            instance.loopBegan = true;
            setCallback("loopBegin");
        }
        if (insTime <= insDelay && instance.currentTime !== 0) setAnimationsProgress(0);
        if (insTime >= insEndDelay && instance.currentTime !== insDuration || !insDuration) setAnimationsProgress(insDuration);
        if (insTime > insDelay && insTime < insEndDelay) {
            if (!instance.changeBegan) {
                instance.changeBegan = true;
                instance.changeCompleted = false;
                setCallback("changeBegin");
            }
            setCallback("change");
            setAnimationsProgress(insTime);
        } else if (instance.changeBegan) {
            instance.changeCompleted = true;
            instance.changeBegan = false;
            setCallback("changeComplete");
        }
        instance.currentTime = $d5074f6a41fc61ab$var$minMax(insTime, 0, insDuration);
        if (instance.began) setCallback("update");
        if (engineTime >= insDuration) {
            lastTime = 0;
            countIteration();
            if (!instance.remaining) {
                instance.paused = true;
                if (!instance.completed) {
                    instance.completed = true;
                    setCallback("loopComplete");
                    setCallback("complete");
                    if (!instance.passThrough && "Promise" in window) {
                        resolve();
                        promise = makePromise(instance);
                    }
                }
            } else {
                startTime = now;
                setCallback("loopComplete");
                instance.loopBegan = false;
                if (instance.direction === "alternate") toggleInstanceDirection();
            }
        }
    }
    instance.reset = function() {
        var direction = instance.direction;
        instance.passThrough = false;
        instance.currentTime = 0;
        instance.progress = 0;
        instance.paused = true;
        instance.began = false;
        instance.loopBegan = false;
        instance.changeBegan = false;
        instance.completed = false;
        instance.changeCompleted = false;
        instance.reversePlayback = false;
        instance.reversed = direction === "reverse";
        instance.remaining = instance.loop;
        children = instance.children;
        childrenLength = children.length;
        for(var i = childrenLength; i--;)instance.children[i].reset();
        if (instance.reversed && instance.loop !== true || direction === "alternate" && instance.loop === 1) instance.remaining++;
        setAnimationsProgress(instance.reversed ? instance.duration : 0);
    };
    // internal method (for engine) to adjust animation timings before restoring engine ticks (rAF)
    instance._onDocumentVisibility = resetTime;
    // Set Value helper
    instance.set = function(targets, properties) {
        $d5074f6a41fc61ab$var$setTargetsValue(targets, properties);
        return instance;
    };
    instance.tick = function(t) {
        now = t;
        if (!startTime) startTime = now;
        setInstanceProgress((now + (lastTime - startTime)) * $d5074f6a41fc61ab$var$anime.speed);
    };
    instance.seek = function(time) {
        setInstanceProgress(adjustTime(time));
    };
    instance.pause = function() {
        instance.paused = true;
        resetTime();
    };
    instance.play = function() {
        if (!instance.paused) return;
        if (instance.completed) instance.reset();
        instance.paused = false;
        $d5074f6a41fc61ab$var$activeInstances.push(instance);
        resetTime();
        $d5074f6a41fc61ab$var$engine();
    };
    instance.reverse = function() {
        toggleInstanceDirection();
        instance.completed = instance.reversed ? false : true;
        resetTime();
    };
    instance.restart = function() {
        instance.reset();
        instance.play();
    };
    instance.remove = function(targets) {
        var targetsArray = $d5074f6a41fc61ab$var$parseTargets(targets);
        $d5074f6a41fc61ab$var$removeTargetsFromInstance(targetsArray, instance);
    };
    instance.reset();
    if (instance.autoplay) instance.play();
    return instance;
}
// Remove targets from animation
function $d5074f6a41fc61ab$var$removeTargetsFromAnimations(targetsArray, animations) {
    for(var a = animations.length; a--;)if ($d5074f6a41fc61ab$var$arrayContains(targetsArray, animations[a].animatable.target)) animations.splice(a, 1);
}
function $d5074f6a41fc61ab$var$removeTargetsFromInstance(targetsArray, instance) {
    var animations = instance.animations;
    var children = instance.children;
    $d5074f6a41fc61ab$var$removeTargetsFromAnimations(targetsArray, animations);
    for(var c = children.length; c--;){
        var child = children[c];
        var childAnimations = child.animations;
        $d5074f6a41fc61ab$var$removeTargetsFromAnimations(targetsArray, childAnimations);
        if (!childAnimations.length && !child.children.length) children.splice(c, 1);
    }
    if (!animations.length && !children.length) instance.pause();
}
function $d5074f6a41fc61ab$var$removeTargetsFromActiveInstances(targets) {
    var targetsArray = $d5074f6a41fc61ab$var$parseTargets(targets);
    for(var i = $d5074f6a41fc61ab$var$activeInstances.length; i--;){
        var instance = $d5074f6a41fc61ab$var$activeInstances[i];
        $d5074f6a41fc61ab$var$removeTargetsFromInstance(targetsArray, instance);
    }
}
// Stagger helpers
function $d5074f6a41fc61ab$var$stagger(val, params) {
    if (params === void 0) params = {};
    var direction = params.direction || "normal";
    var easing = params.easing ? $d5074f6a41fc61ab$var$parseEasings(params.easing) : null;
    var grid = params.grid;
    var axis = params.axis;
    var fromIndex = params.from || 0;
    var fromFirst = fromIndex === "first";
    var fromCenter = fromIndex === "center";
    var fromLast = fromIndex === "last";
    var isRange = $d5074f6a41fc61ab$var$is.arr(val);
    var val1 = isRange ? parseFloat(val[0]) : parseFloat(val);
    var val2 = isRange ? parseFloat(val[1]) : 0;
    var unit = $d5074f6a41fc61ab$var$getUnit(isRange ? val[1] : val) || 0;
    var start = params.start || 0 + (isRange ? val1 : 0);
    var values = [];
    var maxValue = 0;
    return function(el, i, t) {
        if (fromFirst) fromIndex = 0;
        if (fromCenter) fromIndex = (t - 1) / 2;
        if (fromLast) fromIndex = t - 1;
        if (!values.length) {
            for(var index = 0; index < t; index++){
                if (!grid) values.push(Math.abs(fromIndex - index));
                else {
                    var fromX = !fromCenter ? fromIndex % grid[0] : (grid[0] - 1) / 2;
                    var fromY = !fromCenter ? Math.floor(fromIndex / grid[0]) : (grid[1] - 1) / 2;
                    var toX = index % grid[0];
                    var toY = Math.floor(index / grid[0]);
                    var distanceX = fromX - toX;
                    var distanceY = fromY - toY;
                    var value = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
                    if (axis === "x") value = -distanceX;
                    if (axis === "y") value = -distanceY;
                    values.push(value);
                }
                maxValue = Math.max.apply(Math, values);
            }
            if (easing) values = values.map(function(val) {
                return easing(val / maxValue) * maxValue;
            });
            if (direction === "reverse") values = values.map(function(val) {
                return axis ? val < 0 ? val * -1 : -val : Math.abs(maxValue - val);
            });
        }
        var spacing = isRange ? (val2 - val1) / maxValue : val1;
        return start + spacing * (Math.round(values[i] * 100) / 100) + unit;
    };
}
// Timeline
function $d5074f6a41fc61ab$var$timeline(params) {
    if (params === void 0) params = {};
    var tl = $d5074f6a41fc61ab$var$anime(params);
    tl.duration = 0;
    tl.add = function(instanceParams, timelineOffset) {
        var tlIndex = $d5074f6a41fc61ab$var$activeInstances.indexOf(tl);
        var children = tl.children;
        if (tlIndex > -1) $d5074f6a41fc61ab$var$activeInstances.splice(tlIndex, 1);
        function passThrough(ins) {
            ins.passThrough = true;
        }
        for(var i = 0; i < children.length; i++)passThrough(children[i]);
        var insParams = $d5074f6a41fc61ab$var$mergeObjects(instanceParams, $d5074f6a41fc61ab$var$replaceObjectProps($d5074f6a41fc61ab$var$defaultTweenSettings, params));
        insParams.targets = insParams.targets || params.targets;
        var tlDuration = tl.duration;
        insParams.autoplay = false;
        insParams.direction = tl.direction;
        insParams.timelineOffset = $d5074f6a41fc61ab$var$is.und(timelineOffset) ? tlDuration : $d5074f6a41fc61ab$var$getRelativeValue(timelineOffset, tlDuration);
        passThrough(tl);
        tl.seek(insParams.timelineOffset);
        var ins = $d5074f6a41fc61ab$var$anime(insParams);
        passThrough(ins);
        children.push(ins);
        var timings = $d5074f6a41fc61ab$var$getInstanceTimings(children, params);
        tl.delay = timings.delay;
        tl.endDelay = timings.endDelay;
        tl.duration = timings.duration;
        tl.seek(0);
        tl.reset();
        if (tl.autoplay) tl.play();
        return tl;
    };
    return tl;
}
$d5074f6a41fc61ab$var$anime.version = "3.2.1";
$d5074f6a41fc61ab$var$anime.speed = 1;
// TODO:#review: naming, documentation
$d5074f6a41fc61ab$var$anime.suspendWhenDocumentHidden = true;
$d5074f6a41fc61ab$var$anime.running = $d5074f6a41fc61ab$var$activeInstances;
$d5074f6a41fc61ab$var$anime.remove = $d5074f6a41fc61ab$var$removeTargetsFromActiveInstances;
$d5074f6a41fc61ab$var$anime.get = $d5074f6a41fc61ab$var$getOriginalTargetValue;
$d5074f6a41fc61ab$var$anime.set = $d5074f6a41fc61ab$var$setTargetsValue;
$d5074f6a41fc61ab$var$anime.convertPx = $d5074f6a41fc61ab$var$convertPxToUnit;
$d5074f6a41fc61ab$var$anime.path = $d5074f6a41fc61ab$var$getPath;
$d5074f6a41fc61ab$var$anime.setDashoffset = $d5074f6a41fc61ab$var$setDashoffset;
$d5074f6a41fc61ab$var$anime.stagger = $d5074f6a41fc61ab$var$stagger;
$d5074f6a41fc61ab$var$anime.timeline = $d5074f6a41fc61ab$var$timeline;
$d5074f6a41fc61ab$var$anime.easing = $d5074f6a41fc61ab$var$parseEasings;
$d5074f6a41fc61ab$var$anime.penner = $d5074f6a41fc61ab$var$penner;
$d5074f6a41fc61ab$var$anime.random = function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
var $d5074f6a41fc61ab$export$2e2bcd8739ae039 = $d5074f6a41fc61ab$var$anime;



const $4d49ec876afb21b0$export$107f34e1a961432f = ()=>{
    const sliderPanelWrapper = document.querySelector(".section_slider-home");
    const sliderPanels = document.querySelectorAll(".home-slider-panel");
    const sliderPanelsBg = document.querySelectorAll(".home-slider-bg");
    if (sliderPanels.length <= 0) return;
    const sliderPanelsVirtualLength = sliderPanels.length + 1;
    const lastSlider = sliderPanels[sliderPanels.length - 1];
    const lastSliderAlias = lastSlider.cloneNode(true);
    lastSliderAlias.classList.remove("is-3");
    lastSliderAlias.classList.add("is-0");
    sliderPanelWrapper.insertBefore(lastSliderAlias, sliderPanels[0]);
    const lastSliderBg = sliderPanelsBg[sliderPanelsBg.length - 1];
    const lastSliderBgAlias = lastSliderBg.cloneNode(true);
    lastSliderBgAlias.classList.remove("is-3");
    lastSliderBgAlias.classList.add("is-0");
    sliderPanelWrapper.insertBefore(lastSliderBgAlias, sliderPanels[0]);
    var sliderTl = (0, $f3bc927f09a8d458$export$99ee26438460406a).timeline({
        paused: true
    });
    let panelCount = 1;
    const xRightVal = window.innerWidth <= 768 ? 100 : 53;
    const degree = "20";
    const scaleVal = .8;
    (0, $f3bc927f09a8d458$export$99ee26438460406a).set(".home-slider-panel.is-0", {
        x: `0%`,
        zIndex: 2
    });
    (0, $f3bc927f09a8d458$export$99ee26438460406a).set(".home-slider-panel.is-1", {
        pointerEvents: "none",
        x: `${xRightVal}vw`,
        scale: scaleVal,
        zIndex: 3,
        rotate: `-${degree}deg`
    });
    (0, $f3bc927f09a8d458$export$99ee26438460406a).set(".home-slider-panel.is-2", {
        pointerEvents: "none",
        x: `${xRightVal}vw`,
        scale: scaleVal,
        zIndex: 3,
        rotate: `-${degree}deg`
    });
    (0, $f3bc927f09a8d458$export$99ee26438460406a).set(".home-slider-panel.is-3", {
        pointerEvents: "none",
        x: "100%",
        scale: scaleVal,
        zIndex: 3,
        rotate: `-${degree}deg`
    });
    for(let i = 0; i <= sliderPanelsVirtualLength; i++){
        let currentSlide = i;
        let nextSlide = currentSlide + 1;
        let incomingSlide = nextSlide + 1;
        sliderTl.addLabel(`panel-${currentSlide}`);
        sliderTl.to(`.home-slider-panel.is-${currentSlide} .slider_icon`, {
            ease: "power4.in",
            duration: 0.6,
            scale: 0,
            stagger: 0.1
        }).fromTo(`.home-slider-panel.is-${currentSlide}`, {
            x: "0%",
            autoAlpha: 1,
            rotate: `0deg`,
            scale: "1",
            zIndex: 3
        }, {
            ease: "power4.inOut",
            duration: 1,
            x: "-100%",
            rotate: `${degree}deg`,
            scale: scaleVal
        }, "-=0.4").set(`.home_slider-cta.is-${currentSlide}`, {
            display: "none"
        }).set(`.home-slider-panel.is-${currentSlide}`, {
            pointerEvents: "none"
        });
        if (nextSlide <= sliderPanelsVirtualLength) sliderTl.set(`.home-slider-panel.is-${nextSlide}`, {
            pointerEvents: "all"
        }).set(`.home_slider-cta.is-${nextSlide}`, {
            display: "block"
        }).fromTo(`.home-slider-panel.is-${nextSlide}`, {
            x: "100%",
            autoAlpha: 0,
            rotate: `-${degree}deg`,
            scale: scaleVal,
            zIndex: 1
        }, {
            ease: "power4.inOut",
            duration: 1.4,
            autoAlpha: 1,
            x: "0%",
            rotate: `0deg`,
            scale: 1,
            zIndex: 3
        }, "-=1.2").from(`.home-slider-bg.is-${nextSlide}`, {
            ease: "power4.in",
            duration: 2,
            x: "125%"
        }, "-=2.4").from(`.home-slider-panel.is-${nextSlide} .slider_heading`, {
            ease: "power4.inOut",
            duration: 1,
            autoAlpha: 0,
            scale: .1
        }, "-=1.1").from(`.home-slider-panel.is-${nextSlide} .slider_title`, {
            ease: "power4.inOut",
            duration: 1,
            autoAlpha: 0,
            scale: .1
        }, "-=1.1").from(`.home-slider-panel.is-${nextSlide} .slider_icon`, {
            ease: "back.out(1.7)",
            duration: 0.8,
            scale: 0,
            autoAlpha: 0,
            stagger: 0.1
        }, "-=1.1").from(`.home-slider-panel.is-${nextSlide} .bubble`, {
            duration: 0.8,
            autoAlpha: 0,
            stagger: 0.1
        }, "-=0.7");
        if (incomingSlide <= sliderPanelsVirtualLength) sliderTl.to(`.home-slider-panel.is-${incomingSlide}`, {
            ease: "power4.inOut",
            duration: 1,
            x: `${xRightVal}vw`
        }, "-=1.8");
    }
    sliderTl.seek("panel-1");
    const nextPanelTrigger = document.querySelector(".home_slider-arrow-right");
    const prevPanelTrigger = document.querySelector(".home_slider-arrow_left");
    if (nextPanelTrigger) nextPanelTrigger.addEventListener("click", function() {
        if (panelCount == sliderPanels.length) {
            sliderTl.seek("panel-0");
            panelCount = 0;
        }
        panelCount++;
        sliderTl.tweenTo(`panel-${panelCount}`);
    });
    if (prevPanelTrigger) prevPanelTrigger.addEventListener("click", function() {
        if (panelCount == 0) {
            sliderTl.seek("panel-3");
            panelCount = 3;
        }
        panelCount--;
        sliderTl.tweenTo(`panel-${panelCount}`);
    });
};


























var $76297dbd329cba4e$export$99ee26438460406a = (0, $454384510905b1a7$export$99ee26438460406a).registerPlugin((0, $75d916b583848404$export$855822f522f18eef)) || (0, $454384510905b1a7$export$99ee26438460406a), $76297dbd329cba4e$export$7b23975ad686bf91 = $76297dbd329cba4e$export$99ee26438460406a.core.Tween;


/*!
 * ScrollTrigger 3.6.0
 * https://greensock.com
 *
 * @license Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $ae5f928ed8e7c926$var$gsap, $ae5f928ed8e7c926$var$_coreInitted, $ae5f928ed8e7c926$var$_win, $ae5f928ed8e7c926$var$_doc, $ae5f928ed8e7c926$var$_docEl, $ae5f928ed8e7c926$var$_body, $ae5f928ed8e7c926$var$_root, $ae5f928ed8e7c926$var$_resizeDelay, $ae5f928ed8e7c926$var$_raf, $ae5f928ed8e7c926$var$_request, $ae5f928ed8e7c926$var$_toArray, $ae5f928ed8e7c926$var$_clamp, $ae5f928ed8e7c926$var$_time2, $ae5f928ed8e7c926$var$_syncInterval, $ae5f928ed8e7c926$var$_refreshing, $ae5f928ed8e7c926$var$_pointerIsDown, $ae5f928ed8e7c926$var$_transformProp, $ae5f928ed8e7c926$var$_i, $ae5f928ed8e7c926$var$_prevWidth, $ae5f928ed8e7c926$var$_prevHeight, $ae5f928ed8e7c926$var$_autoRefresh, $ae5f928ed8e7c926$var$_sort, $ae5f928ed8e7c926$var$_suppressOverwrites, $ae5f928ed8e7c926$var$_ignoreResize, $ae5f928ed8e7c926$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$ae5f928ed8e7c926$var$_startup = 1, $ae5f928ed8e7c926$var$_proxies = [], $ae5f928ed8e7c926$var$_scrollers = [], $ae5f928ed8e7c926$var$_getTime = Date.now, $ae5f928ed8e7c926$var$_time1 = $ae5f928ed8e7c926$var$_getTime(), $ae5f928ed8e7c926$var$_lastScrollTime = 0, $ae5f928ed8e7c926$var$_enabled = 1, $ae5f928ed8e7c926$var$_passThrough = function _passThrough(v) {
    return v;
}, $ae5f928ed8e7c926$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $ae5f928ed8e7c926$var$_getGSAP = function _getGSAP() {
    return $ae5f928ed8e7c926$var$gsap || $ae5f928ed8e7c926$var$_windowExists() && ($ae5f928ed8e7c926$var$gsap = window.gsap) && $ae5f928ed8e7c926$var$gsap.registerPlugin && $ae5f928ed8e7c926$var$gsap;
}, $ae5f928ed8e7c926$var$_isViewport = function _isViewport(e) {
    return !!~$ae5f928ed8e7c926$var$_root.indexOf(e);
}, $ae5f928ed8e7c926$var$_getProxyProp = function _getProxyProp(element, property) {
    return ~$ae5f928ed8e7c926$var$_proxies.indexOf(element) && $ae5f928ed8e7c926$var$_proxies[$ae5f928ed8e7c926$var$_proxies.indexOf(element) + 1][property];
}, $ae5f928ed8e7c926$var$_getScrollFunc = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    var i = $ae5f928ed8e7c926$var$_scrollers.indexOf(element), offset = sc === $ae5f928ed8e7c926$var$_vertical.sc ? 1 : 2;
    !~i && (i = $ae5f928ed8e7c926$var$_scrollers.push(element) - 1);
    return $ae5f928ed8e7c926$var$_scrollers[i + offset] || ($ae5f928ed8e7c926$var$_scrollers[i + offset] = $ae5f928ed8e7c926$var$_getProxyProp(element, s) || ($ae5f928ed8e7c926$var$_isViewport(element) ? sc : function(value) {
        return arguments.length ? element[s] = value : element[s];
    }));
}, $ae5f928ed8e7c926$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return $ae5f928ed8e7c926$var$_getProxyProp(element, "getBoundingClientRect") || ($ae5f928ed8e7c926$var$_isViewport(element) ? function() {
        $ae5f928ed8e7c926$var$_winOffsets.width = $ae5f928ed8e7c926$var$_win.innerWidth;
        $ae5f928ed8e7c926$var$_winOffsets.height = $ae5f928ed8e7c926$var$_win.innerHeight;
        return $ae5f928ed8e7c926$var$_winOffsets;
    } : function() {
        return $ae5f928ed8e7c926$var$_getBounds(element);
    });
}, $ae5f928ed8e7c926$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref2) {
    var d = _ref2.d, d2 = _ref2.d2, a = _ref2.a;
    return (a = $ae5f928ed8e7c926$var$_getProxyProp(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $ae5f928ed8e7c926$var$_win["inner" + d2] : scroller["client" + d2]) || 0;
    };
}, $ae5f928ed8e7c926$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~$ae5f928ed8e7c926$var$_proxies.indexOf(element) ? $ae5f928ed8e7c926$var$_getBoundsFunc(element) : function() {
        return $ae5f928ed8e7c926$var$_winOffsets;
    };
}, $ae5f928ed8e7c926$var$_maxScroll = function _maxScroll(element, _ref3) {
    var s = _ref3.s, d2 = _ref3.d2, d = _ref3.d, a = _ref3.a;
    return (s = "scroll" + d2, a = $ae5f928ed8e7c926$var$_getProxyProp(element, s)) ? a() - $ae5f928ed8e7c926$var$_getBoundsFunc(element)()[d] : $ae5f928ed8e7c926$var$_isViewport(element) ? Math.max($ae5f928ed8e7c926$var$_docEl[s], $ae5f928ed8e7c926$var$_body[s]) - ($ae5f928ed8e7c926$var$_win["inner" + d2] || $ae5f928ed8e7c926$var$_docEl["client" + d2] || $ae5f928ed8e7c926$var$_body["client" + d2]) : element[s] - element["offset" + d2];
}, $ae5f928ed8e7c926$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $ae5f928ed8e7c926$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($ae5f928ed8e7c926$var$_autoRefresh[i + 1])) && func($ae5f928ed8e7c926$var$_autoRefresh[i], $ae5f928ed8e7c926$var$_autoRefresh[i + 1], $ae5f928ed8e7c926$var$_autoRefresh[i + 2]);
}, $ae5f928ed8e7c926$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $ae5f928ed8e7c926$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $ae5f928ed8e7c926$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $ae5f928ed8e7c926$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $ae5f928ed8e7c926$var$_callIfFunc = function _callIfFunc(value) {
    return $ae5f928ed8e7c926$var$_isFunction(value) && value();
}, $ae5f928ed8e7c926$var$_combineFunc = function _combineFunc(f1, f2) {
    return function() {
        var result1 = $ae5f928ed8e7c926$var$_callIfFunc(f1), result2 = $ae5f928ed8e7c926$var$_callIfFunc(f2);
        return function() {
            $ae5f928ed8e7c926$var$_callIfFunc(result1);
            $ae5f928ed8e7c926$var$_callIfFunc(result2);
        };
    };
}, $ae5f928ed8e7c926$var$_abs = Math.abs, $ae5f928ed8e7c926$var$_scrollLeft = "scrollLeft", $ae5f928ed8e7c926$var$_scrollTop = "scrollTop", $ae5f928ed8e7c926$var$_left = "left", $ae5f928ed8e7c926$var$_top = "top", $ae5f928ed8e7c926$var$_right = "right", $ae5f928ed8e7c926$var$_bottom = "bottom", $ae5f928ed8e7c926$var$_width = "width", $ae5f928ed8e7c926$var$_height = "height", $ae5f928ed8e7c926$var$_Right = "Right", $ae5f928ed8e7c926$var$_Left = "Left", $ae5f928ed8e7c926$var$_Top = "Top", $ae5f928ed8e7c926$var$_Bottom = "Bottom", $ae5f928ed8e7c926$var$_padding = "padding", $ae5f928ed8e7c926$var$_margin = "margin", $ae5f928ed8e7c926$var$_Width = "Width", $ae5f928ed8e7c926$var$_Height = "Height", $ae5f928ed8e7c926$var$_px = "px", $ae5f928ed8e7c926$var$_horizontal = {
    s: $ae5f928ed8e7c926$var$_scrollLeft,
    p: $ae5f928ed8e7c926$var$_left,
    p2: $ae5f928ed8e7c926$var$_Left,
    os: $ae5f928ed8e7c926$var$_right,
    os2: $ae5f928ed8e7c926$var$_Right,
    d: $ae5f928ed8e7c926$var$_width,
    d2: $ae5f928ed8e7c926$var$_Width,
    a: "x",
    sc: function sc(value) {
        return arguments.length ? $ae5f928ed8e7c926$var$_win.scrollTo(value, $ae5f928ed8e7c926$var$_vertical.sc()) : $ae5f928ed8e7c926$var$_win.pageXOffset || $ae5f928ed8e7c926$var$_doc[$ae5f928ed8e7c926$var$_scrollLeft] || $ae5f928ed8e7c926$var$_docEl[$ae5f928ed8e7c926$var$_scrollLeft] || $ae5f928ed8e7c926$var$_body[$ae5f928ed8e7c926$var$_scrollLeft] || 0;
    }
}, $ae5f928ed8e7c926$var$_vertical = {
    s: $ae5f928ed8e7c926$var$_scrollTop,
    p: $ae5f928ed8e7c926$var$_top,
    p2: $ae5f928ed8e7c926$var$_Top,
    os: $ae5f928ed8e7c926$var$_bottom,
    os2: $ae5f928ed8e7c926$var$_Bottom,
    d: $ae5f928ed8e7c926$var$_height,
    d2: $ae5f928ed8e7c926$var$_Height,
    a: "y",
    op: $ae5f928ed8e7c926$var$_horizontal,
    sc: function sc(value) {
        return arguments.length ? $ae5f928ed8e7c926$var$_win.scrollTo($ae5f928ed8e7c926$var$_horizontal.sc(), value) : $ae5f928ed8e7c926$var$_win.pageYOffset || $ae5f928ed8e7c926$var$_doc[$ae5f928ed8e7c926$var$_scrollTop] || $ae5f928ed8e7c926$var$_docEl[$ae5f928ed8e7c926$var$_scrollTop] || $ae5f928ed8e7c926$var$_body[$ae5f928ed8e7c926$var$_scrollTop] || 0;
    }
}, $ae5f928ed8e7c926$var$_getComputedStyle = function _getComputedStyle(element) {
    return $ae5f928ed8e7c926$var$_win.getComputedStyle(element);
}, $ae5f928ed8e7c926$var$_makePositionable = function _makePositionable(element) {
    return element.style.position = $ae5f928ed8e7c926$var$_getComputedStyle(element).position === "absolute" ? "absolute" : "relative";
}, // if the element already has position: absolute, leave that, otherwise make it position: relative
$ae5f928ed8e7c926$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, //_isInViewport = element => (element = _getBounds(element)) && !(element.top > (_win.innerHeight || _docEl.clientHeight) || element.bottom < 0 || element.left > (_win.innerWidth || _docEl.clientWidth) || element.right < 0) && element,
$ae5f928ed8e7c926$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $ae5f928ed8e7c926$var$_getComputedStyle(element)[$ae5f928ed8e7c926$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $ae5f928ed8e7c926$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $ae5f928ed8e7c926$var$_getSize = function _getSize(element, _ref4) {
    var d2 = _ref4.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $ae5f928ed8e7c926$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $ae5f928ed8e7c926$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $ae5f928ed8e7c926$var$gsap.utils.snap($ae5f928ed8e7c926$var$_getLabelRatioArray(animation), value);
    };
}, $ae5f928ed8e7c926$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        var a = $ae5f928ed8e7c926$var$_getLabelRatioArray(timeline), i;
        a.sort(function(a, b) {
            return a - b;
        });
        if (st.direction > 0) {
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a.pop();
        } else {
            i = a.length;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    };
}, $ae5f928ed8e7c926$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $ae5f928ed8e7c926$var$_addListener = function _addListener(element, type, func) {
    return element.addEventListener(type, func, {
        passive: true
    });
}, $ae5f928ed8e7c926$var$_removeListener = function _removeListener(element, type, func) {
    return element.removeEventListener(type, func);
}, $ae5f928ed8e7c926$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $ae5f928ed8e7c926$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $ae5f928ed8e7c926$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $ae5f928ed8e7c926$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($ae5f928ed8e7c926$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $ae5f928ed8e7c926$var$_keywords ? $ae5f928ed8e7c926$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $ae5f928ed8e7c926$var$_createMarker = function _createMarker(type, name, container, direction, _ref5, offset, matchWidthEl) {
    var startColor = _ref5.startColor, endColor = _ref5.endColor, fontSize = _ref5.fontSize, indent = _ref5.indent, fontWeight = _ref5.fontWeight;
    var e = $ae5f928ed8e7c926$var$_doc.createElement("div"), useFixedPosition = $ae5f928ed8e7c926$var$_isViewport(container) || $ae5f928ed8e7c926$var$_getProxyProp(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $ae5f928ed8e7c926$var$_body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + (isScroller && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || !useFixedPosition) && (css += (direction === $ae5f928ed8e7c926$var$_vertical ? $ae5f928ed8e7c926$var$_right : $ae5f928ed8e7c926$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type);
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $ae5f928ed8e7c926$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $ae5f928ed8e7c926$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $ae5f928ed8e7c926$var$_Width] = 1;
    vars["border" + oppositeSide + $ae5f928ed8e7c926$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $ae5f928ed8e7c926$var$gsap.set(marker, vars);
}, $ae5f928ed8e7c926$var$_triggers = [], $ae5f928ed8e7c926$var$_ids = {}, $ae5f928ed8e7c926$var$_sync = function _sync() {
    return $ae5f928ed8e7c926$var$_request || ($ae5f928ed8e7c926$var$_request = $ae5f928ed8e7c926$var$_raf($ae5f928ed8e7c926$var$_updateAll));
}, $ae5f928ed8e7c926$var$_onScroll = function _onScroll() {
    if (!$ae5f928ed8e7c926$var$_request) {
        $ae5f928ed8e7c926$var$_request = $ae5f928ed8e7c926$var$_raf($ae5f928ed8e7c926$var$_updateAll);
        $ae5f928ed8e7c926$var$_lastScrollTime || $ae5f928ed8e7c926$var$_dispatch("scrollStart");
        $ae5f928ed8e7c926$var$_lastScrollTime = $ae5f928ed8e7c926$var$_getTime();
    }
}, $ae5f928ed8e7c926$var$_onResize = function _onResize() {
    return !$ae5f928ed8e7c926$var$_refreshing && !$ae5f928ed8e7c926$var$_ignoreResize && !$ae5f928ed8e7c926$var$_doc.fullscreenElement && $ae5f928ed8e7c926$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$ae5f928ed8e7c926$var$_listeners = {}, $ae5f928ed8e7c926$var$_emptyArray = [], $ae5f928ed8e7c926$var$_media = [], $ae5f928ed8e7c926$var$_creatingMedia, // when ScrollTrigger.matchMedia() is called, we record the current media key here (like "(min-width: 800px)") so that we can assign it to everything that's created during that call. Then we can revert just those when necessary. In the ScrollTrigger's init() call, the _creatingMedia is recorded as a "media" property on the instance.
$ae5f928ed8e7c926$var$_lastMediaTick, $ae5f928ed8e7c926$var$_onMediaChange = function _onMediaChange(e) {
    var tick = $ae5f928ed8e7c926$var$gsap.ticker.frame, matches = [], i = 0, index;
    if ($ae5f928ed8e7c926$var$_lastMediaTick !== tick || $ae5f928ed8e7c926$var$_startup) {
        $ae5f928ed8e7c926$var$_revertAll();
        for(; i < $ae5f928ed8e7c926$var$_media.length; i += 4){
            index = $ae5f928ed8e7c926$var$_win.matchMedia($ae5f928ed8e7c926$var$_media[i]).matches;
            if (index !== $ae5f928ed8e7c926$var$_media[i + 3]) {
                // note: some browsers fire the matchMedia event multiple times, like when going full screen, so we shouldn't call the function multiple times. Check to see if it's already matched.
                $ae5f928ed8e7c926$var$_media[i + 3] = index;
                index ? matches.push(i) : $ae5f928ed8e7c926$var$_revertAll(1, $ae5f928ed8e7c926$var$_media[i]) || $ae5f928ed8e7c926$var$_isFunction($ae5f928ed8e7c926$var$_media[i + 2]) && $ae5f928ed8e7c926$var$_media[i + 2](); // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
            }
        }
        $ae5f928ed8e7c926$var$_revertRecorded(); // in case killing/reverting any of the animations actually added inline styles back.
        for(i = 0; i < matches.length; i++){
            index = matches[i];
            $ae5f928ed8e7c926$var$_creatingMedia = $ae5f928ed8e7c926$var$_media[index];
            $ae5f928ed8e7c926$var$_media[index + 2] = $ae5f928ed8e7c926$var$_media[index + 1](e);
        }
        $ae5f928ed8e7c926$var$_creatingMedia = 0;
        $ae5f928ed8e7c926$var$_coreInitted && $ae5f928ed8e7c926$var$_refreshAll(0, 1);
        $ae5f928ed8e7c926$var$_lastMediaTick = tick;
        $ae5f928ed8e7c926$var$_dispatch("matchMedia");
    }
}, $ae5f928ed8e7c926$var$_softRefresh = function _softRefresh() {
    return $ae5f928ed8e7c926$var$_removeListener($ae5f928ed8e7c926$export$875bcbe48555930, "scrollEnd", _softRefresh) || $ae5f928ed8e7c926$var$_refreshAll(true);
}, $ae5f928ed8e7c926$var$_dispatch = function _dispatch(type) {
    return $ae5f928ed8e7c926$var$_listeners[type] && $ae5f928ed8e7c926$var$_listeners[type].map(function(f) {
        return f();
    }) || $ae5f928ed8e7c926$var$_emptyArray;
}, $ae5f928ed8e7c926$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$ae5f928ed8e7c926$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $ae5f928ed8e7c926$var$_savedStyles.length; i += 4)if (!media || $ae5f928ed8e7c926$var$_savedStyles[i + 3] === media) {
        $ae5f928ed8e7c926$var$_savedStyles[i].style.cssText = $ae5f928ed8e7c926$var$_savedStyles[i + 1];
        $ae5f928ed8e7c926$var$_savedStyles[i + 2].uncache = 1;
    }
}, $ae5f928ed8e7c926$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($ae5f928ed8e7c926$var$_i = 0; $ae5f928ed8e7c926$var$_i < $ae5f928ed8e7c926$var$_triggers.length; $ae5f928ed8e7c926$var$_i++){
        trigger = $ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_i];
        if (!media || trigger.media === media) {
            if (kill) trigger.kill(1);
            else {
                trigger.scroll.rec || (trigger.scroll.rec = trigger.scroll()); // record the scroll positions so that in each refresh() we can ensure that it doesn't shift. Remember, pinning can make things change around, especially if the same element is pinned multiple times. If one was already recorded, don't re-record because unpinning may have occurred and made it shorter.
                trigger.revert();
            }
        }
    }
    $ae5f928ed8e7c926$var$_revertRecorded(media);
    media || $ae5f928ed8e7c926$var$_dispatch("revert");
}, $ae5f928ed8e7c926$var$_refreshAll = function _refreshAll(force, skipRevert) {
    if ($ae5f928ed8e7c926$var$_lastScrollTime && !force) {
        $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$export$875bcbe48555930, "scrollEnd", $ae5f928ed8e7c926$var$_softRefresh);
        return;
    }
    var refreshInits = $ae5f928ed8e7c926$var$_dispatch("refreshInit");
    $ae5f928ed8e7c926$var$_sort && $ae5f928ed8e7c926$export$875bcbe48555930.sort();
    skipRevert || $ae5f928ed8e7c926$var$_revertAll();
    for($ae5f928ed8e7c926$var$_i = 0; $ae5f928ed8e7c926$var$_i < $ae5f928ed8e7c926$var$_triggers.length; $ae5f928ed8e7c926$var$_i++)$ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_i].refresh();
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    $ae5f928ed8e7c926$var$_i = $ae5f928ed8e7c926$var$_triggers.length;
    while($ae5f928ed8e7c926$var$_i--)$ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_i].scroll.rec = 0;
    $ae5f928ed8e7c926$var$_resizeDelay.pause();
    $ae5f928ed8e7c926$var$_dispatch("refresh");
}, $ae5f928ed8e7c926$var$_lastScroll = 0, $ae5f928ed8e7c926$var$_direction = 1, $ae5f928ed8e7c926$var$_updateAll = function _updateAll() {
    var l = $ae5f928ed8e7c926$var$_triggers.length, time = $ae5f928ed8e7c926$var$_getTime(), recordVelocity = time - $ae5f928ed8e7c926$var$_time1 >= 50, scroll = l && $ae5f928ed8e7c926$var$_triggers[0].scroll();
    $ae5f928ed8e7c926$var$_direction = $ae5f928ed8e7c926$var$_lastScroll > scroll ? -1 : 1;
    $ae5f928ed8e7c926$var$_lastScroll = scroll;
    if (recordVelocity) {
        if ($ae5f928ed8e7c926$var$_lastScrollTime && !$ae5f928ed8e7c926$var$_pointerIsDown && time - $ae5f928ed8e7c926$var$_lastScrollTime > 200) {
            $ae5f928ed8e7c926$var$_lastScrollTime = 0;
            $ae5f928ed8e7c926$var$_dispatch("scrollEnd");
        }
        $ae5f928ed8e7c926$var$_time2 = $ae5f928ed8e7c926$var$_time1;
        $ae5f928ed8e7c926$var$_time1 = time;
    }
    if ($ae5f928ed8e7c926$var$_direction < 0) {
        $ae5f928ed8e7c926$var$_i = l;
        while($ae5f928ed8e7c926$var$_i--)$ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_i] && $ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_i].update(0, recordVelocity);
        $ae5f928ed8e7c926$var$_direction = 1;
    } else for($ae5f928ed8e7c926$var$_i = 0; $ae5f928ed8e7c926$var$_i < l; $ae5f928ed8e7c926$var$_i++)$ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_i] && $ae5f928ed8e7c926$var$_triggers[$ae5f928ed8e7c926$var$_i].update(0, recordVelocity);
    $ae5f928ed8e7c926$var$_request = 0;
}, $ae5f928ed8e7c926$var$_propNamesToCopy = [
    $ae5f928ed8e7c926$var$_left,
    $ae5f928ed8e7c926$var$_top,
    $ae5f928ed8e7c926$var$_bottom,
    $ae5f928ed8e7c926$var$_right,
    $ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Bottom,
    $ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Right,
    $ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Top,
    $ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex"
], $ae5f928ed8e7c926$var$_stateProps = $ae5f928ed8e7c926$var$_propNamesToCopy.concat([
    $ae5f928ed8e7c926$var$_width,
    $ae5f928ed8e7c926$var$_height,
    "boxSizing",
    "max" + $ae5f928ed8e7c926$var$_Width,
    "max" + $ae5f928ed8e7c926$var$_Height,
    "position",
    $ae5f928ed8e7c926$var$_margin,
    $ae5f928ed8e7c926$var$_padding,
    $ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Top,
    $ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Right,
    $ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Bottom,
    $ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Left
]), $ae5f928ed8e7c926$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $ae5f928ed8e7c926$var$_setState(state);
    if (pin.parentNode === spacer) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
}, $ae5f928ed8e7c926$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (pin.parentNode !== spacer) {
        var i = $ae5f928ed8e7c926$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $ae5f928ed8e7c926$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$ae5f928ed8e7c926$var$_bottom] = pinStyle[$ae5f928ed8e7c926$var$_right] = "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$ae5f928ed8e7c926$var$_width] = $ae5f928ed8e7c926$var$_getSize(pin, $ae5f928ed8e7c926$var$_horizontal) + $ae5f928ed8e7c926$var$_px;
        spacerStyle[$ae5f928ed8e7c926$var$_height] = $ae5f928ed8e7c926$var$_getSize(pin, $ae5f928ed8e7c926$var$_vertical) + $ae5f928ed8e7c926$var$_px;
        spacerStyle[$ae5f928ed8e7c926$var$_padding] = pinStyle[$ae5f928ed8e7c926$var$_margin] = pinStyle[$ae5f928ed8e7c926$var$_top] = pinStyle[$ae5f928ed8e7c926$var$_left] = "0";
        $ae5f928ed8e7c926$var$_setState(spacerState);
        pinStyle[$ae5f928ed8e7c926$var$_width] = pinStyle["max" + $ae5f928ed8e7c926$var$_Width] = cs[$ae5f928ed8e7c926$var$_width];
        pinStyle[$ae5f928ed8e7c926$var$_height] = pinStyle["max" + $ae5f928ed8e7c926$var$_Height] = cs[$ae5f928ed8e7c926$var$_height];
        pinStyle[$ae5f928ed8e7c926$var$_padding] = cs[$ae5f928ed8e7c926$var$_padding];
        pin.parentNode.insertBefore(spacer, pin);
        spacer.appendChild(pin);
    }
}, $ae5f928ed8e7c926$var$_capsExp = /([A-Z])/g, $ae5f928ed8e7c926$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $ae5f928ed8e7c926$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($ae5f928ed8e7c926$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $ae5f928ed8e7c926$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $ae5f928ed8e7c926$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($ae5f928ed8e7c926$var$_stateProps[i], style[$ae5f928ed8e7c926$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $ae5f928ed8e7c926$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $ae5f928ed8e7c926$var$_winOffsets = {
    left: 0,
    top: 0
}, $ae5f928ed8e7c926$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax) {
    $ae5f928ed8e7c926$var$_isFunction(value) && (value = value(self));
    if ($ae5f928ed8e7c926$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $ae5f928ed8e7c926$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    if (!$ae5f928ed8e7c926$var$_isNumber(value)) {
        $ae5f928ed8e7c926$var$_isFunction(trigger) && (trigger = trigger(self));
        var element = $ae5f928ed8e7c926$var$_toArray(trigger)[0] || $ae5f928ed8e7c926$var$_body, bounds = $ae5f928ed8e7c926$var$_getBounds(element) || {}, offsets = value.split(" "), localOffset, globalOffset, display;
        if ((!bounds || !bounds.left && !bounds.top) && $ae5f928ed8e7c926$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $ae5f928ed8e7c926$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $ae5f928ed8e7c926$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $ae5f928ed8e7c926$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $ae5f928ed8e7c926$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else if (markerScroller) $ae5f928ed8e7c926$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        scrollerMax = "scroll" + direction.d2;
        $ae5f928ed8e7c926$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($ae5f928ed8e7c926$var$_body[scrollerMax], $ae5f928ed8e7c926$var$_docEl[scrollerMax]) : marker.parentNode[scrollerMax]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $ae5f928ed8e7c926$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $ae5f928ed8e7c926$var$_px);
        }
    }
    return Math.round(value);
}, $ae5f928ed8e7c926$var$_prefixExp = /(?:webkit|moz|length|cssText|inset)/i, $ae5f928ed8e7c926$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $ae5f928ed8e7c926$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $ae5f928ed8e7c926$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$ae5f928ed8e7c926$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $ae5f928ed8e7c926$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, // returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$ae5f928ed8e7c926$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = $ae5f928ed8e7c926$var$_getScrollFunc(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    lastScroll1, lastScroll2, getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        tween && tween.kill();
        lastScroll1 = Math.round(initialValue);
        vars[prop] = scrollTo;
        vars.modifiers = modifiers;
        modifiers[prop] = function(value) {
            value = Math.round(getScroll()); // round because in some [very uncommon] Windows environments, it can get reported with decimals even though it was set without.
            if (value !== lastScroll1 && value !== lastScroll2 && Math.abs(value - lastScroll1) > 2) {
                // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
                tween.kill();
                getTween.tween = 0;
            } else value = initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio;
            lastScroll2 = lastScroll1;
            return lastScroll1 = Math.round(value);
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $ae5f928ed8e7c926$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    scroller.addEventListener("mousewheel", function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    }); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a mousewheel event.
    return getTween;
};
$ae5f928ed8e7c926$var$_horizontal.op = $ae5f928ed8e7c926$var$_vertical;
var $ae5f928ed8e7c926$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $ae5f928ed8e7c926$var$_coreInitted || ScrollTrigger.register($ae5f928ed8e7c926$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(1); // in case it's being initted again
        if (!$ae5f928ed8e7c926$var$_enabled) {
            this.update = this.refresh = this.kill = $ae5f928ed8e7c926$var$_passThrough;
            return;
        }
        vars = $ae5f928ed8e7c926$var$_setDefaults($ae5f928ed8e7c926$var$_isString(vars) || $ae5f928ed8e7c926$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $ae5f928ed8e7c926$var$_defaults);
        var direction = vars.horizontal ? $ae5f928ed8e7c926$var$_horizontal : $ae5f928ed8e7c926$var$_vertical, _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, isToggle = !scrub && scrub !== 0, scroller = $ae5f928ed8e7c926$var$_toArray(vars.scroller || $ae5f928ed8e7c926$var$_win)[0], scrollerCache = $ae5f928ed8e7c926$var$gsap.core.getCache(scroller), isViewport = $ae5f928ed8e7c926$var$_isViewport(scroller), useFixedPosition = "pinType" in vars ? vars.pinType === "fixed" : isViewport || $ae5f928ed8e7c926$var$_getProxyProp(scroller, "pinType") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $ae5f928ed8e7c926$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($ae5f928ed8e7c926$var$_getComputedStyle(scroller)["border" + direction.p2 + $ae5f928ed8e7c926$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $ae5f928ed8e7c926$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $ae5f928ed8e7c926$var$_getOffsetsFunc(scroller, isViewport), tweenTo, pinCache, snapFunc, isReverted, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevProgress, prevScroll, prevAnimProgress;
        self.media = $ae5f928ed8e7c926$var$_creatingMedia;
        anticipatePin *= 45;
        $ae5f928ed8e7c926$var$_triggers.push(self);
        self.scroller = scroller;
        self.scroll = $ae5f928ed8e7c926$var$_getScrollFunc(scroller, direction);
        scroll1 = self.scroll();
        self.vars = vars;
        animation = animation || vars.animation;
        "refreshPriority" in vars && ($ae5f928ed8e7c926$var$_sort = 1);
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $ae5f928ed8e7c926$var$_getTweenCreator(scroller, $ae5f928ed8e7c926$var$_vertical),
            left: $ae5f928ed8e7c926$var$_getTweenCreator(scroller, $ae5f928ed8e7c926$var$_horizontal)
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        if (animation) {
            animation.vars.lazy = false;
            animation._initted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.render(0, true, true);
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            scrubSmooth = $ae5f928ed8e7c926$var$_isNumber(scrub) && scrub;
            scrubSmooth && (scrubTween = $ae5f928ed8e7c926$var$gsap.to(animation, {
                ease: "power3",
                duration: scrubSmooth,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            }));
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            $ae5f928ed8e7c926$var$_isObject(snap) || (snap = {
                snapTo: snap
            });
            "scrollBehavior" in $ae5f928ed8e7c926$var$_body.style && $ae5f928ed8e7c926$var$gsap.set(isViewport ? [
                $ae5f928ed8e7c926$var$_body,
                $ae5f928ed8e7c926$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            snapFunc = $ae5f928ed8e7c926$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $ae5f928ed8e7c926$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $ae5f928ed8e7c926$var$_getLabelAtDirection(animation) : $ae5f928ed8e7c926$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $ae5f928ed8e7c926$var$_isObject(snapDurClamp) ? $ae5f928ed8e7c926$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $ae5f928ed8e7c926$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $ae5f928ed8e7c926$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                if (Math.abs(self.getVelocity()) < 10 && !$ae5f928ed8e7c926$var$_pointerIsDown) {
                    var totalProgress = animation && !isToggle ? animation.totalProgress() : self.progress, velocity = (totalProgress - snap2) / ($ae5f928ed8e7c926$var$_getTime() - $ae5f928ed8e7c926$var$_time2) * 1000 || 0, change1 = $ae5f928ed8e7c926$var$_abs(velocity / 2) * velocity / 0.185, naturalEnd = totalProgress + change1, endValue = $ae5f928ed8e7c926$var$_clamp(0, 1, snapFunc(naturalEnd, self)), scroll = self.scroll(), endScroll = Math.round(start + endValue * change), tween = tweenTo.tween;
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= Math.abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($ae5f928ed8e7c926$var$_abs(Math.max($ae5f928ed8e7c926$var$_abs(naturalEnd - totalProgress), $ae5f928ed8e7c926$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: Math.abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onComplete: function onComplete() {
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                    }
                } else if (self.isActive) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($ae5f928ed8e7c926$var$_ids[id] = self);
        trigger = self.trigger = $ae5f928ed8e7c926$var$_toArray(trigger || pin)[0];
        pin = pin === true ? trigger : $ae5f928ed8e7c926$var$_toArray(pin)[0];
        $ae5f928ed8e7c926$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $ae5f928ed8e7c926$var$_margin || (pinSpacing = !pinSpacing && $ae5f928ed8e7c926$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $ae5f928ed8e7c926$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default.
            self.pin = pin;
            vars.force3D !== false && $ae5f928ed8e7c926$var$gsap.set(pin, {
                force3D: true
            });
            pinCache = $ae5f928ed8e7c926$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                pinCache.spacer = spacer = $ae5f928ed8e7c926$var$_doc.createElement("div");
                spacer.setAttribute("class", "pin-spacer" + (id ? " pin-spacer-" + id : ""));
                pinCache.pinState = pinOriginalState = $ae5f928ed8e7c926$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            self.spacer = spacer = pinCache.spacer;
            cs = $ae5f928ed8e7c926$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $ae5f928ed8e7c926$var$gsap.getProperty(pin);
            pinSetter = $ae5f928ed8e7c926$var$gsap.quickSetter(pin, direction.a, $ae5f928ed8e7c926$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $ae5f928ed8e7c926$var$_swapPinIn(pin, spacer, cs);
            pinState = $ae5f928ed8e7c926$var$_getState(pin);
        }
        if (markers) {
            markerVars = $ae5f928ed8e7c926$var$_isObject(markers) ? $ae5f928ed8e7c926$var$_setDefaults(markers, $ae5f928ed8e7c926$var$_markerDefaults) : $ae5f928ed8e7c926$var$_markerDefaults;
            markerStartTrigger = $ae5f928ed8e7c926$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $ae5f928ed8e7c926$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            markerStart = $ae5f928ed8e7c926$var$_createMarker("start", id, scroller, direction, markerVars, offset);
            markerEnd = $ae5f928ed8e7c926$var$_createMarker("end", id, scroller, direction, markerVars, offset);
            if (!useFixedPosition) {
                $ae5f928ed8e7c926$var$_makePositionable(isViewport ? $ae5f928ed8e7c926$var$_body : scroller);
                $ae5f928ed8e7c926$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $ae5f928ed8e7c926$var$gsap.quickSetter(markerStartTrigger, direction.a, $ae5f928ed8e7c926$var$_px);
                markerEndSetter = $ae5f928ed8e7c926$var$gsap.quickSetter(markerEndTrigger, direction.a, $ae5f928ed8e7c926$var$_px);
            }
        }
        self.revert = function(revert) {
            var r = revert !== false || !self.enabled, prevRefreshing = $ae5f928ed8e7c926$var$_refreshing;
            if (r !== isReverted) {
                if (r) {
                    prevScroll = Math.max(self.scroll(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                r && ($ae5f928ed8e7c926$var$_refreshing = 1);
                self.update(r); // make sure the pin is back in its original position so that all the measurements are correct.
                $ae5f928ed8e7c926$var$_refreshing = prevRefreshing;
                pin && (r ? $ae5f928ed8e7c926$var$_swapPinOut(pin, spacer, pinOriginalState) : (!pinReparent || !self.isActive) && $ae5f928ed8e7c926$var$_swapPinIn(pin, spacer, $ae5f928ed8e7c926$var$_getComputedStyle(pin), spacerState));
                isReverted = r;
            }
        };
        self.refresh = function(soft) {
            if ($ae5f928ed8e7c926$var$_refreshing || !self.enabled) return;
            if (pin && soft && $ae5f928ed8e7c926$var$_lastScrollTime) {
                $ae5f928ed8e7c926$var$_addListener(ScrollTrigger, "scrollEnd", $ae5f928ed8e7c926$var$_softRefresh);
                return;
            }
            $ae5f928ed8e7c926$var$_refreshing = 1;
            scrubTween && scrubTween.pause();
            invalidateOnRefresh && animation && animation.progress(0).invalidate();
            isReverted || self.revert();
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = $ae5f928ed8e7c926$var$_maxScroll(scroller, direction), offset = 0, otherPinOffset = 0, parsedEnd = vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), triggerIndex = trigger && Math.max(0, $ae5f928ed8e7c926$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted;
            while(i--){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curPin = $ae5f928ed8e7c926$var$_triggers[i].pin;
                curPin && (curPin === trigger || curPin === pin) && $ae5f928ed8e7c926$var$_triggers[i].revert();
            }
            start = $ae5f928ed8e7c926$var$_parsePosition(parsedStart, trigger, size, direction, self.scroll(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max) || (pin ? -0.001 : 0);
            $ae5f928ed8e7c926$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($ae5f928ed8e7c926$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($ae5f928ed8e7c926$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $ae5f928ed8e7c926$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $ae5f928ed8e7c926$var$_isString(parsedStart) ? parsedStart : start + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            end = Math.max(start, $ae5f928ed8e7c926$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, self.scroll() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max)) || -0.001;
            change = end - start || (start -= 0.01) && 0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $ae5f928ed8e7c926$var$_triggers[i];
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush < start) {
                    cs = curTrigger.end - curTrigger.start;
                    curPin === trigger && (offset += cs);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                $ae5f928ed8e7c926$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin) {
                cs = $ae5f928ed8e7c926$var$_getComputedStyle(pin);
                isVertical = direction === $ae5f928ed8e7c926$var$_vertical;
                scroll = self.scroll(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                !max && end > 1 && ((isViewport ? $ae5f928ed8e7c926$var$_body : scroller).style["overflow-" + direction.a] = "scroll"); // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://greensock.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                $ae5f928ed8e7c926$var$_swapPinIn(pin, spacer, cs);
                pinState = $ae5f928ed8e7c926$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $ae5f928ed8e7c926$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && $ae5f928ed8e7c926$var$_getScrollFunc(scroller, isVertical ? $ae5f928ed8e7c926$var$_horizontal : $ae5f928ed8e7c926$var$_vertical)();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $ae5f928ed8e7c926$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $ae5f928ed8e7c926$var$_padding ? $ae5f928ed8e7c926$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    i && spacerState.push(direction.d, i + $ae5f928ed8e7c926$var$_px); // for box-sizing: border-box (must include padding).
                    $ae5f928ed8e7c926$var$_setState(spacerState);
                    useFixedPosition && self.scroll(prevScroll);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $ae5f928ed8e7c926$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $ae5f928ed8e7c926$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$ae5f928ed8e7c926$var$_width] = override["max" + $ae5f928ed8e7c926$var$_Width] = Math.ceil(bounds.width) + $ae5f928ed8e7c926$var$_px;
                    override[$ae5f928ed8e7c926$var$_height] = override["max" + $ae5f928ed8e7c926$var$_Height] = Math.ceil(bounds.height) + $ae5f928ed8e7c926$var$_px;
                    override[$ae5f928ed8e7c926$var$_margin] = override[$ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Top] = override[$ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Right] = override[$ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Bottom] = override[$ae5f928ed8e7c926$var$_margin + $ae5f928ed8e7c926$var$_Left] = "0";
                    override[$ae5f928ed8e7c926$var$_padding] = cs[$ae5f928ed8e7c926$var$_padding];
                    override[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Top] = cs[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Top];
                    override[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Right] = cs[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Right];
                    override[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Bottom] = cs[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Bottom];
                    override[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Left] = cs[$ae5f928ed8e7c926$var$_padding + $ae5f928ed8e7c926$var$_Left];
                    pinActiveState = $ae5f928ed8e7c926$var$_copyState(pinOriginalState, override, pinReparent);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $ae5f928ed8e7c926$var$_suppressOverwrites(1);
                    animation.progress(1, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    change !== pinChange && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.progress(0, true);
                    initted || animation.invalidate();
                    $ae5f928ed8e7c926$var$_suppressOverwrites(0);
                } else pinChange = change;
            } else if (trigger && self.scroll()) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $ae5f928ed8e7c926$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            for(i = 0; i < triggerIndex; i++){
                // make sure we revert from first to last to make sure things reach their end state properly
                curTrigger = $ae5f928ed8e7c926$var$_triggers[i].pin;
                curTrigger && (curTrigger === trigger || curTrigger === pin) && $ae5f928ed8e7c926$var$_triggers[i].revert(false);
            }
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = self.scroll(); // reset velocity
            scroll1 < prevScroll && self.scroll(prevScroll);
            self.revert(false);
            $ae5f928ed8e7c926$var$_refreshing = 0;
            animation && isToggle && animation._initted && animation.progress(prevAnimProgress, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (prevProgress !== self.progress) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                scrubTween && animation.totalProgress(prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = prevProgress;
                self.update();
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            onRefresh && onRefresh(self);
        };
        self.getVelocity = function() {
            return (self.scroll() - scroll2) / ($ae5f928ed8e7c926$var$_getTime() - $ae5f928ed8e7c926$var$_time2) * 1000 || 0;
        };
        self.update = function(reset, recordVelocity) {
            var scroll = self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            anticipatePin && !clipped && pin && !$ae5f928ed8e7c926$var$_refreshing && !$ae5f928ed8e7c926$var$_startup && $ae5f928ed8e7c926$var$_lastScrollTime && start < scroll + (scroll - scroll2) / ($ae5f928ed8e7c926$var$_getTime() - $ae5f928ed8e7c926$var$_time2) * anticipatePin && (clipped = 0.0001);
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (!isToggle) {
                    if (scrubTween && !$ae5f928ed8e7c926$var$_refreshing && !$ae5f928ed8e7c926$var$_startup) {
                        scrubTween.vars.totalProgress = clipped;
                        scrubTween.invalidate().restart();
                    } else if (animation) animation.totalProgress(clipped, !!$ae5f928ed8e7c926$var$_refreshing);
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter(pinStart + pinChange * clipped);
                    else if (stateChanged) {
                        action = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $ae5f928ed8e7c926$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || action)) {
                                var bounds = $ae5f928ed8e7c926$var$_getBounds(pin, true), _offset = scroll - start;
                                $ae5f928ed8e7c926$var$_reparent(pin, $ae5f928ed8e7c926$var$_body, bounds.top + (direction === $ae5f928ed8e7c926$var$_vertical ? _offset : 0) + $ae5f928ed8e7c926$var$_px, bounds.left + (direction === $ae5f928ed8e7c926$var$_vertical ? 0 : _offset) + $ae5f928ed8e7c926$var$_px);
                            } else $ae5f928ed8e7c926$var$_reparent(pin, spacer);
                        }
                        $ae5f928ed8e7c926$var$_setState(isActive || action ? pinActiveState : pinState);
                        pinChange !== change && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !action ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$ae5f928ed8e7c926$var$_refreshing && !$ae5f928ed8e7c926$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$ae5f928ed8e7c926$var$_limitCallbacks)) && $ae5f928ed8e7c926$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$ae5f928ed8e7c926$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        if (animation && (action === "complete" || action === "reset" || action in animation)) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$ae5f928ed8e7c926$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && onToggle(self);
                        callbacks[toggleState] && callbacks[toggleState](self);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && callbacks[toggleState](self);
                        }
                    }
                } else if (isToggle && onUpdate && !$ae5f928ed8e7c926$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                markerStartSetter(scroll + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(scroll);
            }
        };
        self.enable = function() {
            if (!self.enabled) {
                self.enabled = true;
                $ae5f928ed8e7c926$var$_addListener(scroller, "resize", $ae5f928ed8e7c926$var$_onResize);
                $ae5f928ed8e7c926$var$_addListener(scroller, "scroll", $ae5f928ed8e7c926$var$_onScroll);
                onRefreshInit && $ae5f928ed8e7c926$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                !animation || !animation.add ? self.refresh() : $ae5f928ed8e7c926$var$gsap.delayedCall(0.01, function() {
                    return start || end || self.refresh();
                }) && (change = 0.01) && (start = end = 0); // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick.
            }
        };
        self.disable = function(reset, allowAnimation) {
            if (self.enabled) {
                reset !== false && self.revert();
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $ae5f928ed8e7c926$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $ae5f928ed8e7c926$var$_triggers.length;
                    while(i--){
                        if ($ae5f928ed8e7c926$var$_triggers[i].scroller === scroller && $ae5f928ed8e7c926$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $ae5f928ed8e7c926$var$_removeListener(scroller, "resize", $ae5f928ed8e7c926$var$_onResize);
                    $ae5f928ed8e7c926$var$_removeListener(scroller, "scroll", $ae5f928ed8e7c926$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            id && delete $ae5f928ed8e7c926$var$_ids[id];
            var i = $ae5f928ed8e7c926$var$_triggers.indexOf(self);
            $ae5f928ed8e7c926$var$_triggers.splice(i, 1);
            i === $ae5f928ed8e7c926$var$_i && $ae5f928ed8e7c926$var$_direction > 0 && $ae5f928ed8e7c926$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.render(-1);
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode.removeChild(m);
            });
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $ae5f928ed8e7c926$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
        };
        self.enable();
    };
    ScrollTrigger.register = function register(core) {
        if (!$ae5f928ed8e7c926$var$_coreInitted) {
            $ae5f928ed8e7c926$var$gsap = core || $ae5f928ed8e7c926$var$_getGSAP();
            if ($ae5f928ed8e7c926$var$_windowExists() && window.document) {
                $ae5f928ed8e7c926$var$_win = window;
                $ae5f928ed8e7c926$var$_doc = document;
                $ae5f928ed8e7c926$var$_docEl = $ae5f928ed8e7c926$var$_doc.documentElement;
                $ae5f928ed8e7c926$var$_body = $ae5f928ed8e7c926$var$_doc.body;
            }
            if ($ae5f928ed8e7c926$var$gsap) {
                $ae5f928ed8e7c926$var$_toArray = $ae5f928ed8e7c926$var$gsap.utils.toArray;
                $ae5f928ed8e7c926$var$_clamp = $ae5f928ed8e7c926$var$gsap.utils.clamp;
                $ae5f928ed8e7c926$var$_suppressOverwrites = $ae5f928ed8e7c926$var$gsap.core.suppressOverwrites || $ae5f928ed8e7c926$var$_passThrough;
                $ae5f928ed8e7c926$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
                if ($ae5f928ed8e7c926$var$_body) {
                    $ae5f928ed8e7c926$var$_raf = $ae5f928ed8e7c926$var$_win.requestAnimationFrame || function(f) {
                        return setTimeout(f, 16);
                    };
                    $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$var$_win, "mousewheel", $ae5f928ed8e7c926$var$_onScroll);
                    $ae5f928ed8e7c926$var$_root = [
                        $ae5f928ed8e7c926$var$_win,
                        $ae5f928ed8e7c926$var$_doc,
                        $ae5f928ed8e7c926$var$_docEl,
                        $ae5f928ed8e7c926$var$_body
                    ];
                    $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$var$_doc, "scroll", $ae5f928ed8e7c926$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                    var bodyStyle = $ae5f928ed8e7c926$var$_body.style, border = bodyStyle.borderTop, bounds;
                    bodyStyle.borderTop = "1px solid #000"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                    bounds = $ae5f928ed8e7c926$var$_getBounds($ae5f928ed8e7c926$var$_body);
                    $ae5f928ed8e7c926$var$_vertical.m = Math.round(bounds.top + $ae5f928ed8e7c926$var$_vertical.sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                    $ae5f928ed8e7c926$var$_horizontal.m = Math.round(bounds.left + $ae5f928ed8e7c926$var$_horizontal.sc()) || 0;
                    border ? bodyStyle.borderTop = border : bodyStyle.removeProperty("border-top");
                    $ae5f928ed8e7c926$var$_syncInterval = setInterval($ae5f928ed8e7c926$var$_sync, 200);
                    $ae5f928ed8e7c926$var$gsap.delayedCall(0.5, function() {
                        return $ae5f928ed8e7c926$var$_startup = 0;
                    });
                    $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$var$_doc, "touchcancel", $ae5f928ed8e7c926$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                    $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$var$_body, "touchstart", $ae5f928ed8e7c926$var$_passThrough); //works around Safari bug: https://greensock.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                    $ae5f928ed8e7c926$var$_multiListener($ae5f928ed8e7c926$var$_addListener, $ae5f928ed8e7c926$var$_doc, "pointerdown,touchstart,mousedown", function() {
                        return $ae5f928ed8e7c926$var$_pointerIsDown = 1;
                    });
                    $ae5f928ed8e7c926$var$_multiListener($ae5f928ed8e7c926$var$_addListener, $ae5f928ed8e7c926$var$_doc, "pointerup,touchend,mouseup", function() {
                        return $ae5f928ed8e7c926$var$_pointerIsDown = 0;
                    });
                    $ae5f928ed8e7c926$var$_transformProp = $ae5f928ed8e7c926$var$gsap.utils.checkPrefix("transform");
                    $ae5f928ed8e7c926$var$_stateProps.push($ae5f928ed8e7c926$var$_transformProp);
                    $ae5f928ed8e7c926$var$_coreInitted = $ae5f928ed8e7c926$var$_getTime();
                    $ae5f928ed8e7c926$var$_resizeDelay = $ae5f928ed8e7c926$var$gsap.delayedCall(0.2, $ae5f928ed8e7c926$var$_refreshAll).pause();
                    $ae5f928ed8e7c926$var$_autoRefresh = [
                        $ae5f928ed8e7c926$var$_doc,
                        "visibilitychange",
                        function() {
                            var w = $ae5f928ed8e7c926$var$_win.innerWidth, h = $ae5f928ed8e7c926$var$_win.innerHeight;
                            if ($ae5f928ed8e7c926$var$_doc.hidden) {
                                $ae5f928ed8e7c926$var$_prevWidth = w;
                                $ae5f928ed8e7c926$var$_prevHeight = h;
                            } else if ($ae5f928ed8e7c926$var$_prevWidth !== w || $ae5f928ed8e7c926$var$_prevHeight !== h) $ae5f928ed8e7c926$var$_onResize();
                        },
                        $ae5f928ed8e7c926$var$_doc,
                        "DOMContentLoaded",
                        $ae5f928ed8e7c926$var$_refreshAll,
                        $ae5f928ed8e7c926$var$_win,
                        "load",
                        function() {
                            return $ae5f928ed8e7c926$var$_lastScrollTime || $ae5f928ed8e7c926$var$_refreshAll();
                        },
                        $ae5f928ed8e7c926$var$_win,
                        "resize",
                        $ae5f928ed8e7c926$var$_onResize
                    ];
                    $ae5f928ed8e7c926$var$_iterateAutoRefresh($ae5f928ed8e7c926$var$_addListener);
                }
            }
        }
        return $ae5f928ed8e7c926$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        for(var p in config)$ae5f928ed8e7c926$var$_defaults[p] = config[p];
    };
    ScrollTrigger.kill = function kill() {
        $ae5f928ed8e7c926$var$_enabled = 0;
        $ae5f928ed8e7c926$var$_triggers.slice(0).forEach(function(trigger) {
            return trigger.kill(1);
        });
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($ae5f928ed8e7c926$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($ae5f928ed8e7c926$var$_syncInterval) || ($ae5f928ed8e7c926$var$_syncInterval = ms) && setInterval($ae5f928ed8e7c926$var$_sync, ms);
        if ("autoRefreshEvents" in vars) {
            $ae5f928ed8e7c926$var$_iterateAutoRefresh($ae5f928ed8e7c926$var$_removeListener) || $ae5f928ed8e7c926$var$_iterateAutoRefresh($ae5f928ed8e7c926$var$_addListener, vars.autoRefreshEvents || "none");
            $ae5f928ed8e7c926$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = $ae5f928ed8e7c926$var$_toArray(target)[0], i = $ae5f928ed8e7c926$var$_scrollers.indexOf(t), isViewport = $ae5f928ed8e7c926$var$_isViewport(t);
        if (~i) $ae5f928ed8e7c926$var$_scrollers.splice(i, isViewport ? 6 : 2);
        isViewport ? $ae5f928ed8e7c926$var$_proxies.unshift($ae5f928ed8e7c926$var$_win, vars, $ae5f928ed8e7c926$var$_body, vars, $ae5f928ed8e7c926$var$_docEl, vars) : $ae5f928ed8e7c926$var$_proxies.unshift(t, vars);
    };
    ScrollTrigger.matchMedia = function matchMedia(vars) {
        // _media is populated in the following order: mediaQueryString, onMatch, onUnmatch, isMatched. So if there are two media queries, the Array would have a length of 8
        var mq, p, i, func, result;
        for(p in vars){
            i = $ae5f928ed8e7c926$var$_media.indexOf(p);
            func = vars[p];
            $ae5f928ed8e7c926$var$_creatingMedia = p;
            if (p === "all") func();
            else {
                mq = $ae5f928ed8e7c926$var$_win.matchMedia(p);
                if (mq) {
                    mq.matches && (result = func());
                    if (~i) {
                        $ae5f928ed8e7c926$var$_media[i + 1] = $ae5f928ed8e7c926$var$_combineFunc($ae5f928ed8e7c926$var$_media[i + 1], func);
                        $ae5f928ed8e7c926$var$_media[i + 2] = $ae5f928ed8e7c926$var$_combineFunc($ae5f928ed8e7c926$var$_media[i + 2], result);
                    } else {
                        i = $ae5f928ed8e7c926$var$_media.length;
                        $ae5f928ed8e7c926$var$_media.push(p, func, result);
                        mq.addListener ? mq.addListener($ae5f928ed8e7c926$var$_onMediaChange) : mq.addEventListener("change", $ae5f928ed8e7c926$var$_onMediaChange);
                    }
                    $ae5f928ed8e7c926$var$_media[i + 3] = mq.matches;
                }
            }
            $ae5f928ed8e7c926$var$_creatingMedia = 0;
        }
        return $ae5f928ed8e7c926$var$_media;
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        query || ($ae5f928ed8e7c926$var$_media.length = 0);
        query = $ae5f928ed8e7c926$var$_media.indexOf(query);
        query >= 0 && $ae5f928ed8e7c926$var$_media.splice(query, 4);
    };
    return ScrollTrigger;
}();
$ae5f928ed8e7c926$export$875bcbe48555930.version = "3.6.0";
$ae5f928ed8e7c926$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $ae5f928ed8e7c926$var$_toArray(targets).forEach(function(target) {
        if (target && target.style) {
            var i = $ae5f928ed8e7c926$var$_savedStyles.indexOf(target);
            i >= 0 && $ae5f928ed8e7c926$var$_savedStyles.splice(i, 4);
            $ae5f928ed8e7c926$var$_savedStyles.push(target, target.style.cssText, $ae5f928ed8e7c926$var$gsap.core.getCache(target), $ae5f928ed8e7c926$var$_creatingMedia);
        }
    }) : $ae5f928ed8e7c926$var$_savedStyles;
};
$ae5f928ed8e7c926$export$875bcbe48555930.revert = function(soft, media) {
    return $ae5f928ed8e7c926$var$_revertAll(!soft, media);
};
$ae5f928ed8e7c926$export$875bcbe48555930.create = function(vars, animation) {
    return new $ae5f928ed8e7c926$export$875bcbe48555930(vars, animation);
};
$ae5f928ed8e7c926$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $ae5f928ed8e7c926$var$_onResize() : $ae5f928ed8e7c926$var$_refreshAll(true);
};
$ae5f928ed8e7c926$export$875bcbe48555930.update = $ae5f928ed8e7c926$var$_updateAll;
$ae5f928ed8e7c926$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $ae5f928ed8e7c926$var$_maxScroll(element, horizontal ? $ae5f928ed8e7c926$var$_horizontal : $ae5f928ed8e7c926$var$_vertical);
};
$ae5f928ed8e7c926$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return $ae5f928ed8e7c926$var$_getScrollFunc($ae5f928ed8e7c926$var$_toArray(element)[0], horizontal ? $ae5f928ed8e7c926$var$_horizontal : $ae5f928ed8e7c926$var$_vertical);
};
$ae5f928ed8e7c926$export$875bcbe48555930.getById = function(id) {
    return $ae5f928ed8e7c926$var$_ids[id];
};
$ae5f928ed8e7c926$export$875bcbe48555930.getAll = function() {
    return $ae5f928ed8e7c926$var$_triggers.slice(0);
};
$ae5f928ed8e7c926$export$875bcbe48555930.isScrolling = function() {
    return !!$ae5f928ed8e7c926$var$_lastScrollTime;
};
$ae5f928ed8e7c926$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $ae5f928ed8e7c926$var$_listeners[type] || ($ae5f928ed8e7c926$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$ae5f928ed8e7c926$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $ae5f928ed8e7c926$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$ae5f928ed8e7c926$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $ae5f928ed8e7c926$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $ae5f928ed8e7c926$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($ae5f928ed8e7c926$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $ae5f928ed8e7c926$var$_addListener($ae5f928ed8e7c926$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $ae5f928ed8e7c926$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($ae5f928ed8e7c926$export$875bcbe48555930.create(config));
    });
    return result;
};
$ae5f928ed8e7c926$export$875bcbe48555930.sort = function(func) {
    return $ae5f928ed8e7c926$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1000000);
    });
};
$ae5f928ed8e7c926$var$_getGSAP() && $ae5f928ed8e7c926$var$gsap.registerPlugin($ae5f928ed8e7c926$export$875bcbe48555930);


(0, $76297dbd329cba4e$export$99ee26438460406a).registerPlugin((0, $ae5f928ed8e7c926$export$875bcbe48555930));
const $2a132dbab00960b5$export$494d9d9cf99dba30 = ()=>{
    const timeTicker = document.querySelector(".time_ticker");
    if (!timeTicker) return;
    let tl = (0, $76297dbd329cba4e$export$99ee26438460406a).timeline({
        // yes, we can add it to an entire timeline!
        scrollTrigger: {
            trigger: ".time_ticker",
            once: false,
            pin: false,
            start: "top bottom",
            end: "bottom top",
            scrub: true
        }
    });
    // add animations and labels to the timeline
    tl.addLabel("start").to(".ticker_row:nth-child(2)", {
        scale: 1
    }).to(".ticker_rowing", {
        y: "-20%"
    }).to(".ticker_row:nth-child(3)", {
        scale: 1
    }, "-=0.5").to(".ticker_row:nth-child(2)", {
        scale: .9
    }, "-=0.5").to(".ticker_rowing", {
        y: "-40%"
    }).to(".ticker_row:nth-child(4)", {
        scale: 1
    }, "-=0.5").to(".ticker_row:nth-child(3)", {
        scale: .9
    }, "-=0.5").to(".ticker_rowing", {
        y: "-60%"
    }).to(".ticker_row:nth-child(5)", {
        scale: 1
    }, "-=0.5").to(".ticker_row:nth-child(4)", {
        scale: .9
    }, "-=0.5");
};




(0, $76297dbd329cba4e$export$99ee26438460406a).registerPlugin((0, $ae5f928ed8e7c926$export$875bcbe48555930));
const $af0f0d3af632475b$export$65437bbb2ae5bab6 = ()=>{
    const introTitle = document.querySelector(".intro-title");
    if (!introTitle) return;
    let tl = (0, $76297dbd329cba4e$export$99ee26438460406a).timeline({
        // yes, we can add it to an entire timeline!
        scrollTrigger: {
            trigger: ".intro-title",
            once: true,
            pin: false,
            start: "top 60%",
            scrub: false
        }
    });
    // add animations and labels to the timeline
    tl.fromTo(".intro-title .intro-title_word, .intro-title .intro-title_img, .intro_titels_parent .text-size-large, .intro_titels_parent .home-intro_cta-cont", {
        autoAlpha: 0,
        scale: .4,
        y: 50
    }, {
        duration: 0.6,
        ease: "expo.inOut",
        autoAlpha: 1,
        scale: 1,
        y: 0,
        stagger: 0.1
    });
};


const $9f3c9fe090dd4883$export$989f1d24fc740f18 = ()=>{
    const intersectionElements = document.querySelectorAll(".service-slider_panel");
    if (!intersectionElements) return;
    // Scroll ani
    const configIntersection = {
        root: null,
        rootMargin: "0px",
        threshold: [
            0.1,
            0.5,
            0.7,
            1
        ]
    };
    const sliderWrapper = document.querySelector(".service-slider_wrapper");
    const checkPointContainer = document.querySelector(".checkpoint-cointainer");
    const sliderServiceNavWrapper = document.querySelector(".service-slider-nav");
    const sliderServiceNav = document.querySelector(".service-slider-nav_inner");
    const checkPoints = Array();
    const sliderServiceNavItems = Array();
    if (sliderServiceNavWrapper) sliderServiceNavWrapper.classList.add("items-count-" + intersectionElements.length);
    intersectionElements.forEach((el, index)=>{
        const newCheckpoint = document.createElement("div");
        newCheckpoint.classList.add("checkpoint");
        newCheckpoint.setAttribute("id", `service-${index}`);
        if (!checkPointContainer) {
            console.error("Checkpoint container not found");
            return;
        }
        checkPointContainer.appendChild(newCheckpoint);
        checkPoints.push(newCheckpoint);
        if (sliderServiceNav) {
            const elTitle = el.querySelector(".service-slider_big-title").innerHTML;
            const newNavItem = document.createElement("a");
            newNavItem.classList.add("slider-nav_item");
            newNavItem.setAttribute("href", `#service-${index}`);
            newNavItem.classList.add(`slider-nav_item--${index}`);
            const labelContainer = document.createElement("div");
            labelContainer.classList.add("slider-nav_label");
            labelContainer.innerHTML = elTitle;
            newNavItem.appendChild(labelContainer);
            sliderServiceNav.appendChild(newNavItem);
            sliderServiceNavItems.push(newNavItem);
            const thumbDefault = intersectionElements[index].querySelector(".nav-img--default");
            const thumbCurrent = intersectionElements[index].querySelector(".nav-img--current");
            const lottieContainer = document.createElement("div");
            lottieContainer.classList.add("slider-nav_img");
            lottieContainer.appendChild(thumbDefault);
            lottieContainer.appendChild(thumbCurrent);
            sliderServiceNavItems[index].appendChild(lottieContainer);
        }
    });
    let lastIndex = 0;
    let currentIndex = 0;
    let observer = new IntersectionObserver(function(entries) {
        entries.forEach((entry)=>{
            let element = entry.target;
            if (entry.isIntersecting === true) {
                checkPoints.forEach((el, index)=>{
                    if (el === element) currentIndex = index;
                });
                intersectionElements.forEach((el)=>{
                    el.classList.remove("is-current");
                });
                intersectionElements[currentIndex].classList.add("is-current");
                sliderWrapper.setAttribute("data-current-slide", currentIndex);
                if (sliderServiceNav) {
                    // Si va in su o in giù?
                    if (currentIndex > lastIndex) sliderServiceNavWrapper.classList.add("slide-down");
                    else sliderServiceNavWrapper.classList.add("slide-up");
                    setTimeout(()=>{
                        sliderServiceNavWrapper.classList.remove("slide-down");
                        sliderServiceNavWrapper.classList.remove("slide-up");
                    }, 600);
                    lastIndex = currentIndex;
                    sliderServiceNavItems.forEach((el)=>{
                        el.classList.remove("is-current");
                        el.classList.remove("already-pass");
                    });
                    sliderServiceNav.setAttribute("data-current", currentIndex);
                    sliderServiceNavItems[currentIndex].classList.add("is-current");
                    const sliderServiceItemLenght = sliderServiceNavItems.length;
                    const halfLenght = Math.floor(sliderServiceItemLenght / 2);
                    const addAndRemoveAttr = (isLast, itemIndex, dataIm)=>{
                        if (isLast && dataIm != 0) {
                            sliderServiceNavItems[itemIndex].classList.add("is-last");
                            setTimeout(()=>{
                                sliderServiceNavItems[itemIndex].setAttribute("data-im", dataIm);
                                setTimeout(()=>{
                                    sliderServiceNavItems[itemIndex].classList.remove("is-last");
                                }, 500);
                            }, 500);
                        } else sliderServiceNavItems[itemIndex].setAttribute("data-im", dataIm);
                    };
                    for(let m = 0; m >= 0 - halfLenght; m--){
                        let navItemIndex = currentIndex + m;
                        if (!sliderServiceNavItems[navItemIndex]) navItemIndex = sliderServiceItemLenght + (currentIndex + m);
                        if (sliderServiceNavItems[navItemIndex].classList.contains("already-pass")) continue;
                        let elemPrevIm = parseInt(sliderServiceNavItems[navItemIndex].getAttribute("data-im"));
                        let isLast = elemPrevIm > 0;
                        sliderServiceNavItems[navItemIndex].classList.add("already-pass");
                        addAndRemoveAttr(isLast, navItemIndex, m);
                    }
                    for(let i = 0; i <= halfLenght; i++){
                        let navItemIndex = currentIndex + i < sliderServiceItemLenght ? currentIndex + i : currentIndex + i - sliderServiceItemLenght;
                        if (sliderServiceNavItems[navItemIndex].classList.contains("already-pass")) continue;
                        let elemPrevIm = parseInt(sliderServiceNavItems[navItemIndex].getAttribute("data-im"));
                        let isLast = elemPrevIm === 0 - halfLenght;
                        sliderServiceNavItems[navItemIndex].classList.add("already-pass");
                        addAndRemoveAttr(isLast, navItemIndex, i);
                    }
                }
            }
        });
    }, configIntersection);
    checkPoints.forEach((intersectionElement)=>{
        observer.observe(intersectionElement);
    });
};



var $d1527b41ba5e5844$var$menuTl = (0, $f3bc927f09a8d458$export$99ee26438460406a).timeline({
    paused: true
});
$d1527b41ba5e5844$var$menuTl.fromTo(".nav_bg", {
    scale: 0
}, {
    duration: 1,
    scale: 1,
    ease: "power3.inOut"
}).fromTo(".nav_logos.pink", {
    autoAlpha: 0
}, {
    duration: 0.4,
    ease: "expo.out",
    autoAlpha: 1
}, 0.1).fromTo(".nav_menu_trigger", {
    color: "#FFF"
}, {
    duration: 0.2,
    ease: "expo.out",
    color: "#000000"
}, 0.1).fromTo(".nav_menu_line", {
    backgroundColor: "#FFF"
}, {
    duration: 0.2,
    ease: "expo.out",
    backgroundColor: "#000000"
}, 0.1).fromTo(".nav_ctas .nav_button", {
    autoAlpha: 1
}, {
    duration: 0.4,
    ease: "expo.out",
    autoAlpha: 0
}, 0.1).fromTo(".menu_big .menu_title", {
    autoAlpha: 0,
    scale: 0.4
}, {
    duration: 0.5,
    ease: "expo.out",
    autoAlpha: 1,
    scale: 1,
    stagger: 0.1
}, 0.4).fromTo(".menu_small .menu_title, .menu_small .menu_small_point", {
    autoAlpha: 0,
    scale: 0.4
}, {
    duration: 0.5,
    ease: "expo.out",
    autoAlpha: 1,
    scale: 1,
    stagger: 0.1
}, "-=0.2").fromTo(".header_social_links .social-item", {
    autoAlpha: 0,
    scale: 0.3
}, {
    duration: 0.4,
    ease: "expo.out",
    autoAlpha: 1,
    scale: 1,
    stagger: 0.1
}, "-=0.6");
const $d1527b41ba5e5844$var$menuTrigger = document.querySelector(".nav_menu_trigger");
const $d1527b41ba5e5844$var$body = document.querySelector("body");
let $d1527b41ba5e5844$var$menuIsOpen = false;
$d1527b41ba5e5844$var$menuTrigger.addEventListener("click", function() {
    $d1527b41ba5e5844$var$menuTl.play();
    if ($d1527b41ba5e5844$var$menuIsOpen === true) $d1527b41ba5e5844$var$menuTl.reverse();
    $d1527b41ba5e5844$var$menuIsOpen = !$d1527b41ba5e5844$var$menuIsOpen;
    $d1527b41ba5e5844$var$body.classList.toggle("menuIsOpen");
});


const $5fbffa87c50562b9$var$isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if ($5fbffa87c50562b9$var$isSafari !== true) (0, $03da642c15b09e5e$export$127d9b655e7cc8a7)();
(0, $4d49ec876afb21b0$export$107f34e1a961432f)();
(0, $2a132dbab00960b5$export$494d9d9cf99dba30)();
(0, $af0f0d3af632475b$export$65437bbb2ae5bab6)();
(0, $9f3c9fe090dd4883$export$989f1d24fc740f18)();
let $5fbffa87c50562b9$var$spreadLettersAni = document.querySelectorAll('[data-animation="spread-letters"]');
$5fbffa87c50562b9$var$spreadLettersAni.forEach((item)=>{
    item.innerHTML = item.textContent.replace(/\S/g, "<span class='letter' style='display: inline-block'>$&</span>");
    let letters = item.querySelectorAll(".letter");
    item.addEventListener("mouseenter", function() {
        (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039)({
            targets: letters,
            rotate: function() {
                return (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039).random(-10, 10);
            },
            translateY: function() {
                return (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039).random(0, -20);
            },
            delay: function() {
                return (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039).random(0, 100);
            },
            direction: "alternate",
            easing: "spring(1, 100, 10, 10)",
            loop: false
        });
    });
    item.addEventListener("mouseleave", function() {
        (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039)({
            targets: letters,
            rotate: 0,
            translateY: 0,
            delay: function() {
                return (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039).random(0, 100);
            },
            direction: "alternate",
            easing: "spring(1, 80, 10, 10)",
            loop: false
        });
    });
});
// Button border animation
let $5fbffa87c50562b9$var$buttonBorderAni = document.querySelectorAll("[data-animation-border]");
$5fbffa87c50562b9$var$buttonBorderAni.forEach((item)=>{
    let path = item.querySelectorAll(".button-border");
    item.addEventListener("mouseenter", function() {
        (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039)({
            targets: path,
            strokeDashoffset: [
                (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039).setDashoffset,
                0
            ],
            duration: 400,
            easing: "easeInOutSine",
            loop: false
        });
    });
    item.addEventListener("mouseleave", function() {
        (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039)({
            targets: path,
            strokeDashoffset: [
                0,
                (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039).setDashoffset
            ],
            duration: 300,
            easing: "easeInOutSine",
            loop: false
        });
    });
});
if ($5fbffa87c50562b9$var$isSafari !== true) {
    const morphingBubble = (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039)({
        targets: ".service-slider_bubble path",
        d: [
            {
                value: "M218.946 1.74839C342.344 1.74839 495.5 -25.0002 495.5 224.5C495.5 474 335.5 509.88 230.079 509.88C124.658 509.88 0.600952 402.953 0.600952 248.96C0.600952 109.133 78.2982 1.74839 218.946 1.74839Z"
            },
            {
                value: "M278.946 0.748535C402.344 0.748535 497.146 105.281 497.146 227.96C497.146 366.568 418.366 508.88 278.946 508.88C124.05 508.88 0.600952 381.953 0.600952 227.96C0.600952 88.1328 138.298 0.748535 278.946 0.748535Z"
            },
            {
                value: "M257.102 0.748535C401 0.748535 495.5 96.5 495.5 263.5C495.5 430.5 444.159 508.88 230.079 508.88C16 508.88 0.601074 342.92 0.601074 247.96C0.601074 153 48.0001 0.748535 257.102 0.748535Z"
            }
        ],
        easing: "easeInOutSine",
        duration: 6000,
        direction: "alternate",
        loop: true
    });
    const morphingWaveWhite = (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039)({
        targets: ".section-wave path",
        d: [
            {
                value: "M1311 10.8686C1139 115 981 81.6313 735 15.0001C465.892 -57.8902 326.5 179.5 0 42.3325V100.499H1311V10.8686Z"
            }
        ],
        easing: "easeInOutSine",
        duration: 5000,
        direction: "alternate",
        loop: true
    });
    const morphingTeamBg = (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039)({
        targets: ".team-slider-bg path",
        d: [
            {
                value: "M1152.62 32.7114C1130.28 13.4613 1072.95 27.8056 1042.77 28.4754C959.45 25.9246 777.401 0 605.299 0C453.579 0 310.334 22.9928 211.792 24.8376C159.072 24.7526 80.3739 7.89217 54.7932 17.0268C10.9863 43.1402 14.2173 82.9468 17.7164 126.058C20.0291 154.551 18.4589 184.486 7.50415 212.867C-8.46594 286.778 5.95264 346.349 8.03394 384.983C9.96362 420.802 10.0339 507.164 22.9626 541.014C24.1301 543.539 25.2098 545.976 26.2533 548.332C34.6582 567.305 40.709 580.964 71.293 592.028C98.8411 601.994 137.685 607.904 173.608 607.456C272.535 613.05 454.384 602 605.299 602C772.808 602 1011.62 607.155 1115.38 600.12C1129.66 600.382 1143.42 598.595 1156.54 593.842C1222.41 569.968 1194.92 476.884 1178.8 391.072C1172.35 356.738 1186.12 323.567 1185.54 296.46C1184.92 267.743 1169.33 237.803 1173.69 208.279C1183.58 141.192 1203.15 76.2553 1152.62 32.7114Z"
            }
        ],
        easing: "easeInOutSine",
        duration: 3000,
        direction: "alternate",
        loop: true
    });
    const morphingMemberMask = (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039)({
        targets: ".member-mask path",
        d: [
            {
                value: "M545 0H0V545H545V0ZM22.5 258C22.5 52 278.5 -75.4999 428.5 74.4998C576.584 222.584 601 438.5 288.001 528.5C168.731 562.795 22.5 437 22.5 258Z"
            }
        ],
        easing: "easeInOutSine",
        duration: 4000,
        direction: "alternate",
        loop: true
    });
    const morphingTimeBg = (0, $d5074f6a41fc61ab$export$2e2bcd8739ae039)({
        targets: ".home-time-bg path",
        d: [
            {
                value: "M1085.4 4.89398C896 -16 691 39.0001 594 40.5001C497 42.0001 317.604 25.606 158.5 5.5C75.7599 -4.95585 15 15.001 9.39571 75.501C4.26272 130.913 -8.67832 217.145 9.39571 301.501C27.5007 386.001 29.2956 489.445 19.5008 535.001C9.39571 582 34.5 617.3 103.896 600.394C222.5 571.5 310.396 619.894 571.896 619.894C833.396 619.894 985.5 595.754 1051.9 605.394C1121.5 615.5 1188.64 618 1201.5 563C1219.5 486 1172.5 485.604 1172.5 365.5C1172.5 291.5 1205.5 252.5 1205.5 161.5C1205.5 104.968 1203.5 75.5 1183 43.5C1160.39 8.21241 1128.05 9.59989 1085.4 4.89398Z"
            }
        ],
        easing: "easeInOutSine",
        duration: 5000,
        direction: "alternate",
        loop: true
    });
}

})();
//# sourceMappingURL=main.js.map
